/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VideosRouteImport } from './routes/videos'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SolutionsRouteImport } from './routes/solutions'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as ProofOfConceptRouteImport } from './routes/proof-of-concept'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndustriesRouteImport } from './routes/industries'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConnectorsRouteImport } from './routes/connectors'
import { Route as BrandRouteImport } from './routes/brand'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as ConnectorsIndexRouteImport } from './routes/connectors.index'
import { Route as ProductsMyappRouteImport } from './routes/products/myapp'
import { Route as ProductsKnowledgeBaseRouteImport } from './routes/products/knowledge-base'
import { Route as PreviewMyappTableTypesRouteImport } from './routes/preview/myapp-table-types'
import { Route as PreviewKbHeroesRouteImport } from './routes/preview/kb-heroes'
import { Route as PreviewHomeHeroRouteImport } from './routes/preview/home-hero'
import { Route as PreviewGroundUpFlowRouteImport } from './routes/preview/ground-up-flow'
import { Route as PreviewConnectorFlowsRouteImport } from './routes/preview/connector-flows'
import { Route as PortalSignUpRouteImport } from './routes/portal_.sign-up'
import { Route as PortalSignInRouteImport } from './routes/portal_.sign-in'
import { Route as PortalResetPasswordRouteImport } from './routes/portal_.reset-password'
import { Route as PortalHelpRouteImport } from './routes/portal_.help'
import { Route as PortalForgotPasswordRouteImport } from './routes/portal_.forgot-password'
import { Route as PortalWorkflowsRouteImport } from './routes/portal/workflows'
import { Route as PortalPlatformRouteImport } from './routes/portal/platform'
import { Route as PortalMyappRouteImport } from './routes/portal/myapp'
import { Route as PortalMessagingRouteImport } from './routes/portal/messaging'
import { Route as PortalLmsRouteImport } from './routes/portal/lms'
import { Route as PortalLearningRouteImport } from './routes/portal/learning'
import { Route as PortalKnowledgebaseSqlRouteImport } from './routes/portal/knowledgebase-sql'
import { Route as PortalKnowledgebaseFileRouteImport } from './routes/portal/knowledgebase-file'
import { Route as PortalHrRouteImport } from './routes/portal/hr'
import { Route as PortalFtpRouteImport } from './routes/portal/ftp'
import { Route as PortalCatalogueIntelligenceRouteImport } from './routes/portal/catalogue-intelligence'
import { Route as PortalAutomationRouteImport } from './routes/portal/automation'
import { Route as PortalAssetLibraryRouteImport } from './routes/portal/asset-library'
import { Route as PortalAiContentRouteImport } from './routes/portal/ai-content'
import { Route as OnboardTokenRouteImport } from './routes/onboard.$token'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as LegalTermsOfUseRouteImport } from './routes/legal/terms-of-use'
import { Route as LegalRefundPolicyRouteImport } from './routes/legal/refund-policy'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LegalPaiaRouteImport } from './routes/legal/paia'
import { Route as LegalDataProcessingRouteImport } from './routes/legal/data-processing'
import { Route as ConnectorsXeroCaseStudyRouteImport } from './routes/connectors.xero-case-study'
import { Route as ConnectorsProductRouteImport } from './routes/connectors.product'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as ArchivePricingRouteImport } from './routes/archive/pricing'
import { Route as ArchiveHomeRouteImport } from './routes/archive/home'
import { Route as PortalWorkflowsIndexRouteImport } from './routes/portal/workflows/index'
import { Route as PortalSpacesIndexRouteImport } from './routes/portal/spaces/index'
import { Route as PortalMyappIndexRouteImport } from './routes/portal/myapp/index'
import { Route as PortalMessagingIndexRouteImport } from './routes/portal/messaging/index'
import { Route as PortalLmsIndexRouteImport } from './routes/portal/lms/index'
import { Route as PortalLearningIndexRouteImport } from './routes/portal/learning/index'
import { Route as PortalKnowledgebaseSqlIndexRouteImport } from './routes/portal/knowledgebase-sql/index'
import { Route as PortalKnowledgebaseFileIndexRouteImport } from './routes/portal/knowledgebase-file/index'
import { Route as PortalHrIndexRouteImport } from './routes/portal/hr/index'
import { Route as PortalFtpIndexRouteImport } from './routes/portal/ftp/index'
import { Route as PortalConnectorsIndexRouteImport } from './routes/portal/connectors/index'
import { Route as PortalAutomationIndexRouteImport } from './routes/portal/automation/index'
import { Route as PortalAppsIndexRouteImport } from './routes/portal/apps/index'
import { Route as PortalAiContentIndexRouteImport } from './routes/portal/ai-content/index'
import { Route as ProductsMyappExcelAddinSetupRouteImport } from './routes/products/myapp_.excel-addin-setup'
import { Route as PortalSignInVerifyRouteImport } from './routes/portal_.sign-in_.verify'
import { Route as PortalInviteAcceptRouteImport } from './routes/portal_.invite.accept'
import { Route as PortalAuthVerifyEmailRouteImport } from './routes/portal_.auth.verify-email'
import { Route as PortalAuthUnlockAccountRouteImport } from './routes/portal_.auth.unlock-account'
import { Route as PortalWorkflowsTopologyRouteImport } from './routes/portal/workflows/topology'
import { Route as PortalWorkflowsTemplatesRouteImport } from './routes/portal/workflows/templates'
import { Route as PortalWorkflowsRetryFailuresRouteImport } from './routes/portal/workflows/retry-failures'
import { Route as PortalWorkflowsProjectsRouteImport } from './routes/portal/workflows/projects'
import { Route as PortalWorkflowsExecutionsRouteImport } from './routes/portal/workflows/executions'
import { Route as PortalWorkflowsExecuteRouteImport } from './routes/portal/workflows/execute'
import { Route as PortalWorkflowsDlqRouteImport } from './routes/portal/workflows/dlq'
import { Route as PortalWorkflowsDefinitionsRouteImport } from './routes/portal/workflows/definitions'
import { Route as PortalWorkflowsCanvasDemoRouteImport } from './routes/portal/workflows/canvas-demo'
import { Route as PortalSpacesNewRouteImport } from './routes/portal/spaces/new'
import { Route as PortalSpacesSpaceIdRouteImport } from './routes/portal/spaces/$spaceId'
import { Route as PortalPlatformUsersRouteImport } from './routes/portal/platform/users'
import { Route as PortalPlatformTiersRouteImport } from './routes/portal/platform/tiers'
import { Route as PortalPlatformThemeRouteImport } from './routes/portal/platform/theme'
import { Route as PortalPlatformSubscriptionsRouteImport } from './routes/portal/platform/subscriptions'
import { Route as PortalPlatformSettingsRouteImport } from './routes/portal/platform/settings'
import { Route as PortalPlatformSecurityRouteImport } from './routes/portal/platform/security'
import { Route as PortalPlatformSecretsRouteImport } from './routes/portal/platform/secrets'
import { Route as PortalPlatformSdlcRouteImport } from './routes/portal/platform/sdlc'
import { Route as PortalPlatformSchemaDriftRouteImport } from './routes/portal/platform/schema-drift'
import { Route as PortalPlatformRbacRouteImport } from './routes/portal/platform/rbac'
import { Route as PortalPlatformProfileRouteImport } from './routes/portal/platform/profile'
import { Route as PortalPlatformProductsRouteImport } from './routes/portal/platform/products'
import { Route as PortalPlatformPricingRouteImport } from './routes/portal/platform/pricing'
import { Route as PortalPlatformPipelinesRouteImport } from './routes/portal/platform/pipelines'
import { Route as PortalPlatformOrphanedSchedulesRouteImport } from './routes/portal/platform/orphaned-schedules'
import { Route as PortalPlatformOrganisationsRouteImport } from './routes/portal/platform/organisations'
import { Route as PortalPlatformObjectPermissionsRouteImport } from './routes/portal/platform/object-permissions'
import { Route as PortalPlatformMonitoringRouteImport } from './routes/portal/platform/monitoring'
import { Route as PortalPlatformMaintenanceRouteImport } from './routes/portal/platform/maintenance'
import { Route as PortalPlatformInfrastructureRouteImport } from './routes/portal/platform/infrastructure'
import { Route as PortalPlatformInboundDeadLettersRouteImport } from './routes/portal/platform/inbound-dead-letters'
import { Route as PortalPlatformGroupsRouteImport } from './routes/portal/platform/groups'
import { Route as PortalPlatformDiscountsRouteImport } from './routes/portal/platform/discounts'
import { Route as PortalPlatformConnectorsRouteImport } from './routes/portal/platform/connectors'
import { Route as PortalPlatformConnectorEnrichmentRouteImport } from './routes/portal/platform/connector-enrichment'
import { Route as PortalPlatformClientOnboardingRouteImport } from './routes/portal/platform/client-onboarding'
import { Route as PortalPlatformChartSettingsRouteImport } from './routes/portal/platform/chart-settings'
import { Route as PortalPlatformCategoriesRouteImport } from './routes/portal/platform/categories'
import { Route as PortalPlatformBillingOverviewRouteImport } from './routes/portal/platform/billing-overview'
import { Route as PortalPlatformBillingRouteImport } from './routes/portal/platform/billing'
import { Route as PortalPlatformApiKeysRouteImport } from './routes/portal/platform/api-keys'
import { Route as PortalOrganisationThemeRouteImport } from './routes/portal/organisation/theme'
import { Route as PortalOrganisationSettingsRouteImport } from './routes/portal/organisation/settings'
import { Route as PortalOrganisationMembersRouteImport } from './routes/portal/organisation/members'
import { Route as PortalOrganisationCategoriesRouteImport } from './routes/portal/organisation/categories'
import { Route as PortalMyappTablesRouteImport } from './routes/portal/myapp/tables'
import { Route as PortalMyappBridgeRouteImport } from './routes/portal/myapp/bridge'
import { Route as PortalMyappAreasRouteImport } from './routes/portal/myapp/areas'
import { Route as PortalMyappAppsRouteImport } from './routes/portal/myapp/apps'
import { Route as PortalMessagingWhatsappSetupRouteImport } from './routes/portal/messaging/whatsapp-setup'
import { Route as PortalMessagingTemplatesRouteImport } from './routes/portal/messaging/templates'
import { Route as PortalMessagingInboxRouteImport } from './routes/portal/messaging/inbox'
import { Route as PortalLmsLeaderboardRouteImport } from './routes/portal/lms/leaderboard'
import { Route as PortalLmsCyclesRouteImport } from './routes/portal/lms/cycles'
import { Route as PortalLmsCurationRouteImport } from './routes/portal/lms/curation'
import { Route as PortalLmsAuthorRouteImport } from './routes/portal/lms/author'
import { Route as PortalLmsAssignRouteImport } from './routes/portal/lms/assign'
import { Route as PortalKnowledgebaseSqlQuickQuestionRouteImport } from './routes/portal/knowledgebase-sql/quick-question'
import { Route as PortalKnowledgebaseSqlQueryRouteImport } from './routes/portal/knowledgebase-sql/query'
import { Route as PortalKnowledgebaseSqlGlossaryRouteImport } from './routes/portal/knowledgebase-sql/glossary'
import { Route as PortalKnowledgebaseSqlDataSourcesRouteImport } from './routes/portal/knowledgebase-sql/data-sources'
import { Route as PortalKnowledgebaseSqlConnectRouteImport } from './routes/portal/knowledgebase-sql/connect'
import { Route as PortalKnowledgebaseFileUploadRouteImport } from './routes/portal/knowledgebase-file/upload'
import { Route as PortalKnowledgebaseFileTemplatesRouteImport } from './routes/portal/knowledgebase-file/templates'
import { Route as PortalKnowledgebaseFileQueryRouteImport } from './routes/portal/knowledgebase-file/query'
import { Route as PortalKnowledgebaseFileLabelsRouteImport } from './routes/portal/knowledgebase-file/labels'
import { Route as PortalKnowledgebaseFileDocumentsRouteImport } from './routes/portal/knowledgebase-file/documents'
import { Route as PortalKnowledgebaseFileCategoryReviewRouteImport } from './routes/portal/knowledgebase-file/category-review'
import { Route as PortalKnowledgebaseFileCategoriesRouteImport } from './routes/portal/knowledgebase-file/categories'
import { Route as PortalKnowledgebaseFileBatchesRouteImport } from './routes/portal/knowledgebase-file/batches'
import { Route as PortalFtpUsersRouteImport } from './routes/portal/ftp/users'
import { Route as PortalFtpFilesRouteImport } from './routes/portal/ftp/files'
import { Route as PortalFtpConnectionsRouteImport } from './routes/portal/ftp/connections'
import { Route as PortalFtpAuditRouteImport } from './routes/portal/ftp/audit'
import { Route as PortalAutomationWorkflowsRouteImport } from './routes/portal/automation/workflows'
import { Route as PortalAutomationWebhooksRouteImport } from './routes/portal/automation/webhooks'
import { Route as PortalAutomationSkillsRouteImport } from './routes/portal/automation/skills'
import { Route as PortalAutomationPoliciesRouteImport } from './routes/portal/automation/policies'
import { Route as PortalAutomationMonitoringRouteImport } from './routes/portal/automation/monitoring'
import { Route as PortalAutomationMcpRouteImport } from './routes/portal/automation/mcp'
import { Route as PortalAutomationLlmRouteImport } from './routes/portal/automation/llm'
import { Route as PortalAutomationDashboardRouteImport } from './routes/portal/automation/dashboard'
import { Route as PortalAutomationCredentialsRouteImport } from './routes/portal/automation/credentials'
import { Route as PortalAutomationContentReviewRouteImport } from './routes/portal/automation/content-review'
import { Route as PortalAutomationAuditRouteImport } from './routes/portal/automation/audit'
import { Route as PortalAutomationAgentEntitlementsRouteImport } from './routes/portal/automation/agent-entitlements'
import { Route as PortalAppsExpenseRouteImport } from './routes/portal/apps/expense'
import { Route as PortalAiContentHistoryRouteImport } from './routes/portal/ai-content/history'
import { Route as FormsSlugRespondRouteImport } from './routes/forms/$slug/respond'
import { Route as PortalSpacesSpaceIdIndexRouteImport } from './routes/portal/spaces/$spaceId.index'
import { Route as PortalMyappTableIdIndexRouteImport } from './routes/portal/myapp/$tableId/index'
import { Route as PortalLearningReviewIndexRouteImport } from './routes/portal/learning/review/index'
import { Route as PortalKnowledgebaseSqlInsightReportsIndexRouteImport } from './routes/portal/knowledgebase-sql/insight-reports/index'
import { Route as PortalHrSettingsIndexRouteImport } from './routes/portal/hr/settings/index'
import { Route as PortalHrRulesIndexRouteImport } from './routes/portal/hr/rules/index'
import { Route as PortalHrOnboardingIndexRouteImport } from './routes/portal/hr/onboarding/index'
import { Route as PortalHrForecastIndexRouteImport } from './routes/portal/hr/forecast/index'
import { Route as PortalHrEmployeesIndexRouteImport } from './routes/portal/hr/employees/index'
import { Route as PortalHrAllocationsIndexRouteImport } from './routes/portal/hr/allocations/index'
import { Route as PortalConnectorsTypeSlugIndexRouteImport } from './routes/portal/connectors/$typeSlug/index'
import { Route as PortalAppsReportingIndexRouteImport } from './routes/portal/apps/reporting/index'
import { Route as PortalAppsAppSlugIndexRouteImport } from './routes/portal/apps/$appSlug/index'
import { Route as FormsSlugRespondIndexRouteImport } from './routes/forms/$slug/respond.index'
import { Route as PortalWorkflowsProjectsProjectIdRouteImport } from './routes/portal/workflows/projects_.$projectId'
import { Route as PortalWorkflowsDefinitionsNewRouteImport } from './routes/portal/workflows/definitions_.new'
import { Route as PortalSpacesSpaceIdEditRouteImport } from './routes/portal/spaces/$spaceId.edit'
import { Route as PortalPlatformGroupsGroupIdRouteImport } from './routes/portal/platform/groups_.$groupId'
import { Route as PortalMyappTableIdSubmitRouteImport } from './routes/portal/myapp/$tableId/submit'
import { Route as PortalMyappTableIdReportRouteImport } from './routes/portal/myapp/$tableId/report'
import { Route as PortalMyappTableIdPrintRouteImport } from './routes/portal/myapp/$tableId/print'
import { Route as PortalMyappTableIdPermissionsRouteImport } from './routes/portal/myapp/$tableId/permissions'
import { Route as PortalMyappTableIdKanbanRouteImport } from './routes/portal/myapp/$tableId/kanban'
import { Route as PortalMyappTableIdGridRouteImport } from './routes/portal/myapp/$tableId/grid'
import { Route as PortalMyappTableIdEditRouteImport } from './routes/portal/myapp/$tableId/edit'
import { Route as PortalLearningReviewAttemptIdRouteImport } from './routes/portal/learning/review/$attemptId'
import { Route as PortalLearningAttemptAttemptIdRouteImport } from './routes/portal/learning/attempt/$attemptId'
import { Route as PortalKnowledgebaseSqlInsightReportsNewRouteImport } from './routes/portal/knowledgebase-sql/insight-reports/new'
import { Route as PortalKnowledgebaseSqlInsightReportsSlugRouteImport } from './routes/portal/knowledgebase-sql/insight-reports/$slug'
import { Route as PortalKnowledgebaseFileDocumentsIdRouteImport } from './routes/portal/knowledgebase-file/documents.$id'
import { Route as PortalKnowledgebaseFileBatchesIdRouteImport } from './routes/portal/knowledgebase-file/batches.$id'
import { Route as PortalHrOnboardingIdRouteImport } from './routes/portal/hr/onboarding/$id'
import { Route as PortalConnectorsSqlserverNewRouteImport } from './routes/portal/connectors/sqlserver/new'
import { Route as PortalConnectorsMysqlNewRouteImport } from './routes/portal/connectors/mysql/new'
import { Route as PortalConnectorsTypeSlugNewRouteImport } from './routes/portal/connectors/$typeSlug/new'
import { Route as PortalConnectorsTypeSlugManageRouteImport } from './routes/portal/connectors/$typeSlug/manage'
import { Route as FormsSlugRespondSuccessRouteImport } from './routes/forms/$slug/respond.success'
import { Route as PortalAppsReportingModelIndexRouteImport } from './routes/portal/apps/reporting/model/index'
import { Route as PortalAppsReportingDatasourcesIndexRouteImport } from './routes/portal/apps/reporting/datasources/index'
import { Route as PortalAppsReportingCustomIndexRouteImport } from './routes/portal/apps/reporting/custom/index'
import { Route as PortalSpacesSpaceIdWidgetWidgetIdRouteImport } from './routes/portal_.spaces.$spaceId.widget.$widgetId'
import { Route as PortalWorkflowsDefinitionsKeyNewVersionRouteImport } from './routes/portal/workflows/definitions_.$key.new-version'
import { Route as PortalAppsReportingDatasourcesNewRouteImport } from './routes/portal/apps/reporting/datasources/new'
import { Route as PortalAppsReportingDatasourcesSlugRouteImport } from './routes/portal/apps/reporting/datasources/$slug'
import { Route as PortalAppsReportingCustomNewRouteImport } from './routes/portal/apps/reporting/custom/new'
import { Route as PortalAppsReportingCustomSlugRouteImport } from './routes/portal/apps/reporting/custom/$slug'
import { Route as PortalAppsReportingCustomSlugWindowRouteImport } from './routes/portal_.apps.reporting.custom.$slug.window'
import { Route as PortalAppsReportingDatasourcesSlugEditRouteImport } from './routes/portal/apps/reporting/datasources/$slug_.edit'
import { Route as PortalAppsReportingCustomSlugEditRouteImport } from './routes/portal/apps/reporting/custom/$slug_.edit'

const VideosRoute = VideosRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsRoute = SolutionsRouteImport.update({
  id: '/solutions',
  path: '/solutions',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesRoute = ResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => rootRouteImport,
} as any)
const ProofOfConceptRoute = ProofOfConceptRouteImport.update({
  id: '/proof-of-concept',
  path: '/proof-of-concept',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndustriesRoute = IndustriesRouteImport.update({
  id: '/industries',
  path: '/industries',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectorsRoute = ConnectorsRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandRoute = BrandRouteImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const ConnectorsIndexRoute = ConnectorsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConnectorsRoute,
} as any)
const ProductsMyappRoute = ProductsMyappRouteImport.update({
  id: '/products/myapp',
  path: '/products/myapp',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsKnowledgeBaseRoute = ProductsKnowledgeBaseRouteImport.update({
  id: '/products/knowledge-base',
  path: '/products/knowledge-base',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewMyappTableTypesRoute = PreviewMyappTableTypesRouteImport.update({
  id: '/preview/myapp-table-types',
  path: '/preview/myapp-table-types',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewKbHeroesRoute = PreviewKbHeroesRouteImport.update({
  id: '/preview/kb-heroes',
  path: '/preview/kb-heroes',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewHomeHeroRoute = PreviewHomeHeroRouteImport.update({
  id: '/preview/home-hero',
  path: '/preview/home-hero',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewGroundUpFlowRoute = PreviewGroundUpFlowRouteImport.update({
  id: '/preview/ground-up-flow',
  path: '/preview/ground-up-flow',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewConnectorFlowsRoute = PreviewConnectorFlowsRouteImport.update({
  id: '/preview/connector-flows',
  path: '/preview/connector-flows',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalSignUpRoute = PortalSignUpRouteImport.update({
  id: '/portal_/sign-up',
  path: '/portal/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalSignInRoute = PortalSignInRouteImport.update({
  id: '/portal_/sign-in',
  path: '/portal/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalResetPasswordRoute = PortalResetPasswordRouteImport.update({
  id: '/portal_/reset-password',
  path: '/portal/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalHelpRoute = PortalHelpRouteImport.update({
  id: '/portal_/help',
  path: '/portal/help',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalForgotPasswordRoute = PortalForgotPasswordRouteImport.update({
  id: '/portal_/forgot-password',
  path: '/portal/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalWorkflowsRoute = PortalWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPlatformRoute = PortalPlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => PortalRoute,
} as any)
const PortalMyappRoute = PortalMyappRouteImport.update({
  id: '/myapp',
  path: '/myapp',
  getParentRoute: () => PortalRoute,
} as any)
const PortalMessagingRoute = PortalMessagingRouteImport.update({
  id: '/messaging',
  path: '/messaging',
  getParentRoute: () => PortalRoute,
} as any)
const PortalLmsRoute = PortalLmsRouteImport.update({
  id: '/lms',
  path: '/lms',
  getParentRoute: () => PortalRoute,
} as any)
const PortalLearningRoute = PortalLearningRouteImport.update({
  id: '/learning',
  path: '/learning',
  getParentRoute: () => PortalRoute,
} as any)
const PortalKnowledgebaseSqlRoute = PortalKnowledgebaseSqlRouteImport.update({
  id: '/knowledgebase-sql',
  path: '/knowledgebase-sql',
  getParentRoute: () => PortalRoute,
} as any)
const PortalKnowledgebaseFileRoute = PortalKnowledgebaseFileRouteImport.update({
  id: '/knowledgebase-file',
  path: '/knowledgebase-file',
  getParentRoute: () => PortalRoute,
} as any)
const PortalHrRoute = PortalHrRouteImport.update({
  id: '/hr',
  path: '/hr',
  getParentRoute: () => PortalRoute,
} as any)
const PortalFtpRoute = PortalFtpRouteImport.update({
  id: '/ftp',
  path: '/ftp',
  getParentRoute: () => PortalRoute,
} as any)
const PortalCatalogueIntelligenceRoute =
  PortalCatalogueIntelligenceRouteImport.update({
    id: '/catalogue-intelligence',
    path: '/catalogue-intelligence',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAutomationRoute = PortalAutomationRouteImport.update({
  id: '/automation',
  path: '/automation',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAssetLibraryRoute = PortalAssetLibraryRouteImport.update({
  id: '/asset-library',
  path: '/asset-library',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAiContentRoute = PortalAiContentRouteImport.update({
  id: '/ai-content',
  path: '/ai-content',
  getParentRoute: () => PortalRoute,
} as any)
const OnboardTokenRoute = OnboardTokenRouteImport.update({
  id: '/onboard/$token',
  path: '/onboard/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalTermsOfUseRoute = LegalTermsOfUseRouteImport.update({
  id: '/legal/terms-of-use',
  path: '/legal/terms-of-use',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRefundPolicyRoute = LegalRefundPolicyRouteImport.update({
  id: '/legal/refund-policy',
  path: '/legal/refund-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/legal/privacy',
  path: '/legal/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalPaiaRoute = LegalPaiaRouteImport.update({
  id: '/legal/paia',
  path: '/legal/paia',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalDataProcessingRoute = LegalDataProcessingRouteImport.update({
  id: '/legal/data-processing',
  path: '/legal/data-processing',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectorsXeroCaseStudyRoute = ConnectorsXeroCaseStudyRouteImport.update({
  id: '/xero-case-study',
  path: '/xero-case-study',
  getParentRoute: () => ConnectorsRoute,
} as any)
const ConnectorsProductRoute = ConnectorsProductRouteImport.update({
  id: '/product',
  path: '/product',
  getParentRoute: () => ConnectorsRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchivePricingRoute = ArchivePricingRouteImport.update({
  id: '/archive/pricing',
  path: '/archive/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveHomeRoute = ArchiveHomeRouteImport.update({
  id: '/archive/home',
  path: '/archive/home',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalWorkflowsIndexRoute = PortalWorkflowsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalWorkflowsRoute,
} as any)
const PortalSpacesIndexRoute = PortalSpacesIndexRouteImport.update({
  id: '/spaces/',
  path: '/spaces/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalMyappIndexRoute = PortalMyappIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalMyappRoute,
} as any)
const PortalMessagingIndexRoute = PortalMessagingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalMessagingRoute,
} as any)
const PortalLmsIndexRoute = PortalLmsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalLmsRoute,
} as any)
const PortalLearningIndexRoute = PortalLearningIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalLearningRoute,
} as any)
const PortalKnowledgebaseSqlIndexRoute =
  PortalKnowledgebaseSqlIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PortalKnowledgebaseSqlRoute,
  } as any)
const PortalKnowledgebaseFileIndexRoute =
  PortalKnowledgebaseFileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PortalKnowledgebaseFileRoute,
  } as any)
const PortalHrIndexRoute = PortalHrIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalHrRoute,
} as any)
const PortalFtpIndexRoute = PortalFtpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalFtpRoute,
} as any)
const PortalConnectorsIndexRoute = PortalConnectorsIndexRouteImport.update({
  id: '/connectors/',
  path: '/connectors/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAutomationIndexRoute = PortalAutomationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalAutomationRoute,
} as any)
const PortalAppsIndexRoute = PortalAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAiContentIndexRoute = PortalAiContentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalAiContentRoute,
} as any)
const ProductsMyappExcelAddinSetupRoute =
  ProductsMyappExcelAddinSetupRouteImport.update({
    id: '/products/myapp_/excel-addin-setup',
    path: '/products/myapp/excel-addin-setup',
    getParentRoute: () => rootRouteImport,
  } as any)
const PortalSignInVerifyRoute = PortalSignInVerifyRouteImport.update({
  id: '/portal_/sign-in_/verify',
  path: '/portal/sign-in/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalInviteAcceptRoute = PortalInviteAcceptRouteImport.update({
  id: '/portal_/invite/accept',
  path: '/portal/invite/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalAuthVerifyEmailRoute = PortalAuthVerifyEmailRouteImport.update({
  id: '/portal_/auth/verify-email',
  path: '/portal/auth/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalAuthUnlockAccountRoute = PortalAuthUnlockAccountRouteImport.update({
  id: '/portal_/auth/unlock-account',
  path: '/portal/auth/unlock-account',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalWorkflowsTopologyRoute = PortalWorkflowsTopologyRouteImport.update({
  id: '/topology',
  path: '/topology',
  getParentRoute: () => PortalWorkflowsRoute,
} as any)
const PortalWorkflowsTemplatesRoute =
  PortalWorkflowsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => PortalWorkflowsRoute,
  } as any)
const PortalWorkflowsRetryFailuresRoute =
  PortalWorkflowsRetryFailuresRouteImport.update({
    id: '/retry-failures',
    path: '/retry-failures',
    getParentRoute: () => PortalWorkflowsRoute,
  } as any)
const PortalWorkflowsProjectsRoute = PortalWorkflowsProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => PortalWorkflowsRoute,
} as any)
const PortalWorkflowsExecutionsRoute =
  PortalWorkflowsExecutionsRouteImport.update({
    id: '/executions',
    path: '/executions',
    getParentRoute: () => PortalWorkflowsRoute,
  } as any)
const PortalWorkflowsExecuteRoute = PortalWorkflowsExecuteRouteImport.update({
  id: '/execute',
  path: '/execute',
  getParentRoute: () => PortalWorkflowsRoute,
} as any)
const PortalWorkflowsDlqRoute = PortalWorkflowsDlqRouteImport.update({
  id: '/dlq',
  path: '/dlq',
  getParentRoute: () => PortalWorkflowsRoute,
} as any)
const PortalWorkflowsDefinitionsRoute =
  PortalWorkflowsDefinitionsRouteImport.update({
    id: '/definitions',
    path: '/definitions',
    getParentRoute: () => PortalWorkflowsRoute,
  } as any)
const PortalWorkflowsCanvasDemoRoute =
  PortalWorkflowsCanvasDemoRouteImport.update({
    id: '/canvas-demo',
    path: '/canvas-demo',
    getParentRoute: () => PortalWorkflowsRoute,
  } as any)
const PortalSpacesNewRoute = PortalSpacesNewRouteImport.update({
  id: '/spaces/new',
  path: '/spaces/new',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSpacesSpaceIdRoute = PortalSpacesSpaceIdRouteImport.update({
  id: '/spaces/$spaceId',
  path: '/spaces/$spaceId',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPlatformUsersRoute = PortalPlatformUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformTiersRoute = PortalPlatformTiersRouteImport.update({
  id: '/tiers',
  path: '/tiers',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformThemeRoute = PortalPlatformThemeRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformSubscriptionsRoute =
  PortalPlatformSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformSettingsRoute = PortalPlatformSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformSecurityRoute = PortalPlatformSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformSecretsRoute = PortalPlatformSecretsRouteImport.update({
  id: '/secrets',
  path: '/secrets',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformSdlcRoute = PortalPlatformSdlcRouteImport.update({
  id: '/sdlc',
  path: '/sdlc',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformSchemaDriftRoute =
  PortalPlatformSchemaDriftRouteImport.update({
    id: '/schema-drift',
    path: '/schema-drift',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformRbacRoute = PortalPlatformRbacRouteImport.update({
  id: '/rbac',
  path: '/rbac',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformProfileRoute = PortalPlatformProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformProductsRoute = PortalPlatformProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformPricingRoute = PortalPlatformPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformPipelinesRoute = PortalPlatformPipelinesRouteImport.update({
  id: '/pipelines',
  path: '/pipelines',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformOrphanedSchedulesRoute =
  PortalPlatformOrphanedSchedulesRouteImport.update({
    id: '/orphaned-schedules',
    path: '/orphaned-schedules',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformOrganisationsRoute =
  PortalPlatformOrganisationsRouteImport.update({
    id: '/organisations',
    path: '/organisations',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformObjectPermissionsRoute =
  PortalPlatformObjectPermissionsRouteImport.update({
    id: '/object-permissions',
    path: '/object-permissions',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformMonitoringRoute =
  PortalPlatformMonitoringRouteImport.update({
    id: '/monitoring',
    path: '/monitoring',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformMaintenanceRoute =
  PortalPlatformMaintenanceRouteImport.update({
    id: '/maintenance',
    path: '/maintenance',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformInfrastructureRoute =
  PortalPlatformInfrastructureRouteImport.update({
    id: '/infrastructure',
    path: '/infrastructure',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformInboundDeadLettersRoute =
  PortalPlatformInboundDeadLettersRouteImport.update({
    id: '/inbound-dead-letters',
    path: '/inbound-dead-letters',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformGroupsRoute = PortalPlatformGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformDiscountsRoute = PortalPlatformDiscountsRouteImport.update({
  id: '/discounts',
  path: '/discounts',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformConnectorsRoute =
  PortalPlatformConnectorsRouteImport.update({
    id: '/connectors',
    path: '/connectors',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformConnectorEnrichmentRoute =
  PortalPlatformConnectorEnrichmentRouteImport.update({
    id: '/connector-enrichment',
    path: '/connector-enrichment',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformClientOnboardingRoute =
  PortalPlatformClientOnboardingRouteImport.update({
    id: '/client-onboarding',
    path: '/client-onboarding',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformChartSettingsRoute =
  PortalPlatformChartSettingsRouteImport.update({
    id: '/chart-settings',
    path: '/chart-settings',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformCategoriesRoute =
  PortalPlatformCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformBillingOverviewRoute =
  PortalPlatformBillingOverviewRouteImport.update({
    id: '/billing-overview',
    path: '/billing-overview',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalPlatformBillingRoute = PortalPlatformBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalPlatformApiKeysRoute = PortalPlatformApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => PortalPlatformRoute,
} as any)
const PortalOrganisationThemeRoute = PortalOrganisationThemeRouteImport.update({
  id: '/organisation/theme',
  path: '/organisation/theme',
  getParentRoute: () => PortalRoute,
} as any)
const PortalOrganisationSettingsRoute =
  PortalOrganisationSettingsRouteImport.update({
    id: '/organisation/settings',
    path: '/organisation/settings',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalOrganisationMembersRoute =
  PortalOrganisationMembersRouteImport.update({
    id: '/organisation/members',
    path: '/organisation/members',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalOrganisationCategoriesRoute =
  PortalOrganisationCategoriesRouteImport.update({
    id: '/organisation/categories',
    path: '/organisation/categories',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalMyappTablesRoute = PortalMyappTablesRouteImport.update({
  id: '/tables',
  path: '/tables',
  getParentRoute: () => PortalMyappRoute,
} as any)
const PortalMyappBridgeRoute = PortalMyappBridgeRouteImport.update({
  id: '/bridge',
  path: '/bridge',
  getParentRoute: () => PortalMyappRoute,
} as any)
const PortalMyappAreasRoute = PortalMyappAreasRouteImport.update({
  id: '/areas',
  path: '/areas',
  getParentRoute: () => PortalMyappRoute,
} as any)
const PortalMyappAppsRoute = PortalMyappAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => PortalMyappRoute,
} as any)
const PortalMessagingWhatsappSetupRoute =
  PortalMessagingWhatsappSetupRouteImport.update({
    id: '/whatsapp-setup',
    path: '/whatsapp-setup',
    getParentRoute: () => PortalMessagingRoute,
  } as any)
const PortalMessagingTemplatesRoute =
  PortalMessagingTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => PortalMessagingRoute,
  } as any)
const PortalMessagingInboxRoute = PortalMessagingInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => PortalMessagingRoute,
} as any)
const PortalLmsLeaderboardRoute = PortalLmsLeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => PortalLmsRoute,
} as any)
const PortalLmsCyclesRoute = PortalLmsCyclesRouteImport.update({
  id: '/cycles',
  path: '/cycles',
  getParentRoute: () => PortalLmsRoute,
} as any)
const PortalLmsCurationRoute = PortalLmsCurationRouteImport.update({
  id: '/curation',
  path: '/curation',
  getParentRoute: () => PortalLmsRoute,
} as any)
const PortalLmsAuthorRoute = PortalLmsAuthorRouteImport.update({
  id: '/author',
  path: '/author',
  getParentRoute: () => PortalLmsRoute,
} as any)
const PortalLmsAssignRoute = PortalLmsAssignRouteImport.update({
  id: '/assign',
  path: '/assign',
  getParentRoute: () => PortalLmsRoute,
} as any)
const PortalKnowledgebaseSqlQuickQuestionRoute =
  PortalKnowledgebaseSqlQuickQuestionRouteImport.update({
    id: '/quick-question',
    path: '/quick-question',
    getParentRoute: () => PortalKnowledgebaseSqlRoute,
  } as any)
const PortalKnowledgebaseSqlQueryRoute =
  PortalKnowledgebaseSqlQueryRouteImport.update({
    id: '/query',
    path: '/query',
    getParentRoute: () => PortalKnowledgebaseSqlRoute,
  } as any)
const PortalKnowledgebaseSqlGlossaryRoute =
  PortalKnowledgebaseSqlGlossaryRouteImport.update({
    id: '/glossary',
    path: '/glossary',
    getParentRoute: () => PortalKnowledgebaseSqlRoute,
  } as any)
const PortalKnowledgebaseSqlDataSourcesRoute =
  PortalKnowledgebaseSqlDataSourcesRouteImport.update({
    id: '/data-sources',
    path: '/data-sources',
    getParentRoute: () => PortalKnowledgebaseSqlRoute,
  } as any)
const PortalKnowledgebaseSqlConnectRoute =
  PortalKnowledgebaseSqlConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => PortalKnowledgebaseSqlRoute,
  } as any)
const PortalKnowledgebaseFileUploadRoute =
  PortalKnowledgebaseFileUploadRouteImport.update({
    id: '/upload',
    path: '/upload',
    getParentRoute: () => PortalKnowledgebaseFileRoute,
  } as any)
const PortalKnowledgebaseFileTemplatesRoute =
  PortalKnowledgebaseFileTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => PortalKnowledgebaseFileRoute,
  } as any)
const PortalKnowledgebaseFileQueryRoute =
  PortalKnowledgebaseFileQueryRouteImport.update({
    id: '/query',
    path: '/query',
    getParentRoute: () => PortalKnowledgebaseFileRoute,
  } as any)
const PortalKnowledgebaseFileLabelsRoute =
  PortalKnowledgebaseFileLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => PortalKnowledgebaseFileRoute,
  } as any)
const PortalKnowledgebaseFileDocumentsRoute =
  PortalKnowledgebaseFileDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => PortalKnowledgebaseFileRoute,
  } as any)
const PortalKnowledgebaseFileCategoryReviewRoute =
  PortalKnowledgebaseFileCategoryReviewRouteImport.update({
    id: '/category-review',
    path: '/category-review',
    getParentRoute: () => PortalKnowledgebaseFileRoute,
  } as any)
const PortalKnowledgebaseFileCategoriesRoute =
  PortalKnowledgebaseFileCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => PortalKnowledgebaseFileRoute,
  } as any)
const PortalKnowledgebaseFileBatchesRoute =
  PortalKnowledgebaseFileBatchesRouteImport.update({
    id: '/batches',
    path: '/batches',
    getParentRoute: () => PortalKnowledgebaseFileRoute,
  } as any)
const PortalFtpUsersRoute = PortalFtpUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => PortalFtpRoute,
} as any)
const PortalFtpFilesRoute = PortalFtpFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => PortalFtpRoute,
} as any)
const PortalFtpConnectionsRoute = PortalFtpConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => PortalFtpRoute,
} as any)
const PortalFtpAuditRoute = PortalFtpAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => PortalFtpRoute,
} as any)
const PortalAutomationWorkflowsRoute =
  PortalAutomationWorkflowsRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => PortalAutomationRoute,
  } as any)
const PortalAutomationWebhooksRoute =
  PortalAutomationWebhooksRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () => PortalAutomationRoute,
  } as any)
const PortalAutomationSkillsRoute = PortalAutomationSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => PortalAutomationRoute,
} as any)
const PortalAutomationPoliciesRoute =
  PortalAutomationPoliciesRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => PortalAutomationRoute,
  } as any)
const PortalAutomationMonitoringRoute =
  PortalAutomationMonitoringRouteImport.update({
    id: '/monitoring',
    path: '/monitoring',
    getParentRoute: () => PortalAutomationRoute,
  } as any)
const PortalAutomationMcpRoute = PortalAutomationMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => PortalAutomationRoute,
} as any)
const PortalAutomationLlmRoute = PortalAutomationLlmRouteImport.update({
  id: '/llm',
  path: '/llm',
  getParentRoute: () => PortalAutomationRoute,
} as any)
const PortalAutomationDashboardRoute =
  PortalAutomationDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => PortalAutomationRoute,
  } as any)
const PortalAutomationCredentialsRoute =
  PortalAutomationCredentialsRouteImport.update({
    id: '/credentials',
    path: '/credentials',
    getParentRoute: () => PortalAutomationRoute,
  } as any)
const PortalAutomationContentReviewRoute =
  PortalAutomationContentReviewRouteImport.update({
    id: '/content-review',
    path: '/content-review',
    getParentRoute: () => PortalAutomationRoute,
  } as any)
const PortalAutomationAuditRoute = PortalAutomationAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => PortalAutomationRoute,
} as any)
const PortalAutomationAgentEntitlementsRoute =
  PortalAutomationAgentEntitlementsRouteImport.update({
    id: '/agent-entitlements',
    path: '/agent-entitlements',
    getParentRoute: () => PortalAutomationRoute,
  } as any)
const PortalAppsExpenseRoute = PortalAppsExpenseRouteImport.update({
  id: '/apps/expense',
  path: '/apps/expense',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAiContentHistoryRoute = PortalAiContentHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => PortalAiContentRoute,
} as any)
const FormsSlugRespondRoute = FormsSlugRespondRouteImport.update({
  id: '/forms/$slug/respond',
  path: '/forms/$slug/respond',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalSpacesSpaceIdIndexRoute =
  PortalSpacesSpaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PortalSpacesSpaceIdRoute,
  } as any)
const PortalMyappTableIdIndexRoute = PortalMyappTableIdIndexRouteImport.update({
  id: '/$tableId/',
  path: '/$tableId/',
  getParentRoute: () => PortalMyappRoute,
} as any)
const PortalLearningReviewIndexRoute =
  PortalLearningReviewIndexRouteImport.update({
    id: '/review/',
    path: '/review/',
    getParentRoute: () => PortalLearningRoute,
  } as any)
const PortalKnowledgebaseSqlInsightReportsIndexRoute =
  PortalKnowledgebaseSqlInsightReportsIndexRouteImport.update({
    id: '/insight-reports/',
    path: '/insight-reports/',
    getParentRoute: () => PortalKnowledgebaseSqlRoute,
  } as any)
const PortalHrSettingsIndexRoute = PortalHrSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => PortalHrRoute,
} as any)
const PortalHrRulesIndexRoute = PortalHrRulesIndexRouteImport.update({
  id: '/rules/',
  path: '/rules/',
  getParentRoute: () => PortalHrRoute,
} as any)
const PortalHrOnboardingIndexRoute = PortalHrOnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => PortalHrRoute,
} as any)
const PortalHrForecastIndexRoute = PortalHrForecastIndexRouteImport.update({
  id: '/forecast/',
  path: '/forecast/',
  getParentRoute: () => PortalHrRoute,
} as any)
const PortalHrEmployeesIndexRoute = PortalHrEmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => PortalHrRoute,
} as any)
const PortalHrAllocationsIndexRoute =
  PortalHrAllocationsIndexRouteImport.update({
    id: '/allocations/',
    path: '/allocations/',
    getParentRoute: () => PortalHrRoute,
  } as any)
const PortalConnectorsTypeSlugIndexRoute =
  PortalConnectorsTypeSlugIndexRouteImport.update({
    id: '/connectors/$typeSlug/',
    path: '/connectors/$typeSlug/',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAppsReportingIndexRoute =
  PortalAppsReportingIndexRouteImport.update({
    id: '/apps/reporting/',
    path: '/apps/reporting/',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAppsAppSlugIndexRoute = PortalAppsAppSlugIndexRouteImport.update({
  id: '/apps/$appSlug/',
  path: '/apps/$appSlug/',
  getParentRoute: () => PortalRoute,
} as any)
const FormsSlugRespondIndexRoute = FormsSlugRespondIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FormsSlugRespondRoute,
} as any)
const PortalWorkflowsProjectsProjectIdRoute =
  PortalWorkflowsProjectsProjectIdRouteImport.update({
    id: '/projects_/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => PortalWorkflowsRoute,
  } as any)
const PortalWorkflowsDefinitionsNewRoute =
  PortalWorkflowsDefinitionsNewRouteImport.update({
    id: '/definitions_/new',
    path: '/definitions/new',
    getParentRoute: () => PortalWorkflowsRoute,
  } as any)
const PortalSpacesSpaceIdEditRoute = PortalSpacesSpaceIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => PortalSpacesSpaceIdRoute,
} as any)
const PortalPlatformGroupsGroupIdRoute =
  PortalPlatformGroupsGroupIdRouteImport.update({
    id: '/groups_/$groupId',
    path: '/groups/$groupId',
    getParentRoute: () => PortalPlatformRoute,
  } as any)
const PortalMyappTableIdSubmitRoute =
  PortalMyappTableIdSubmitRouteImport.update({
    id: '/$tableId/submit',
    path: '/$tableId/submit',
    getParentRoute: () => PortalMyappRoute,
  } as any)
const PortalMyappTableIdReportRoute =
  PortalMyappTableIdReportRouteImport.update({
    id: '/$tableId/report',
    path: '/$tableId/report',
    getParentRoute: () => PortalMyappRoute,
  } as any)
const PortalMyappTableIdPrintRoute = PortalMyappTableIdPrintRouteImport.update({
  id: '/$tableId/print',
  path: '/$tableId/print',
  getParentRoute: () => PortalMyappRoute,
} as any)
const PortalMyappTableIdPermissionsRoute =
  PortalMyappTableIdPermissionsRouteImport.update({
    id: '/$tableId/permissions',
    path: '/$tableId/permissions',
    getParentRoute: () => PortalMyappRoute,
  } as any)
const PortalMyappTableIdKanbanRoute =
  PortalMyappTableIdKanbanRouteImport.update({
    id: '/$tableId/kanban',
    path: '/$tableId/kanban',
    getParentRoute: () => PortalMyappRoute,
  } as any)
const PortalMyappTableIdGridRoute = PortalMyappTableIdGridRouteImport.update({
  id: '/$tableId/grid',
  path: '/$tableId/grid',
  getParentRoute: () => PortalMyappRoute,
} as any)
const PortalMyappTableIdEditRoute = PortalMyappTableIdEditRouteImport.update({
  id: '/$tableId/edit',
  path: '/$tableId/edit',
  getParentRoute: () => PortalMyappRoute,
} as any)
const PortalLearningReviewAttemptIdRoute =
  PortalLearningReviewAttemptIdRouteImport.update({
    id: '/review/$attemptId',
    path: '/review/$attemptId',
    getParentRoute: () => PortalLearningRoute,
  } as any)
const PortalLearningAttemptAttemptIdRoute =
  PortalLearningAttemptAttemptIdRouteImport.update({
    id: '/attempt/$attemptId',
    path: '/attempt/$attemptId',
    getParentRoute: () => PortalLearningRoute,
  } as any)
const PortalKnowledgebaseSqlInsightReportsNewRoute =
  PortalKnowledgebaseSqlInsightReportsNewRouteImport.update({
    id: '/insight-reports/new',
    path: '/insight-reports/new',
    getParentRoute: () => PortalKnowledgebaseSqlRoute,
  } as any)
const PortalKnowledgebaseSqlInsightReportsSlugRoute =
  PortalKnowledgebaseSqlInsightReportsSlugRouteImport.update({
    id: '/insight-reports/$slug',
    path: '/insight-reports/$slug',
    getParentRoute: () => PortalKnowledgebaseSqlRoute,
  } as any)
const PortalKnowledgebaseFileDocumentsIdRoute =
  PortalKnowledgebaseFileDocumentsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => PortalKnowledgebaseFileDocumentsRoute,
  } as any)
const PortalKnowledgebaseFileBatchesIdRoute =
  PortalKnowledgebaseFileBatchesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => PortalKnowledgebaseFileBatchesRoute,
  } as any)
const PortalHrOnboardingIdRoute = PortalHrOnboardingIdRouteImport.update({
  id: '/onboarding/$id',
  path: '/onboarding/$id',
  getParentRoute: () => PortalHrRoute,
} as any)
const PortalConnectorsSqlserverNewRoute =
  PortalConnectorsSqlserverNewRouteImport.update({
    id: '/connectors/sqlserver/new',
    path: '/connectors/sqlserver/new',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalConnectorsMysqlNewRoute =
  PortalConnectorsMysqlNewRouteImport.update({
    id: '/connectors/mysql/new',
    path: '/connectors/mysql/new',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalConnectorsTypeSlugNewRoute =
  PortalConnectorsTypeSlugNewRouteImport.update({
    id: '/connectors/$typeSlug/new',
    path: '/connectors/$typeSlug/new',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalConnectorsTypeSlugManageRoute =
  PortalConnectorsTypeSlugManageRouteImport.update({
    id: '/connectors/$typeSlug/manage',
    path: '/connectors/$typeSlug/manage',
    getParentRoute: () => PortalRoute,
  } as any)
const FormsSlugRespondSuccessRoute = FormsSlugRespondSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => FormsSlugRespondRoute,
} as any)
const PortalAppsReportingModelIndexRoute =
  PortalAppsReportingModelIndexRouteImport.update({
    id: '/apps/reporting/model/',
    path: '/apps/reporting/model/',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAppsReportingDatasourcesIndexRoute =
  PortalAppsReportingDatasourcesIndexRouteImport.update({
    id: '/apps/reporting/datasources/',
    path: '/apps/reporting/datasources/',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAppsReportingCustomIndexRoute =
  PortalAppsReportingCustomIndexRouteImport.update({
    id: '/apps/reporting/custom/',
    path: '/apps/reporting/custom/',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalSpacesSpaceIdWidgetWidgetIdRoute =
  PortalSpacesSpaceIdWidgetWidgetIdRouteImport.update({
    id: '/portal_/spaces/$spaceId/widget/$widgetId',
    path: '/portal/spaces/$spaceId/widget/$widgetId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PortalWorkflowsDefinitionsKeyNewVersionRoute =
  PortalWorkflowsDefinitionsKeyNewVersionRouteImport.update({
    id: '/definitions_/$key/new-version',
    path: '/definitions/$key/new-version',
    getParentRoute: () => PortalWorkflowsRoute,
  } as any)
const PortalAppsReportingDatasourcesNewRoute =
  PortalAppsReportingDatasourcesNewRouteImport.update({
    id: '/apps/reporting/datasources/new',
    path: '/apps/reporting/datasources/new',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAppsReportingDatasourcesSlugRoute =
  PortalAppsReportingDatasourcesSlugRouteImport.update({
    id: '/apps/reporting/datasources/$slug',
    path: '/apps/reporting/datasources/$slug',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAppsReportingCustomNewRoute =
  PortalAppsReportingCustomNewRouteImport.update({
    id: '/apps/reporting/custom/new',
    path: '/apps/reporting/custom/new',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAppsReportingCustomSlugRoute =
  PortalAppsReportingCustomSlugRouteImport.update({
    id: '/apps/reporting/custom/$slug',
    path: '/apps/reporting/custom/$slug',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAppsReportingCustomSlugWindowRoute =
  PortalAppsReportingCustomSlugWindowRouteImport.update({
    id: '/portal_/apps/reporting/custom/$slug/window',
    path: '/portal/apps/reporting/custom/$slug/window',
    getParentRoute: () => rootRouteImport,
  } as any)
const PortalAppsReportingDatasourcesSlugEditRoute =
  PortalAppsReportingDatasourcesSlugEditRouteImport.update({
    id: '/apps/reporting/datasources/$slug_/edit',
    path: '/apps/reporting/datasources/$slug/edit',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAppsReportingCustomSlugEditRoute =
  PortalAppsReportingCustomSlugEditRouteImport.update({
    id: '/apps/reporting/custom/$slug_/edit',
    path: '/apps/reporting/custom/$slug/edit',
    getParentRoute: () => PortalRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/brand': typeof BrandRoute
  '/connectors': typeof ConnectorsRouteWithChildren
  '/contact': typeof ContactRoute
  '/industries': typeof IndustriesRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/pricing': typeof PricingRoute
  '/proof-of-concept': typeof ProofOfConceptRoute
  '/resources': typeof ResourcesRoute
  '/solutions': typeof SolutionsRoute
  '/status': typeof StatusRoute
  '/videos': typeof VideosRoute
  '/archive/home': typeof ArchiveHomeRoute
  '/archive/pricing': typeof ArchivePricingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/connectors/product': typeof ConnectorsProductRoute
  '/connectors/xero-case-study': typeof ConnectorsXeroCaseStudyRoute
  '/legal/data-processing': typeof LegalDataProcessingRoute
  '/legal/paia': typeof LegalPaiaRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/refund-policy': typeof LegalRefundPolicyRoute
  '/legal/terms-of-use': typeof LegalTermsOfUseRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboard/$token': typeof OnboardTokenRoute
  '/portal/ai-content': typeof PortalAiContentRouteWithChildren
  '/portal/asset-library': typeof PortalAssetLibraryRoute
  '/portal/automation': typeof PortalAutomationRouteWithChildren
  '/portal/catalogue-intelligence': typeof PortalCatalogueIntelligenceRoute
  '/portal/ftp': typeof PortalFtpRouteWithChildren
  '/portal/hr': typeof PortalHrRouteWithChildren
  '/portal/knowledgebase-file': typeof PortalKnowledgebaseFileRouteWithChildren
  '/portal/knowledgebase-sql': typeof PortalKnowledgebaseSqlRouteWithChildren
  '/portal/learning': typeof PortalLearningRouteWithChildren
  '/portal/lms': typeof PortalLmsRouteWithChildren
  '/portal/messaging': typeof PortalMessagingRouteWithChildren
  '/portal/myapp': typeof PortalMyappRouteWithChildren
  '/portal/platform': typeof PortalPlatformRouteWithChildren
  '/portal/workflows': typeof PortalWorkflowsRouteWithChildren
  '/portal/forgot-password': typeof PortalForgotPasswordRoute
  '/portal/help': typeof PortalHelpRoute
  '/portal/reset-password': typeof PortalResetPasswordRoute
  '/portal/sign-in': typeof PortalSignInRoute
  '/portal/sign-up': typeof PortalSignUpRoute
  '/preview/connector-flows': typeof PreviewConnectorFlowsRoute
  '/preview/ground-up-flow': typeof PreviewGroundUpFlowRoute
  '/preview/home-hero': typeof PreviewHomeHeroRoute
  '/preview/kb-heroes': typeof PreviewKbHeroesRoute
  '/preview/myapp-table-types': typeof PreviewMyappTableTypesRoute
  '/products/knowledge-base': typeof ProductsKnowledgeBaseRoute
  '/products/myapp': typeof ProductsMyappRoute
  '/connectors/': typeof ConnectorsIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/forms/$slug/respond': typeof FormsSlugRespondRouteWithChildren
  '/portal/ai-content/history': typeof PortalAiContentHistoryRoute
  '/portal/apps/expense': typeof PortalAppsExpenseRoute
  '/portal/automation/agent-entitlements': typeof PortalAutomationAgentEntitlementsRoute
  '/portal/automation/audit': typeof PortalAutomationAuditRoute
  '/portal/automation/content-review': typeof PortalAutomationContentReviewRoute
  '/portal/automation/credentials': typeof PortalAutomationCredentialsRoute
  '/portal/automation/dashboard': typeof PortalAutomationDashboardRoute
  '/portal/automation/llm': typeof PortalAutomationLlmRoute
  '/portal/automation/mcp': typeof PortalAutomationMcpRoute
  '/portal/automation/monitoring': typeof PortalAutomationMonitoringRoute
  '/portal/automation/policies': typeof PortalAutomationPoliciesRoute
  '/portal/automation/skills': typeof PortalAutomationSkillsRoute
  '/portal/automation/webhooks': typeof PortalAutomationWebhooksRoute
  '/portal/automation/workflows': typeof PortalAutomationWorkflowsRoute
  '/portal/ftp/audit': typeof PortalFtpAuditRoute
  '/portal/ftp/connections': typeof PortalFtpConnectionsRoute
  '/portal/ftp/files': typeof PortalFtpFilesRoute
  '/portal/ftp/users': typeof PortalFtpUsersRoute
  '/portal/knowledgebase-file/batches': typeof PortalKnowledgebaseFileBatchesRouteWithChildren
  '/portal/knowledgebase-file/categories': typeof PortalKnowledgebaseFileCategoriesRoute
  '/portal/knowledgebase-file/category-review': typeof PortalKnowledgebaseFileCategoryReviewRoute
  '/portal/knowledgebase-file/documents': typeof PortalKnowledgebaseFileDocumentsRouteWithChildren
  '/portal/knowledgebase-file/labels': typeof PortalKnowledgebaseFileLabelsRoute
  '/portal/knowledgebase-file/query': typeof PortalKnowledgebaseFileQueryRoute
  '/portal/knowledgebase-file/templates': typeof PortalKnowledgebaseFileTemplatesRoute
  '/portal/knowledgebase-file/upload': typeof PortalKnowledgebaseFileUploadRoute
  '/portal/knowledgebase-sql/connect': typeof PortalKnowledgebaseSqlConnectRoute
  '/portal/knowledgebase-sql/data-sources': typeof PortalKnowledgebaseSqlDataSourcesRoute
  '/portal/knowledgebase-sql/glossary': typeof PortalKnowledgebaseSqlGlossaryRoute
  '/portal/knowledgebase-sql/query': typeof PortalKnowledgebaseSqlQueryRoute
  '/portal/knowledgebase-sql/quick-question': typeof PortalKnowledgebaseSqlQuickQuestionRoute
  '/portal/lms/assign': typeof PortalLmsAssignRoute
  '/portal/lms/author': typeof PortalLmsAuthorRoute
  '/portal/lms/curation': typeof PortalLmsCurationRoute
  '/portal/lms/cycles': typeof PortalLmsCyclesRoute
  '/portal/lms/leaderboard': typeof PortalLmsLeaderboardRoute
  '/portal/messaging/inbox': typeof PortalMessagingInboxRoute
  '/portal/messaging/templates': typeof PortalMessagingTemplatesRoute
  '/portal/messaging/whatsapp-setup': typeof PortalMessagingWhatsappSetupRoute
  '/portal/myapp/apps': typeof PortalMyappAppsRoute
  '/portal/myapp/areas': typeof PortalMyappAreasRoute
  '/portal/myapp/bridge': typeof PortalMyappBridgeRoute
  '/portal/myapp/tables': typeof PortalMyappTablesRoute
  '/portal/organisation/categories': typeof PortalOrganisationCategoriesRoute
  '/portal/organisation/members': typeof PortalOrganisationMembersRoute
  '/portal/organisation/settings': typeof PortalOrganisationSettingsRoute
  '/portal/organisation/theme': typeof PortalOrganisationThemeRoute
  '/portal/platform/api-keys': typeof PortalPlatformApiKeysRoute
  '/portal/platform/billing': typeof PortalPlatformBillingRoute
  '/portal/platform/billing-overview': typeof PortalPlatformBillingOverviewRoute
  '/portal/platform/categories': typeof PortalPlatformCategoriesRoute
  '/portal/platform/chart-settings': typeof PortalPlatformChartSettingsRoute
  '/portal/platform/client-onboarding': typeof PortalPlatformClientOnboardingRoute
  '/portal/platform/connector-enrichment': typeof PortalPlatformConnectorEnrichmentRoute
  '/portal/platform/connectors': typeof PortalPlatformConnectorsRoute
  '/portal/platform/discounts': typeof PortalPlatformDiscountsRoute
  '/portal/platform/groups': typeof PortalPlatformGroupsRoute
  '/portal/platform/inbound-dead-letters': typeof PortalPlatformInboundDeadLettersRoute
  '/portal/platform/infrastructure': typeof PortalPlatformInfrastructureRoute
  '/portal/platform/maintenance': typeof PortalPlatformMaintenanceRoute
  '/portal/platform/monitoring': typeof PortalPlatformMonitoringRoute
  '/portal/platform/object-permissions': typeof PortalPlatformObjectPermissionsRoute
  '/portal/platform/organisations': typeof PortalPlatformOrganisationsRoute
  '/portal/platform/orphaned-schedules': typeof PortalPlatformOrphanedSchedulesRoute
  '/portal/platform/pipelines': typeof PortalPlatformPipelinesRoute
  '/portal/platform/pricing': typeof PortalPlatformPricingRoute
  '/portal/platform/products': typeof PortalPlatformProductsRoute
  '/portal/platform/profile': typeof PortalPlatformProfileRoute
  '/portal/platform/rbac': typeof PortalPlatformRbacRoute
  '/portal/platform/schema-drift': typeof PortalPlatformSchemaDriftRoute
  '/portal/platform/sdlc': typeof PortalPlatformSdlcRoute
  '/portal/platform/secrets': typeof PortalPlatformSecretsRoute
  '/portal/platform/security': typeof PortalPlatformSecurityRoute
  '/portal/platform/settings': typeof PortalPlatformSettingsRoute
  '/portal/platform/subscriptions': typeof PortalPlatformSubscriptionsRoute
  '/portal/platform/theme': typeof PortalPlatformThemeRoute
  '/portal/platform/tiers': typeof PortalPlatformTiersRoute
  '/portal/platform/users': typeof PortalPlatformUsersRoute
  '/portal/spaces/$spaceId': typeof PortalSpacesSpaceIdRouteWithChildren
  '/portal/spaces/new': typeof PortalSpacesNewRoute
  '/portal/workflows/canvas-demo': typeof PortalWorkflowsCanvasDemoRoute
  '/portal/workflows/definitions': typeof PortalWorkflowsDefinitionsRoute
  '/portal/workflows/dlq': typeof PortalWorkflowsDlqRoute
  '/portal/workflows/execute': typeof PortalWorkflowsExecuteRoute
  '/portal/workflows/executions': typeof PortalWorkflowsExecutionsRoute
  '/portal/workflows/projects': typeof PortalWorkflowsProjectsRoute
  '/portal/workflows/retry-failures': typeof PortalWorkflowsRetryFailuresRoute
  '/portal/workflows/templates': typeof PortalWorkflowsTemplatesRoute
  '/portal/workflows/topology': typeof PortalWorkflowsTopologyRoute
  '/portal/auth/unlock-account': typeof PortalAuthUnlockAccountRoute
  '/portal/auth/verify-email': typeof PortalAuthVerifyEmailRoute
  '/portal/invite/accept': typeof PortalInviteAcceptRoute
  '/portal/sign-in/verify': typeof PortalSignInVerifyRoute
  '/products/myapp/excel-addin-setup': typeof ProductsMyappExcelAddinSetupRoute
  '/portal/ai-content/': typeof PortalAiContentIndexRoute
  '/portal/apps/': typeof PortalAppsIndexRoute
  '/portal/automation/': typeof PortalAutomationIndexRoute
  '/portal/connectors/': typeof PortalConnectorsIndexRoute
  '/portal/ftp/': typeof PortalFtpIndexRoute
  '/portal/hr/': typeof PortalHrIndexRoute
  '/portal/knowledgebase-file/': typeof PortalKnowledgebaseFileIndexRoute
  '/portal/knowledgebase-sql/': typeof PortalKnowledgebaseSqlIndexRoute
  '/portal/learning/': typeof PortalLearningIndexRoute
  '/portal/lms/': typeof PortalLmsIndexRoute
  '/portal/messaging/': typeof PortalMessagingIndexRoute
  '/portal/myapp/': typeof PortalMyappIndexRoute
  '/portal/spaces/': typeof PortalSpacesIndexRoute
  '/portal/workflows/': typeof PortalWorkflowsIndexRoute
  '/forms/$slug/respond/success': typeof FormsSlugRespondSuccessRoute
  '/portal/connectors/$typeSlug/manage': typeof PortalConnectorsTypeSlugManageRoute
  '/portal/connectors/$typeSlug/new': typeof PortalConnectorsTypeSlugNewRoute
  '/portal/connectors/mysql/new': typeof PortalConnectorsMysqlNewRoute
  '/portal/connectors/sqlserver/new': typeof PortalConnectorsSqlserverNewRoute
  '/portal/hr/onboarding/$id': typeof PortalHrOnboardingIdRoute
  '/portal/knowledgebase-file/batches/$id': typeof PortalKnowledgebaseFileBatchesIdRoute
  '/portal/knowledgebase-file/documents/$id': typeof PortalKnowledgebaseFileDocumentsIdRoute
  '/portal/knowledgebase-sql/insight-reports/$slug': typeof PortalKnowledgebaseSqlInsightReportsSlugRoute
  '/portal/knowledgebase-sql/insight-reports/new': typeof PortalKnowledgebaseSqlInsightReportsNewRoute
  '/portal/learning/attempt/$attemptId': typeof PortalLearningAttemptAttemptIdRoute
  '/portal/learning/review/$attemptId': typeof PortalLearningReviewAttemptIdRoute
  '/portal/myapp/$tableId/edit': typeof PortalMyappTableIdEditRoute
  '/portal/myapp/$tableId/grid': typeof PortalMyappTableIdGridRoute
  '/portal/myapp/$tableId/kanban': typeof PortalMyappTableIdKanbanRoute
  '/portal/myapp/$tableId/permissions': typeof PortalMyappTableIdPermissionsRoute
  '/portal/myapp/$tableId/print': typeof PortalMyappTableIdPrintRoute
  '/portal/myapp/$tableId/report': typeof PortalMyappTableIdReportRoute
  '/portal/myapp/$tableId/submit': typeof PortalMyappTableIdSubmitRoute
  '/portal/platform/groups/$groupId': typeof PortalPlatformGroupsGroupIdRoute
  '/portal/spaces/$spaceId/edit': typeof PortalSpacesSpaceIdEditRoute
  '/portal/workflows/definitions/new': typeof PortalWorkflowsDefinitionsNewRoute
  '/portal/workflows/projects/$projectId': typeof PortalWorkflowsProjectsProjectIdRoute
  '/forms/$slug/respond/': typeof FormsSlugRespondIndexRoute
  '/portal/apps/$appSlug/': typeof PortalAppsAppSlugIndexRoute
  '/portal/apps/reporting/': typeof PortalAppsReportingIndexRoute
  '/portal/connectors/$typeSlug/': typeof PortalConnectorsTypeSlugIndexRoute
  '/portal/hr/allocations/': typeof PortalHrAllocationsIndexRoute
  '/portal/hr/employees/': typeof PortalHrEmployeesIndexRoute
  '/portal/hr/forecast/': typeof PortalHrForecastIndexRoute
  '/portal/hr/onboarding/': typeof PortalHrOnboardingIndexRoute
  '/portal/hr/rules/': typeof PortalHrRulesIndexRoute
  '/portal/hr/settings/': typeof PortalHrSettingsIndexRoute
  '/portal/knowledgebase-sql/insight-reports/': typeof PortalKnowledgebaseSqlInsightReportsIndexRoute
  '/portal/learning/review/': typeof PortalLearningReviewIndexRoute
  '/portal/myapp/$tableId/': typeof PortalMyappTableIdIndexRoute
  '/portal/spaces/$spaceId/': typeof PortalSpacesSpaceIdIndexRoute
  '/portal/apps/reporting/custom/$slug': typeof PortalAppsReportingCustomSlugRoute
  '/portal/apps/reporting/custom/new': typeof PortalAppsReportingCustomNewRoute
  '/portal/apps/reporting/datasources/$slug': typeof PortalAppsReportingDatasourcesSlugRoute
  '/portal/apps/reporting/datasources/new': typeof PortalAppsReportingDatasourcesNewRoute
  '/portal/workflows/definitions/$key/new-version': typeof PortalWorkflowsDefinitionsKeyNewVersionRoute
  '/portal/spaces/$spaceId/widget/$widgetId': typeof PortalSpacesSpaceIdWidgetWidgetIdRoute
  '/portal/apps/reporting/custom/': typeof PortalAppsReportingCustomIndexRoute
  '/portal/apps/reporting/datasources/': typeof PortalAppsReportingDatasourcesIndexRoute
  '/portal/apps/reporting/model/': typeof PortalAppsReportingModelIndexRoute
  '/portal/apps/reporting/custom/$slug/edit': typeof PortalAppsReportingCustomSlugEditRoute
  '/portal/apps/reporting/datasources/$slug/edit': typeof PortalAppsReportingDatasourcesSlugEditRoute
  '/portal/apps/reporting/custom/$slug/window': typeof PortalAppsReportingCustomSlugWindowRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/brand': typeof BrandRoute
  '/contact': typeof ContactRoute
  '/industries': typeof IndustriesRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/proof-of-concept': typeof ProofOfConceptRoute
  '/resources': typeof ResourcesRoute
  '/solutions': typeof SolutionsRoute
  '/status': typeof StatusRoute
  '/videos': typeof VideosRoute
  '/archive/home': typeof ArchiveHomeRoute
  '/archive/pricing': typeof ArchivePricingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/connectors/product': typeof ConnectorsProductRoute
  '/connectors/xero-case-study': typeof ConnectorsXeroCaseStudyRoute
  '/legal/data-processing': typeof LegalDataProcessingRoute
  '/legal/paia': typeof LegalPaiaRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/refund-policy': typeof LegalRefundPolicyRoute
  '/legal/terms-of-use': typeof LegalTermsOfUseRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboard/$token': typeof OnboardTokenRoute
  '/portal/asset-library': typeof PortalAssetLibraryRoute
  '/portal/catalogue-intelligence': typeof PortalCatalogueIntelligenceRoute
  '/portal/platform': typeof PortalPlatformRouteWithChildren
  '/portal/forgot-password': typeof PortalForgotPasswordRoute
  '/portal/help': typeof PortalHelpRoute
  '/portal/reset-password': typeof PortalResetPasswordRoute
  '/portal/sign-in': typeof PortalSignInRoute
  '/portal/sign-up': typeof PortalSignUpRoute
  '/preview/connector-flows': typeof PreviewConnectorFlowsRoute
  '/preview/ground-up-flow': typeof PreviewGroundUpFlowRoute
  '/preview/home-hero': typeof PreviewHomeHeroRoute
  '/preview/kb-heroes': typeof PreviewKbHeroesRoute
  '/preview/myapp-table-types': typeof PreviewMyappTableTypesRoute
  '/products/knowledge-base': typeof ProductsKnowledgeBaseRoute
  '/products/myapp': typeof ProductsMyappRoute
  '/connectors': typeof ConnectorsIndexRoute
  '/portal': typeof PortalIndexRoute
  '/portal/ai-content/history': typeof PortalAiContentHistoryRoute
  '/portal/apps/expense': typeof PortalAppsExpenseRoute
  '/portal/automation/agent-entitlements': typeof PortalAutomationAgentEntitlementsRoute
  '/portal/automation/audit': typeof PortalAutomationAuditRoute
  '/portal/automation/content-review': typeof PortalAutomationContentReviewRoute
  '/portal/automation/credentials': typeof PortalAutomationCredentialsRoute
  '/portal/automation/dashboard': typeof PortalAutomationDashboardRoute
  '/portal/automation/llm': typeof PortalAutomationLlmRoute
  '/portal/automation/mcp': typeof PortalAutomationMcpRoute
  '/portal/automation/monitoring': typeof PortalAutomationMonitoringRoute
  '/portal/automation/policies': typeof PortalAutomationPoliciesRoute
  '/portal/automation/skills': typeof PortalAutomationSkillsRoute
  '/portal/automation/webhooks': typeof PortalAutomationWebhooksRoute
  '/portal/automation/workflows': typeof PortalAutomationWorkflowsRoute
  '/portal/ftp/audit': typeof PortalFtpAuditRoute
  '/portal/ftp/connections': typeof PortalFtpConnectionsRoute
  '/portal/ftp/files': typeof PortalFtpFilesRoute
  '/portal/ftp/users': typeof PortalFtpUsersRoute
  '/portal/knowledgebase-file/batches': typeof PortalKnowledgebaseFileBatchesRouteWithChildren
  '/portal/knowledgebase-file/categories': typeof PortalKnowledgebaseFileCategoriesRoute
  '/portal/knowledgebase-file/category-review': typeof PortalKnowledgebaseFileCategoryReviewRoute
  '/portal/knowledgebase-file/documents': typeof PortalKnowledgebaseFileDocumentsRouteWithChildren
  '/portal/knowledgebase-file/labels': typeof PortalKnowledgebaseFileLabelsRoute
  '/portal/knowledgebase-file/query': typeof PortalKnowledgebaseFileQueryRoute
  '/portal/knowledgebase-file/templates': typeof PortalKnowledgebaseFileTemplatesRoute
  '/portal/knowledgebase-file/upload': typeof PortalKnowledgebaseFileUploadRoute
  '/portal/knowledgebase-sql/connect': typeof PortalKnowledgebaseSqlConnectRoute
  '/portal/knowledgebase-sql/data-sources': typeof PortalKnowledgebaseSqlDataSourcesRoute
  '/portal/knowledgebase-sql/glossary': typeof PortalKnowledgebaseSqlGlossaryRoute
  '/portal/knowledgebase-sql/query': typeof PortalKnowledgebaseSqlQueryRoute
  '/portal/knowledgebase-sql/quick-question': typeof PortalKnowledgebaseSqlQuickQuestionRoute
  '/portal/lms/assign': typeof PortalLmsAssignRoute
  '/portal/lms/author': typeof PortalLmsAuthorRoute
  '/portal/lms/curation': typeof PortalLmsCurationRoute
  '/portal/lms/cycles': typeof PortalLmsCyclesRoute
  '/portal/lms/leaderboard': typeof PortalLmsLeaderboardRoute
  '/portal/messaging/inbox': typeof PortalMessagingInboxRoute
  '/portal/messaging/templates': typeof PortalMessagingTemplatesRoute
  '/portal/messaging/whatsapp-setup': typeof PortalMessagingWhatsappSetupRoute
  '/portal/myapp/apps': typeof PortalMyappAppsRoute
  '/portal/myapp/areas': typeof PortalMyappAreasRoute
  '/portal/myapp/bridge': typeof PortalMyappBridgeRoute
  '/portal/myapp/tables': typeof PortalMyappTablesRoute
  '/portal/organisation/categories': typeof PortalOrganisationCategoriesRoute
  '/portal/organisation/members': typeof PortalOrganisationMembersRoute
  '/portal/organisation/settings': typeof PortalOrganisationSettingsRoute
  '/portal/organisation/theme': typeof PortalOrganisationThemeRoute
  '/portal/platform/api-keys': typeof PortalPlatformApiKeysRoute
  '/portal/platform/billing': typeof PortalPlatformBillingRoute
  '/portal/platform/billing-overview': typeof PortalPlatformBillingOverviewRoute
  '/portal/platform/categories': typeof PortalPlatformCategoriesRoute
  '/portal/platform/chart-settings': typeof PortalPlatformChartSettingsRoute
  '/portal/platform/client-onboarding': typeof PortalPlatformClientOnboardingRoute
  '/portal/platform/connector-enrichment': typeof PortalPlatformConnectorEnrichmentRoute
  '/portal/platform/connectors': typeof PortalPlatformConnectorsRoute
  '/portal/platform/discounts': typeof PortalPlatformDiscountsRoute
  '/portal/platform/groups': typeof PortalPlatformGroupsRoute
  '/portal/platform/inbound-dead-letters': typeof PortalPlatformInboundDeadLettersRoute
  '/portal/platform/infrastructure': typeof PortalPlatformInfrastructureRoute
  '/portal/platform/maintenance': typeof PortalPlatformMaintenanceRoute
  '/portal/platform/monitoring': typeof PortalPlatformMonitoringRoute
  '/portal/platform/object-permissions': typeof PortalPlatformObjectPermissionsRoute
  '/portal/platform/organisations': typeof PortalPlatformOrganisationsRoute
  '/portal/platform/orphaned-schedules': typeof PortalPlatformOrphanedSchedulesRoute
  '/portal/platform/pipelines': typeof PortalPlatformPipelinesRoute
  '/portal/platform/pricing': typeof PortalPlatformPricingRoute
  '/portal/platform/products': typeof PortalPlatformProductsRoute
  '/portal/platform/profile': typeof PortalPlatformProfileRoute
  '/portal/platform/rbac': typeof PortalPlatformRbacRoute
  '/portal/platform/schema-drift': typeof PortalPlatformSchemaDriftRoute
  '/portal/platform/sdlc': typeof PortalPlatformSdlcRoute
  '/portal/platform/secrets': typeof PortalPlatformSecretsRoute
  '/portal/platform/security': typeof PortalPlatformSecurityRoute
  '/portal/platform/settings': typeof PortalPlatformSettingsRoute
  '/portal/platform/subscriptions': typeof PortalPlatformSubscriptionsRoute
  '/portal/platform/theme': typeof PortalPlatformThemeRoute
  '/portal/platform/tiers': typeof PortalPlatformTiersRoute
  '/portal/platform/users': typeof PortalPlatformUsersRoute
  '/portal/spaces/new': typeof PortalSpacesNewRoute
  '/portal/workflows/canvas-demo': typeof PortalWorkflowsCanvasDemoRoute
  '/portal/workflows/definitions': typeof PortalWorkflowsDefinitionsRoute
  '/portal/workflows/dlq': typeof PortalWorkflowsDlqRoute
  '/portal/workflows/execute': typeof PortalWorkflowsExecuteRoute
  '/portal/workflows/executions': typeof PortalWorkflowsExecutionsRoute
  '/portal/workflows/projects': typeof PortalWorkflowsProjectsRoute
  '/portal/workflows/retry-failures': typeof PortalWorkflowsRetryFailuresRoute
  '/portal/workflows/templates': typeof PortalWorkflowsTemplatesRoute
  '/portal/workflows/topology': typeof PortalWorkflowsTopologyRoute
  '/portal/auth/unlock-account': typeof PortalAuthUnlockAccountRoute
  '/portal/auth/verify-email': typeof PortalAuthVerifyEmailRoute
  '/portal/invite/accept': typeof PortalInviteAcceptRoute
  '/portal/sign-in/verify': typeof PortalSignInVerifyRoute
  '/products/myapp/excel-addin-setup': typeof ProductsMyappExcelAddinSetupRoute
  '/portal/ai-content': typeof PortalAiContentIndexRoute
  '/portal/apps': typeof PortalAppsIndexRoute
  '/portal/automation': typeof PortalAutomationIndexRoute
  '/portal/connectors': typeof PortalConnectorsIndexRoute
  '/portal/ftp': typeof PortalFtpIndexRoute
  '/portal/hr': typeof PortalHrIndexRoute
  '/portal/knowledgebase-file': typeof PortalKnowledgebaseFileIndexRoute
  '/portal/knowledgebase-sql': typeof PortalKnowledgebaseSqlIndexRoute
  '/portal/learning': typeof PortalLearningIndexRoute
  '/portal/lms': typeof PortalLmsIndexRoute
  '/portal/messaging': typeof PortalMessagingIndexRoute
  '/portal/myapp': typeof PortalMyappIndexRoute
  '/portal/spaces': typeof PortalSpacesIndexRoute
  '/portal/workflows': typeof PortalWorkflowsIndexRoute
  '/forms/$slug/respond/success': typeof FormsSlugRespondSuccessRoute
  '/portal/connectors/$typeSlug/manage': typeof PortalConnectorsTypeSlugManageRoute
  '/portal/connectors/$typeSlug/new': typeof PortalConnectorsTypeSlugNewRoute
  '/portal/connectors/mysql/new': typeof PortalConnectorsMysqlNewRoute
  '/portal/connectors/sqlserver/new': typeof PortalConnectorsSqlserverNewRoute
  '/portal/hr/onboarding/$id': typeof PortalHrOnboardingIdRoute
  '/portal/knowledgebase-file/batches/$id': typeof PortalKnowledgebaseFileBatchesIdRoute
  '/portal/knowledgebase-file/documents/$id': typeof PortalKnowledgebaseFileDocumentsIdRoute
  '/portal/knowledgebase-sql/insight-reports/$slug': typeof PortalKnowledgebaseSqlInsightReportsSlugRoute
  '/portal/knowledgebase-sql/insight-reports/new': typeof PortalKnowledgebaseSqlInsightReportsNewRoute
  '/portal/learning/attempt/$attemptId': typeof PortalLearningAttemptAttemptIdRoute
  '/portal/learning/review/$attemptId': typeof PortalLearningReviewAttemptIdRoute
  '/portal/myapp/$tableId/edit': typeof PortalMyappTableIdEditRoute
  '/portal/myapp/$tableId/grid': typeof PortalMyappTableIdGridRoute
  '/portal/myapp/$tableId/kanban': typeof PortalMyappTableIdKanbanRoute
  '/portal/myapp/$tableId/permissions': typeof PortalMyappTableIdPermissionsRoute
  '/portal/myapp/$tableId/print': typeof PortalMyappTableIdPrintRoute
  '/portal/myapp/$tableId/report': typeof PortalMyappTableIdReportRoute
  '/portal/myapp/$tableId/submit': typeof PortalMyappTableIdSubmitRoute
  '/portal/platform/groups/$groupId': typeof PortalPlatformGroupsGroupIdRoute
  '/portal/spaces/$spaceId/edit': typeof PortalSpacesSpaceIdEditRoute
  '/portal/workflows/definitions/new': typeof PortalWorkflowsDefinitionsNewRoute
  '/portal/workflows/projects/$projectId': typeof PortalWorkflowsProjectsProjectIdRoute
  '/forms/$slug/respond': typeof FormsSlugRespondIndexRoute
  '/portal/apps/$appSlug': typeof PortalAppsAppSlugIndexRoute
  '/portal/apps/reporting': typeof PortalAppsReportingIndexRoute
  '/portal/connectors/$typeSlug': typeof PortalConnectorsTypeSlugIndexRoute
  '/portal/hr/allocations': typeof PortalHrAllocationsIndexRoute
  '/portal/hr/employees': typeof PortalHrEmployeesIndexRoute
  '/portal/hr/forecast': typeof PortalHrForecastIndexRoute
  '/portal/hr/onboarding': typeof PortalHrOnboardingIndexRoute
  '/portal/hr/rules': typeof PortalHrRulesIndexRoute
  '/portal/hr/settings': typeof PortalHrSettingsIndexRoute
  '/portal/knowledgebase-sql/insight-reports': typeof PortalKnowledgebaseSqlInsightReportsIndexRoute
  '/portal/learning/review': typeof PortalLearningReviewIndexRoute
  '/portal/myapp/$tableId': typeof PortalMyappTableIdIndexRoute
  '/portal/spaces/$spaceId': typeof PortalSpacesSpaceIdIndexRoute
  '/portal/apps/reporting/custom/$slug': typeof PortalAppsReportingCustomSlugRoute
  '/portal/apps/reporting/custom/new': typeof PortalAppsReportingCustomNewRoute
  '/portal/apps/reporting/datasources/$slug': typeof PortalAppsReportingDatasourcesSlugRoute
  '/portal/apps/reporting/datasources/new': typeof PortalAppsReportingDatasourcesNewRoute
  '/portal/workflows/definitions/$key/new-version': typeof PortalWorkflowsDefinitionsKeyNewVersionRoute
  '/portal/spaces/$spaceId/widget/$widgetId': typeof PortalSpacesSpaceIdWidgetWidgetIdRoute
  '/portal/apps/reporting/custom': typeof PortalAppsReportingCustomIndexRoute
  '/portal/apps/reporting/datasources': typeof PortalAppsReportingDatasourcesIndexRoute
  '/portal/apps/reporting/model': typeof PortalAppsReportingModelIndexRoute
  '/portal/apps/reporting/custom/$slug/edit': typeof PortalAppsReportingCustomSlugEditRoute
  '/portal/apps/reporting/datasources/$slug/edit': typeof PortalAppsReportingDatasourcesSlugEditRoute
  '/portal/apps/reporting/custom/$slug/window': typeof PortalAppsReportingCustomSlugWindowRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/brand': typeof BrandRoute
  '/connectors': typeof ConnectorsRouteWithChildren
  '/contact': typeof ContactRoute
  '/industries': typeof IndustriesRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/pricing': typeof PricingRoute
  '/proof-of-concept': typeof ProofOfConceptRoute
  '/resources': typeof ResourcesRoute
  '/solutions': typeof SolutionsRoute
  '/status': typeof StatusRoute
  '/videos': typeof VideosRoute
  '/archive/home': typeof ArchiveHomeRoute
  '/archive/pricing': typeof ArchivePricingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/connectors/product': typeof ConnectorsProductRoute
  '/connectors/xero-case-study': typeof ConnectorsXeroCaseStudyRoute
  '/legal/data-processing': typeof LegalDataProcessingRoute
  '/legal/paia': typeof LegalPaiaRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/refund-policy': typeof LegalRefundPolicyRoute
  '/legal/terms-of-use': typeof LegalTermsOfUseRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboard/$token': typeof OnboardTokenRoute
  '/portal/ai-content': typeof PortalAiContentRouteWithChildren
  '/portal/asset-library': typeof PortalAssetLibraryRoute
  '/portal/automation': typeof PortalAutomationRouteWithChildren
  '/portal/catalogue-intelligence': typeof PortalCatalogueIntelligenceRoute
  '/portal/ftp': typeof PortalFtpRouteWithChildren
  '/portal/hr': typeof PortalHrRouteWithChildren
  '/portal/knowledgebase-file': typeof PortalKnowledgebaseFileRouteWithChildren
  '/portal/knowledgebase-sql': typeof PortalKnowledgebaseSqlRouteWithChildren
  '/portal/learning': typeof PortalLearningRouteWithChildren
  '/portal/lms': typeof PortalLmsRouteWithChildren
  '/portal/messaging': typeof PortalMessagingRouteWithChildren
  '/portal/myapp': typeof PortalMyappRouteWithChildren
  '/portal/platform': typeof PortalPlatformRouteWithChildren
  '/portal/workflows': typeof PortalWorkflowsRouteWithChildren
  '/portal_/forgot-password': typeof PortalForgotPasswordRoute
  '/portal_/help': typeof PortalHelpRoute
  '/portal_/reset-password': typeof PortalResetPasswordRoute
  '/portal_/sign-in': typeof PortalSignInRoute
  '/portal_/sign-up': typeof PortalSignUpRoute
  '/preview/connector-flows': typeof PreviewConnectorFlowsRoute
  '/preview/ground-up-flow': typeof PreviewGroundUpFlowRoute
  '/preview/home-hero': typeof PreviewHomeHeroRoute
  '/preview/kb-heroes': typeof PreviewKbHeroesRoute
  '/preview/myapp-table-types': typeof PreviewMyappTableTypesRoute
  '/products/knowledge-base': typeof ProductsKnowledgeBaseRoute
  '/products/myapp': typeof ProductsMyappRoute
  '/connectors/': typeof ConnectorsIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/forms/$slug/respond': typeof FormsSlugRespondRouteWithChildren
  '/portal/ai-content/history': typeof PortalAiContentHistoryRoute
  '/portal/apps/expense': typeof PortalAppsExpenseRoute
  '/portal/automation/agent-entitlements': typeof PortalAutomationAgentEntitlementsRoute
  '/portal/automation/audit': typeof PortalAutomationAuditRoute
  '/portal/automation/content-review': typeof PortalAutomationContentReviewRoute
  '/portal/automation/credentials': typeof PortalAutomationCredentialsRoute
  '/portal/automation/dashboard': typeof PortalAutomationDashboardRoute
  '/portal/automation/llm': typeof PortalAutomationLlmRoute
  '/portal/automation/mcp': typeof PortalAutomationMcpRoute
  '/portal/automation/monitoring': typeof PortalAutomationMonitoringRoute
  '/portal/automation/policies': typeof PortalAutomationPoliciesRoute
  '/portal/automation/skills': typeof PortalAutomationSkillsRoute
  '/portal/automation/webhooks': typeof PortalAutomationWebhooksRoute
  '/portal/automation/workflows': typeof PortalAutomationWorkflowsRoute
  '/portal/ftp/audit': typeof PortalFtpAuditRoute
  '/portal/ftp/connections': typeof PortalFtpConnectionsRoute
  '/portal/ftp/files': typeof PortalFtpFilesRoute
  '/portal/ftp/users': typeof PortalFtpUsersRoute
  '/portal/knowledgebase-file/batches': typeof PortalKnowledgebaseFileBatchesRouteWithChildren
  '/portal/knowledgebase-file/categories': typeof PortalKnowledgebaseFileCategoriesRoute
  '/portal/knowledgebase-file/category-review': typeof PortalKnowledgebaseFileCategoryReviewRoute
  '/portal/knowledgebase-file/documents': typeof PortalKnowledgebaseFileDocumentsRouteWithChildren
  '/portal/knowledgebase-file/labels': typeof PortalKnowledgebaseFileLabelsRoute
  '/portal/knowledgebase-file/query': typeof PortalKnowledgebaseFileQueryRoute
  '/portal/knowledgebase-file/templates': typeof PortalKnowledgebaseFileTemplatesRoute
  '/portal/knowledgebase-file/upload': typeof PortalKnowledgebaseFileUploadRoute
  '/portal/knowledgebase-sql/connect': typeof PortalKnowledgebaseSqlConnectRoute
  '/portal/knowledgebase-sql/data-sources': typeof PortalKnowledgebaseSqlDataSourcesRoute
  '/portal/knowledgebase-sql/glossary': typeof PortalKnowledgebaseSqlGlossaryRoute
  '/portal/knowledgebase-sql/query': typeof PortalKnowledgebaseSqlQueryRoute
  '/portal/knowledgebase-sql/quick-question': typeof PortalKnowledgebaseSqlQuickQuestionRoute
  '/portal/lms/assign': typeof PortalLmsAssignRoute
  '/portal/lms/author': typeof PortalLmsAuthorRoute
  '/portal/lms/curation': typeof PortalLmsCurationRoute
  '/portal/lms/cycles': typeof PortalLmsCyclesRoute
  '/portal/lms/leaderboard': typeof PortalLmsLeaderboardRoute
  '/portal/messaging/inbox': typeof PortalMessagingInboxRoute
  '/portal/messaging/templates': typeof PortalMessagingTemplatesRoute
  '/portal/messaging/whatsapp-setup': typeof PortalMessagingWhatsappSetupRoute
  '/portal/myapp/apps': typeof PortalMyappAppsRoute
  '/portal/myapp/areas': typeof PortalMyappAreasRoute
  '/portal/myapp/bridge': typeof PortalMyappBridgeRoute
  '/portal/myapp/tables': typeof PortalMyappTablesRoute
  '/portal/organisation/categories': typeof PortalOrganisationCategoriesRoute
  '/portal/organisation/members': typeof PortalOrganisationMembersRoute
  '/portal/organisation/settings': typeof PortalOrganisationSettingsRoute
  '/portal/organisation/theme': typeof PortalOrganisationThemeRoute
  '/portal/platform/api-keys': typeof PortalPlatformApiKeysRoute
  '/portal/platform/billing': typeof PortalPlatformBillingRoute
  '/portal/platform/billing-overview': typeof PortalPlatformBillingOverviewRoute
  '/portal/platform/categories': typeof PortalPlatformCategoriesRoute
  '/portal/platform/chart-settings': typeof PortalPlatformChartSettingsRoute
  '/portal/platform/client-onboarding': typeof PortalPlatformClientOnboardingRoute
  '/portal/platform/connector-enrichment': typeof PortalPlatformConnectorEnrichmentRoute
  '/portal/platform/connectors': typeof PortalPlatformConnectorsRoute
  '/portal/platform/discounts': typeof PortalPlatformDiscountsRoute
  '/portal/platform/groups': typeof PortalPlatformGroupsRoute
  '/portal/platform/inbound-dead-letters': typeof PortalPlatformInboundDeadLettersRoute
  '/portal/platform/infrastructure': typeof PortalPlatformInfrastructureRoute
  '/portal/platform/maintenance': typeof PortalPlatformMaintenanceRoute
  '/portal/platform/monitoring': typeof PortalPlatformMonitoringRoute
  '/portal/platform/object-permissions': typeof PortalPlatformObjectPermissionsRoute
  '/portal/platform/organisations': typeof PortalPlatformOrganisationsRoute
  '/portal/platform/orphaned-schedules': typeof PortalPlatformOrphanedSchedulesRoute
  '/portal/platform/pipelines': typeof PortalPlatformPipelinesRoute
  '/portal/platform/pricing': typeof PortalPlatformPricingRoute
  '/portal/platform/products': typeof PortalPlatformProductsRoute
  '/portal/platform/profile': typeof PortalPlatformProfileRoute
  '/portal/platform/rbac': typeof PortalPlatformRbacRoute
  '/portal/platform/schema-drift': typeof PortalPlatformSchemaDriftRoute
  '/portal/platform/sdlc': typeof PortalPlatformSdlcRoute
  '/portal/platform/secrets': typeof PortalPlatformSecretsRoute
  '/portal/platform/security': typeof PortalPlatformSecurityRoute
  '/portal/platform/settings': typeof PortalPlatformSettingsRoute
  '/portal/platform/subscriptions': typeof PortalPlatformSubscriptionsRoute
  '/portal/platform/theme': typeof PortalPlatformThemeRoute
  '/portal/platform/tiers': typeof PortalPlatformTiersRoute
  '/portal/platform/users': typeof PortalPlatformUsersRoute
  '/portal/spaces/$spaceId': typeof PortalSpacesSpaceIdRouteWithChildren
  '/portal/spaces/new': typeof PortalSpacesNewRoute
  '/portal/workflows/canvas-demo': typeof PortalWorkflowsCanvasDemoRoute
  '/portal/workflows/definitions': typeof PortalWorkflowsDefinitionsRoute
  '/portal/workflows/dlq': typeof PortalWorkflowsDlqRoute
  '/portal/workflows/execute': typeof PortalWorkflowsExecuteRoute
  '/portal/workflows/executions': typeof PortalWorkflowsExecutionsRoute
  '/portal/workflows/projects': typeof PortalWorkflowsProjectsRoute
  '/portal/workflows/retry-failures': typeof PortalWorkflowsRetryFailuresRoute
  '/portal/workflows/templates': typeof PortalWorkflowsTemplatesRoute
  '/portal/workflows/topology': typeof PortalWorkflowsTopologyRoute
  '/portal_/auth/unlock-account': typeof PortalAuthUnlockAccountRoute
  '/portal_/auth/verify-email': typeof PortalAuthVerifyEmailRoute
  '/portal_/invite/accept': typeof PortalInviteAcceptRoute
  '/portal_/sign-in_/verify': typeof PortalSignInVerifyRoute
  '/products/myapp_/excel-addin-setup': typeof ProductsMyappExcelAddinSetupRoute
  '/portal/ai-content/': typeof PortalAiContentIndexRoute
  '/portal/apps/': typeof PortalAppsIndexRoute
  '/portal/automation/': typeof PortalAutomationIndexRoute
  '/portal/connectors/': typeof PortalConnectorsIndexRoute
  '/portal/ftp/': typeof PortalFtpIndexRoute
  '/portal/hr/': typeof PortalHrIndexRoute
  '/portal/knowledgebase-file/': typeof PortalKnowledgebaseFileIndexRoute
  '/portal/knowledgebase-sql/': typeof PortalKnowledgebaseSqlIndexRoute
  '/portal/learning/': typeof PortalLearningIndexRoute
  '/portal/lms/': typeof PortalLmsIndexRoute
  '/portal/messaging/': typeof PortalMessagingIndexRoute
  '/portal/myapp/': typeof PortalMyappIndexRoute
  '/portal/spaces/': typeof PortalSpacesIndexRoute
  '/portal/workflows/': typeof PortalWorkflowsIndexRoute
  '/forms/$slug/respond/success': typeof FormsSlugRespondSuccessRoute
  '/portal/connectors/$typeSlug/manage': typeof PortalConnectorsTypeSlugManageRoute
  '/portal/connectors/$typeSlug/new': typeof PortalConnectorsTypeSlugNewRoute
  '/portal/connectors/mysql/new': typeof PortalConnectorsMysqlNewRoute
  '/portal/connectors/sqlserver/new': typeof PortalConnectorsSqlserverNewRoute
  '/portal/hr/onboarding/$id': typeof PortalHrOnboardingIdRoute
  '/portal/knowledgebase-file/batches/$id': typeof PortalKnowledgebaseFileBatchesIdRoute
  '/portal/knowledgebase-file/documents/$id': typeof PortalKnowledgebaseFileDocumentsIdRoute
  '/portal/knowledgebase-sql/insight-reports/$slug': typeof PortalKnowledgebaseSqlInsightReportsSlugRoute
  '/portal/knowledgebase-sql/insight-reports/new': typeof PortalKnowledgebaseSqlInsightReportsNewRoute
  '/portal/learning/attempt/$attemptId': typeof PortalLearningAttemptAttemptIdRoute
  '/portal/learning/review/$attemptId': typeof PortalLearningReviewAttemptIdRoute
  '/portal/myapp/$tableId/edit': typeof PortalMyappTableIdEditRoute
  '/portal/myapp/$tableId/grid': typeof PortalMyappTableIdGridRoute
  '/portal/myapp/$tableId/kanban': typeof PortalMyappTableIdKanbanRoute
  '/portal/myapp/$tableId/permissions': typeof PortalMyappTableIdPermissionsRoute
  '/portal/myapp/$tableId/print': typeof PortalMyappTableIdPrintRoute
  '/portal/myapp/$tableId/report': typeof PortalMyappTableIdReportRoute
  '/portal/myapp/$tableId/submit': typeof PortalMyappTableIdSubmitRoute
  '/portal/platform/groups_/$groupId': typeof PortalPlatformGroupsGroupIdRoute
  '/portal/spaces/$spaceId/edit': typeof PortalSpacesSpaceIdEditRoute
  '/portal/workflows/definitions_/new': typeof PortalWorkflowsDefinitionsNewRoute
  '/portal/workflows/projects_/$projectId': typeof PortalWorkflowsProjectsProjectIdRoute
  '/forms/$slug/respond/': typeof FormsSlugRespondIndexRoute
  '/portal/apps/$appSlug/': typeof PortalAppsAppSlugIndexRoute
  '/portal/apps/reporting/': typeof PortalAppsReportingIndexRoute
  '/portal/connectors/$typeSlug/': typeof PortalConnectorsTypeSlugIndexRoute
  '/portal/hr/allocations/': typeof PortalHrAllocationsIndexRoute
  '/portal/hr/employees/': typeof PortalHrEmployeesIndexRoute
  '/portal/hr/forecast/': typeof PortalHrForecastIndexRoute
  '/portal/hr/onboarding/': typeof PortalHrOnboardingIndexRoute
  '/portal/hr/rules/': typeof PortalHrRulesIndexRoute
  '/portal/hr/settings/': typeof PortalHrSettingsIndexRoute
  '/portal/knowledgebase-sql/insight-reports/': typeof PortalKnowledgebaseSqlInsightReportsIndexRoute
  '/portal/learning/review/': typeof PortalLearningReviewIndexRoute
  '/portal/myapp/$tableId/': typeof PortalMyappTableIdIndexRoute
  '/portal/spaces/$spaceId/': typeof PortalSpacesSpaceIdIndexRoute
  '/portal/apps/reporting/custom/$slug': typeof PortalAppsReportingCustomSlugRoute
  '/portal/apps/reporting/custom/new': typeof PortalAppsReportingCustomNewRoute
  '/portal/apps/reporting/datasources/$slug': typeof PortalAppsReportingDatasourcesSlugRoute
  '/portal/apps/reporting/datasources/new': typeof PortalAppsReportingDatasourcesNewRoute
  '/portal/workflows/definitions_/$key/new-version': typeof PortalWorkflowsDefinitionsKeyNewVersionRoute
  '/portal_/spaces/$spaceId/widget/$widgetId': typeof PortalSpacesSpaceIdWidgetWidgetIdRoute
  '/portal/apps/reporting/custom/': typeof PortalAppsReportingCustomIndexRoute
  '/portal/apps/reporting/datasources/': typeof PortalAppsReportingDatasourcesIndexRoute
  '/portal/apps/reporting/model/': typeof PortalAppsReportingModelIndexRoute
  '/portal/apps/reporting/custom/$slug_/edit': typeof PortalAppsReportingCustomSlugEditRoute
  '/portal/apps/reporting/datasources/$slug_/edit': typeof PortalAppsReportingDatasourcesSlugEditRoute
  '/portal_/apps/reporting/custom/$slug/window': typeof PortalAppsReportingCustomSlugWindowRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/brand'
    | '/connectors'
    | '/contact'
    | '/industries'
    | '/login'
    | '/portal'
    | '/pricing'
    | '/proof-of-concept'
    | '/resources'
    | '/solutions'
    | '/status'
    | '/videos'
    | '/archive/home'
    | '/archive/pricing'
    | '/auth/callback'
    | '/connectors/product'
    | '/connectors/xero-case-study'
    | '/legal/data-processing'
    | '/legal/paia'
    | '/legal/privacy'
    | '/legal/refund-policy'
    | '/legal/terms-of-use'
    | '/oauth/consent'
    | '/onboard/$token'
    | '/portal/ai-content'
    | '/portal/asset-library'
    | '/portal/automation'
    | '/portal/catalogue-intelligence'
    | '/portal/ftp'
    | '/portal/hr'
    | '/portal/knowledgebase-file'
    | '/portal/knowledgebase-sql'
    | '/portal/learning'
    | '/portal/lms'
    | '/portal/messaging'
    | '/portal/myapp'
    | '/portal/platform'
    | '/portal/workflows'
    | '/portal/forgot-password'
    | '/portal/help'
    | '/portal/reset-password'
    | '/portal/sign-in'
    | '/portal/sign-up'
    | '/preview/connector-flows'
    | '/preview/ground-up-flow'
    | '/preview/home-hero'
    | '/preview/kb-heroes'
    | '/preview/myapp-table-types'
    | '/products/knowledge-base'
    | '/products/myapp'
    | '/connectors/'
    | '/portal/'
    | '/forms/$slug/respond'
    | '/portal/ai-content/history'
    | '/portal/apps/expense'
    | '/portal/automation/agent-entitlements'
    | '/portal/automation/audit'
    | '/portal/automation/content-review'
    | '/portal/automation/credentials'
    | '/portal/automation/dashboard'
    | '/portal/automation/llm'
    | '/portal/automation/mcp'
    | '/portal/automation/monitoring'
    | '/portal/automation/policies'
    | '/portal/automation/skills'
    | '/portal/automation/webhooks'
    | '/portal/automation/workflows'
    | '/portal/ftp/audit'
    | '/portal/ftp/connections'
    | '/portal/ftp/files'
    | '/portal/ftp/users'
    | '/portal/knowledgebase-file/batches'
    | '/portal/knowledgebase-file/categories'
    | '/portal/knowledgebase-file/category-review'
    | '/portal/knowledgebase-file/documents'
    | '/portal/knowledgebase-file/labels'
    | '/portal/knowledgebase-file/query'
    | '/portal/knowledgebase-file/templates'
    | '/portal/knowledgebase-file/upload'
    | '/portal/knowledgebase-sql/connect'
    | '/portal/knowledgebase-sql/data-sources'
    | '/portal/knowledgebase-sql/glossary'
    | '/portal/knowledgebase-sql/query'
    | '/portal/knowledgebase-sql/quick-question'
    | '/portal/lms/assign'
    | '/portal/lms/author'
    | '/portal/lms/curation'
    | '/portal/lms/cycles'
    | '/portal/lms/leaderboard'
    | '/portal/messaging/inbox'
    | '/portal/messaging/templates'
    | '/portal/messaging/whatsapp-setup'
    | '/portal/myapp/apps'
    | '/portal/myapp/areas'
    | '/portal/myapp/bridge'
    | '/portal/myapp/tables'
    | '/portal/organisation/categories'
    | '/portal/organisation/members'
    | '/portal/organisation/settings'
    | '/portal/organisation/theme'
    | '/portal/platform/api-keys'
    | '/portal/platform/billing'
    | '/portal/platform/billing-overview'
    | '/portal/platform/categories'
    | '/portal/platform/chart-settings'
    | '/portal/platform/client-onboarding'
    | '/portal/platform/connector-enrichment'
    | '/portal/platform/connectors'
    | '/portal/platform/discounts'
    | '/portal/platform/groups'
    | '/portal/platform/inbound-dead-letters'
    | '/portal/platform/infrastructure'
    | '/portal/platform/maintenance'
    | '/portal/platform/monitoring'
    | '/portal/platform/object-permissions'
    | '/portal/platform/organisations'
    | '/portal/platform/orphaned-schedules'
    | '/portal/platform/pipelines'
    | '/portal/platform/pricing'
    | '/portal/platform/products'
    | '/portal/platform/profile'
    | '/portal/platform/rbac'
    | '/portal/platform/schema-drift'
    | '/portal/platform/sdlc'
    | '/portal/platform/secrets'
    | '/portal/platform/security'
    | '/portal/platform/settings'
    | '/portal/platform/subscriptions'
    | '/portal/platform/theme'
    | '/portal/platform/tiers'
    | '/portal/platform/users'
    | '/portal/spaces/$spaceId'
    | '/portal/spaces/new'
    | '/portal/workflows/canvas-demo'
    | '/portal/workflows/definitions'
    | '/portal/workflows/dlq'
    | '/portal/workflows/execute'
    | '/portal/workflows/executions'
    | '/portal/workflows/projects'
    | '/portal/workflows/retry-failures'
    | '/portal/workflows/templates'
    | '/portal/workflows/topology'
    | '/portal/auth/unlock-account'
    | '/portal/auth/verify-email'
    | '/portal/invite/accept'
    | '/portal/sign-in/verify'
    | '/products/myapp/excel-addin-setup'
    | '/portal/ai-content/'
    | '/portal/apps/'
    | '/portal/automation/'
    | '/portal/connectors/'
    | '/portal/ftp/'
    | '/portal/hr/'
    | '/portal/knowledgebase-file/'
    | '/portal/knowledgebase-sql/'
    | '/portal/learning/'
    | '/portal/lms/'
    | '/portal/messaging/'
    | '/portal/myapp/'
    | '/portal/spaces/'
    | '/portal/workflows/'
    | '/forms/$slug/respond/success'
    | '/portal/connectors/$typeSlug/manage'
    | '/portal/connectors/$typeSlug/new'
    | '/portal/connectors/mysql/new'
    | '/portal/connectors/sqlserver/new'
    | '/portal/hr/onboarding/$id'
    | '/portal/knowledgebase-file/batches/$id'
    | '/portal/knowledgebase-file/documents/$id'
    | '/portal/knowledgebase-sql/insight-reports/$slug'
    | '/portal/knowledgebase-sql/insight-reports/new'
    | '/portal/learning/attempt/$attemptId'
    | '/portal/learning/review/$attemptId'
    | '/portal/myapp/$tableId/edit'
    | '/portal/myapp/$tableId/grid'
    | '/portal/myapp/$tableId/kanban'
    | '/portal/myapp/$tableId/permissions'
    | '/portal/myapp/$tableId/print'
    | '/portal/myapp/$tableId/report'
    | '/portal/myapp/$tableId/submit'
    | '/portal/platform/groups/$groupId'
    | '/portal/spaces/$spaceId/edit'
    | '/portal/workflows/definitions/new'
    | '/portal/workflows/projects/$projectId'
    | '/forms/$slug/respond/'
    | '/portal/apps/$appSlug/'
    | '/portal/apps/reporting/'
    | '/portal/connectors/$typeSlug/'
    | '/portal/hr/allocations/'
    | '/portal/hr/employees/'
    | '/portal/hr/forecast/'
    | '/portal/hr/onboarding/'
    | '/portal/hr/rules/'
    | '/portal/hr/settings/'
    | '/portal/knowledgebase-sql/insight-reports/'
    | '/portal/learning/review/'
    | '/portal/myapp/$tableId/'
    | '/portal/spaces/$spaceId/'
    | '/portal/apps/reporting/custom/$slug'
    | '/portal/apps/reporting/custom/new'
    | '/portal/apps/reporting/datasources/$slug'
    | '/portal/apps/reporting/datasources/new'
    | '/portal/workflows/definitions/$key/new-version'
    | '/portal/spaces/$spaceId/widget/$widgetId'
    | '/portal/apps/reporting/custom/'
    | '/portal/apps/reporting/datasources/'
    | '/portal/apps/reporting/model/'
    | '/portal/apps/reporting/custom/$slug/edit'
    | '/portal/apps/reporting/datasources/$slug/edit'
    | '/portal/apps/reporting/custom/$slug/window'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/brand'
    | '/contact'
    | '/industries'
    | '/login'
    | '/pricing'
    | '/proof-of-concept'
    | '/resources'
    | '/solutions'
    | '/status'
    | '/videos'
    | '/archive/home'
    | '/archive/pricing'
    | '/auth/callback'
    | '/connectors/product'
    | '/connectors/xero-case-study'
    | '/legal/data-processing'
    | '/legal/paia'
    | '/legal/privacy'
    | '/legal/refund-policy'
    | '/legal/terms-of-use'
    | '/oauth/consent'
    | '/onboard/$token'
    | '/portal/asset-library'
    | '/portal/catalogue-intelligence'
    | '/portal/platform'
    | '/portal/forgot-password'
    | '/portal/help'
    | '/portal/reset-password'
    | '/portal/sign-in'
    | '/portal/sign-up'
    | '/preview/connector-flows'
    | '/preview/ground-up-flow'
    | '/preview/home-hero'
    | '/preview/kb-heroes'
    | '/preview/myapp-table-types'
    | '/products/knowledge-base'
    | '/products/myapp'
    | '/connectors'
    | '/portal'
    | '/portal/ai-content/history'
    | '/portal/apps/expense'
    | '/portal/automation/agent-entitlements'
    | '/portal/automation/audit'
    | '/portal/automation/content-review'
    | '/portal/automation/credentials'
    | '/portal/automation/dashboard'
    | '/portal/automation/llm'
    | '/portal/automation/mcp'
    | '/portal/automation/monitoring'
    | '/portal/automation/policies'
    | '/portal/automation/skills'
    | '/portal/automation/webhooks'
    | '/portal/automation/workflows'
    | '/portal/ftp/audit'
    | '/portal/ftp/connections'
    | '/portal/ftp/files'
    | '/portal/ftp/users'
    | '/portal/knowledgebase-file/batches'
    | '/portal/knowledgebase-file/categories'
    | '/portal/knowledgebase-file/category-review'
    | '/portal/knowledgebase-file/documents'
    | '/portal/knowledgebase-file/labels'
    | '/portal/knowledgebase-file/query'
    | '/portal/knowledgebase-file/templates'
    | '/portal/knowledgebase-file/upload'
    | '/portal/knowledgebase-sql/connect'
    | '/portal/knowledgebase-sql/data-sources'
    | '/portal/knowledgebase-sql/glossary'
    | '/portal/knowledgebase-sql/query'
    | '/portal/knowledgebase-sql/quick-question'
    | '/portal/lms/assign'
    | '/portal/lms/author'
    | '/portal/lms/curation'
    | '/portal/lms/cycles'
    | '/portal/lms/leaderboard'
    | '/portal/messaging/inbox'
    | '/portal/messaging/templates'
    | '/portal/messaging/whatsapp-setup'
    | '/portal/myapp/apps'
    | '/portal/myapp/areas'
    | '/portal/myapp/bridge'
    | '/portal/myapp/tables'
    | '/portal/organisation/categories'
    | '/portal/organisation/members'
    | '/portal/organisation/settings'
    | '/portal/organisation/theme'
    | '/portal/platform/api-keys'
    | '/portal/platform/billing'
    | '/portal/platform/billing-overview'
    | '/portal/platform/categories'
    | '/portal/platform/chart-settings'
    | '/portal/platform/client-onboarding'
    | '/portal/platform/connector-enrichment'
    | '/portal/platform/connectors'
    | '/portal/platform/discounts'
    | '/portal/platform/groups'
    | '/portal/platform/inbound-dead-letters'
    | '/portal/platform/infrastructure'
    | '/portal/platform/maintenance'
    | '/portal/platform/monitoring'
    | '/portal/platform/object-permissions'
    | '/portal/platform/organisations'
    | '/portal/platform/orphaned-schedules'
    | '/portal/platform/pipelines'
    | '/portal/platform/pricing'
    | '/portal/platform/products'
    | '/portal/platform/profile'
    | '/portal/platform/rbac'
    | '/portal/platform/schema-drift'
    | '/portal/platform/sdlc'
    | '/portal/platform/secrets'
    | '/portal/platform/security'
    | '/portal/platform/settings'
    | '/portal/platform/subscriptions'
    | '/portal/platform/theme'
    | '/portal/platform/tiers'
    | '/portal/platform/users'
    | '/portal/spaces/new'
    | '/portal/workflows/canvas-demo'
    | '/portal/workflows/definitions'
    | '/portal/workflows/dlq'
    | '/portal/workflows/execute'
    | '/portal/workflows/executions'
    | '/portal/workflows/projects'
    | '/portal/workflows/retry-failures'
    | '/portal/workflows/templates'
    | '/portal/workflows/topology'
    | '/portal/auth/unlock-account'
    | '/portal/auth/verify-email'
    | '/portal/invite/accept'
    | '/portal/sign-in/verify'
    | '/products/myapp/excel-addin-setup'
    | '/portal/ai-content'
    | '/portal/apps'
    | '/portal/automation'
    | '/portal/connectors'
    | '/portal/ftp'
    | '/portal/hr'
    | '/portal/knowledgebase-file'
    | '/portal/knowledgebase-sql'
    | '/portal/learning'
    | '/portal/lms'
    | '/portal/messaging'
    | '/portal/myapp'
    | '/portal/spaces'
    | '/portal/workflows'
    | '/forms/$slug/respond/success'
    | '/portal/connectors/$typeSlug/manage'
    | '/portal/connectors/$typeSlug/new'
    | '/portal/connectors/mysql/new'
    | '/portal/connectors/sqlserver/new'
    | '/portal/hr/onboarding/$id'
    | '/portal/knowledgebase-file/batches/$id'
    | '/portal/knowledgebase-file/documents/$id'
    | '/portal/knowledgebase-sql/insight-reports/$slug'
    | '/portal/knowledgebase-sql/insight-reports/new'
    | '/portal/learning/attempt/$attemptId'
    | '/portal/learning/review/$attemptId'
    | '/portal/myapp/$tableId/edit'
    | '/portal/myapp/$tableId/grid'
    | '/portal/myapp/$tableId/kanban'
    | '/portal/myapp/$tableId/permissions'
    | '/portal/myapp/$tableId/print'
    | '/portal/myapp/$tableId/report'
    | '/portal/myapp/$tableId/submit'
    | '/portal/platform/groups/$groupId'
    | '/portal/spaces/$spaceId/edit'
    | '/portal/workflows/definitions/new'
    | '/portal/workflows/projects/$projectId'
    | '/forms/$slug/respond'
    | '/portal/apps/$appSlug'
    | '/portal/apps/reporting'
    | '/portal/connectors/$typeSlug'
    | '/portal/hr/allocations'
    | '/portal/hr/employees'
    | '/portal/hr/forecast'
    | '/portal/hr/onboarding'
    | '/portal/hr/rules'
    | '/portal/hr/settings'
    | '/portal/knowledgebase-sql/insight-reports'
    | '/portal/learning/review'
    | '/portal/myapp/$tableId'
    | '/portal/spaces/$spaceId'
    | '/portal/apps/reporting/custom/$slug'
    | '/portal/apps/reporting/custom/new'
    | '/portal/apps/reporting/datasources/$slug'
    | '/portal/apps/reporting/datasources/new'
    | '/portal/workflows/definitions/$key/new-version'
    | '/portal/spaces/$spaceId/widget/$widgetId'
    | '/portal/apps/reporting/custom'
    | '/portal/apps/reporting/datasources'
    | '/portal/apps/reporting/model'
    | '/portal/apps/reporting/custom/$slug/edit'
    | '/portal/apps/reporting/datasources/$slug/edit'
    | '/portal/apps/reporting/custom/$slug/window'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/brand'
    | '/connectors'
    | '/contact'
    | '/industries'
    | '/login'
    | '/portal'
    | '/pricing'
    | '/proof-of-concept'
    | '/resources'
    | '/solutions'
    | '/status'
    | '/videos'
    | '/archive/home'
    | '/archive/pricing'
    | '/auth/callback'
    | '/connectors/product'
    | '/connectors/xero-case-study'
    | '/legal/data-processing'
    | '/legal/paia'
    | '/legal/privacy'
    | '/legal/refund-policy'
    | '/legal/terms-of-use'
    | '/oauth/consent'
    | '/onboard/$token'
    | '/portal/ai-content'
    | '/portal/asset-library'
    | '/portal/automation'
    | '/portal/catalogue-intelligence'
    | '/portal/ftp'
    | '/portal/hr'
    | '/portal/knowledgebase-file'
    | '/portal/knowledgebase-sql'
    | '/portal/learning'
    | '/portal/lms'
    | '/portal/messaging'
    | '/portal/myapp'
    | '/portal/platform'
    | '/portal/workflows'
    | '/portal_/forgot-password'
    | '/portal_/help'
    | '/portal_/reset-password'
    | '/portal_/sign-in'
    | '/portal_/sign-up'
    | '/preview/connector-flows'
    | '/preview/ground-up-flow'
    | '/preview/home-hero'
    | '/preview/kb-heroes'
    | '/preview/myapp-table-types'
    | '/products/knowledge-base'
    | '/products/myapp'
    | '/connectors/'
    | '/portal/'
    | '/forms/$slug/respond'
    | '/portal/ai-content/history'
    | '/portal/apps/expense'
    | '/portal/automation/agent-entitlements'
    | '/portal/automation/audit'
    | '/portal/automation/content-review'
    | '/portal/automation/credentials'
    | '/portal/automation/dashboard'
    | '/portal/automation/llm'
    | '/portal/automation/mcp'
    | '/portal/automation/monitoring'
    | '/portal/automation/policies'
    | '/portal/automation/skills'
    | '/portal/automation/webhooks'
    | '/portal/automation/workflows'
    | '/portal/ftp/audit'
    | '/portal/ftp/connections'
    | '/portal/ftp/files'
    | '/portal/ftp/users'
    | '/portal/knowledgebase-file/batches'
    | '/portal/knowledgebase-file/categories'
    | '/portal/knowledgebase-file/category-review'
    | '/portal/knowledgebase-file/documents'
    | '/portal/knowledgebase-file/labels'
    | '/portal/knowledgebase-file/query'
    | '/portal/knowledgebase-file/templates'
    | '/portal/knowledgebase-file/upload'
    | '/portal/knowledgebase-sql/connect'
    | '/portal/knowledgebase-sql/data-sources'
    | '/portal/knowledgebase-sql/glossary'
    | '/portal/knowledgebase-sql/query'
    | '/portal/knowledgebase-sql/quick-question'
    | '/portal/lms/assign'
    | '/portal/lms/author'
    | '/portal/lms/curation'
    | '/portal/lms/cycles'
    | '/portal/lms/leaderboard'
    | '/portal/messaging/inbox'
    | '/portal/messaging/templates'
    | '/portal/messaging/whatsapp-setup'
    | '/portal/myapp/apps'
    | '/portal/myapp/areas'
    | '/portal/myapp/bridge'
    | '/portal/myapp/tables'
    | '/portal/organisation/categories'
    | '/portal/organisation/members'
    | '/portal/organisation/settings'
    | '/portal/organisation/theme'
    | '/portal/platform/api-keys'
    | '/portal/platform/billing'
    | '/portal/platform/billing-overview'
    | '/portal/platform/categories'
    | '/portal/platform/chart-settings'
    | '/portal/platform/client-onboarding'
    | '/portal/platform/connector-enrichment'
    | '/portal/platform/connectors'
    | '/portal/platform/discounts'
    | '/portal/platform/groups'
    | '/portal/platform/inbound-dead-letters'
    | '/portal/platform/infrastructure'
    | '/portal/platform/maintenance'
    | '/portal/platform/monitoring'
    | '/portal/platform/object-permissions'
    | '/portal/platform/organisations'
    | '/portal/platform/orphaned-schedules'
    | '/portal/platform/pipelines'
    | '/portal/platform/pricing'
    | '/portal/platform/products'
    | '/portal/platform/profile'
    | '/portal/platform/rbac'
    | '/portal/platform/schema-drift'
    | '/portal/platform/sdlc'
    | '/portal/platform/secrets'
    | '/portal/platform/security'
    | '/portal/platform/settings'
    | '/portal/platform/subscriptions'
    | '/portal/platform/theme'
    | '/portal/platform/tiers'
    | '/portal/platform/users'
    | '/portal/spaces/$spaceId'
    | '/portal/spaces/new'
    | '/portal/workflows/canvas-demo'
    | '/portal/workflows/definitions'
    | '/portal/workflows/dlq'
    | '/portal/workflows/execute'
    | '/portal/workflows/executions'
    | '/portal/workflows/projects'
    | '/portal/workflows/retry-failures'
    | '/portal/workflows/templates'
    | '/portal/workflows/topology'
    | '/portal_/auth/unlock-account'
    | '/portal_/auth/verify-email'
    | '/portal_/invite/accept'
    | '/portal_/sign-in_/verify'
    | '/products/myapp_/excel-addin-setup'
    | '/portal/ai-content/'
    | '/portal/apps/'
    | '/portal/automation/'
    | '/portal/connectors/'
    | '/portal/ftp/'
    | '/portal/hr/'
    | '/portal/knowledgebase-file/'
    | '/portal/knowledgebase-sql/'
    | '/portal/learning/'
    | '/portal/lms/'
    | '/portal/messaging/'
    | '/portal/myapp/'
    | '/portal/spaces/'
    | '/portal/workflows/'
    | '/forms/$slug/respond/success'
    | '/portal/connectors/$typeSlug/manage'
    | '/portal/connectors/$typeSlug/new'
    | '/portal/connectors/mysql/new'
    | '/portal/connectors/sqlserver/new'
    | '/portal/hr/onboarding/$id'
    | '/portal/knowledgebase-file/batches/$id'
    | '/portal/knowledgebase-file/documents/$id'
    | '/portal/knowledgebase-sql/insight-reports/$slug'
    | '/portal/knowledgebase-sql/insight-reports/new'
    | '/portal/learning/attempt/$attemptId'
    | '/portal/learning/review/$attemptId'
    | '/portal/myapp/$tableId/edit'
    | '/portal/myapp/$tableId/grid'
    | '/portal/myapp/$tableId/kanban'
    | '/portal/myapp/$tableId/permissions'
    | '/portal/myapp/$tableId/print'
    | '/portal/myapp/$tableId/report'
    | '/portal/myapp/$tableId/submit'
    | '/portal/platform/groups_/$groupId'
    | '/portal/spaces/$spaceId/edit'
    | '/portal/workflows/definitions_/new'
    | '/portal/workflows/projects_/$projectId'
    | '/forms/$slug/respond/'
    | '/portal/apps/$appSlug/'
    | '/portal/apps/reporting/'
    | '/portal/connectors/$typeSlug/'
    | '/portal/hr/allocations/'
    | '/portal/hr/employees/'
    | '/portal/hr/forecast/'
    | '/portal/hr/onboarding/'
    | '/portal/hr/rules/'
    | '/portal/hr/settings/'
    | '/portal/knowledgebase-sql/insight-reports/'
    | '/portal/learning/review/'
    | '/portal/myapp/$tableId/'
    | '/portal/spaces/$spaceId/'
    | '/portal/apps/reporting/custom/$slug'
    | '/portal/apps/reporting/custom/new'
    | '/portal/apps/reporting/datasources/$slug'
    | '/portal/apps/reporting/datasources/new'
    | '/portal/workflows/definitions_/$key/new-version'
    | '/portal_/spaces/$spaceId/widget/$widgetId'
    | '/portal/apps/reporting/custom/'
    | '/portal/apps/reporting/datasources/'
    | '/portal/apps/reporting/model/'
    | '/portal/apps/reporting/custom/$slug_/edit'
    | '/portal/apps/reporting/datasources/$slug_/edit'
    | '/portal_/apps/reporting/custom/$slug/window'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  BrandRoute: typeof BrandRoute
  ConnectorsRoute: typeof ConnectorsRouteWithChildren
  ContactRoute: typeof ContactRoute
  IndustriesRoute: typeof IndustriesRoute
  LoginRoute: typeof LoginRoute
  PortalRoute: typeof PortalRouteWithChildren
  PricingRoute: typeof PricingRoute
  ProofOfConceptRoute: typeof ProofOfConceptRoute
  ResourcesRoute: typeof ResourcesRoute
  SolutionsRoute: typeof SolutionsRoute
  StatusRoute: typeof StatusRoute
  VideosRoute: typeof VideosRoute
  ArchiveHomeRoute: typeof ArchiveHomeRoute
  ArchivePricingRoute: typeof ArchivePricingRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  LegalDataProcessingRoute: typeof LegalDataProcessingRoute
  LegalPaiaRoute: typeof LegalPaiaRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalRefundPolicyRoute: typeof LegalRefundPolicyRoute
  LegalTermsOfUseRoute: typeof LegalTermsOfUseRoute
  OauthConsentRoute: typeof OauthConsentRoute
  OnboardTokenRoute: typeof OnboardTokenRoute
  PortalForgotPasswordRoute: typeof PortalForgotPasswordRoute
  PortalHelpRoute: typeof PortalHelpRoute
  PortalResetPasswordRoute: typeof PortalResetPasswordRoute
  PortalSignInRoute: typeof PortalSignInRoute
  PortalSignUpRoute: typeof PortalSignUpRoute
  PreviewConnectorFlowsRoute: typeof PreviewConnectorFlowsRoute
  PreviewGroundUpFlowRoute: typeof PreviewGroundUpFlowRoute
  PreviewHomeHeroRoute: typeof PreviewHomeHeroRoute
  PreviewKbHeroesRoute: typeof PreviewKbHeroesRoute
  PreviewMyappTableTypesRoute: typeof PreviewMyappTableTypesRoute
  ProductsKnowledgeBaseRoute: typeof ProductsKnowledgeBaseRoute
  ProductsMyappRoute: typeof ProductsMyappRoute
  FormsSlugRespondRoute: typeof FormsSlugRespondRouteWithChildren
  PortalAuthUnlockAccountRoute: typeof PortalAuthUnlockAccountRoute
  PortalAuthVerifyEmailRoute: typeof PortalAuthVerifyEmailRoute
  PortalInviteAcceptRoute: typeof PortalInviteAcceptRoute
  PortalSignInVerifyRoute: typeof PortalSignInVerifyRoute
  ProductsMyappExcelAddinSetupRoute: typeof ProductsMyappExcelAddinSetupRoute
  PortalSpacesSpaceIdWidgetWidgetIdRoute: typeof PortalSpacesSpaceIdWidgetWidgetIdRoute
  PortalAppsReportingCustomSlugWindowRoute: typeof PortalAppsReportingCustomSlugWindowRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/videos': {
      id: '/videos'
      path: '/videos'
      fullPath: '/videos'
      preLoaderRoute: typeof VideosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions': {
      id: '/solutions'
      path: '/solutions'
      fullPath: '/solutions'
      preLoaderRoute: typeof SolutionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources': {
      id: '/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof ResourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proof-of-concept': {
      id: '/proof-of-concept'
      path: '/proof-of-concept'
      fullPath: '/proof-of-concept'
      preLoaderRoute: typeof ProofOfConceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries': {
      id: '/industries'
      path: '/industries'
      fullPath: '/industries'
      preLoaderRoute: typeof IndustriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connectors': {
      id: '/connectors'
      path: '/connectors'
      fullPath: '/connectors'
      preLoaderRoute: typeof ConnectorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brand': {
      id: '/brand'
      path: '/brand'
      fullPath: '/brand'
      preLoaderRoute: typeof BrandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/connectors/': {
      id: '/connectors/'
      path: '/'
      fullPath: '/connectors/'
      preLoaderRoute: typeof ConnectorsIndexRouteImport
      parentRoute: typeof ConnectorsRoute
    }
    '/products/myapp': {
      id: '/products/myapp'
      path: '/products/myapp'
      fullPath: '/products/myapp'
      preLoaderRoute: typeof ProductsMyappRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/knowledge-base': {
      id: '/products/knowledge-base'
      path: '/products/knowledge-base'
      fullPath: '/products/knowledge-base'
      preLoaderRoute: typeof ProductsKnowledgeBaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/myapp-table-types': {
      id: '/preview/myapp-table-types'
      path: '/preview/myapp-table-types'
      fullPath: '/preview/myapp-table-types'
      preLoaderRoute: typeof PreviewMyappTableTypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/kb-heroes': {
      id: '/preview/kb-heroes'
      path: '/preview/kb-heroes'
      fullPath: '/preview/kb-heroes'
      preLoaderRoute: typeof PreviewKbHeroesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/home-hero': {
      id: '/preview/home-hero'
      path: '/preview/home-hero'
      fullPath: '/preview/home-hero'
      preLoaderRoute: typeof PreviewHomeHeroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/ground-up-flow': {
      id: '/preview/ground-up-flow'
      path: '/preview/ground-up-flow'
      fullPath: '/preview/ground-up-flow'
      preLoaderRoute: typeof PreviewGroundUpFlowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/connector-flows': {
      id: '/preview/connector-flows'
      path: '/preview/connector-flows'
      fullPath: '/preview/connector-flows'
      preLoaderRoute: typeof PreviewConnectorFlowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal_/sign-up': {
      id: '/portal_/sign-up'
      path: '/portal/sign-up'
      fullPath: '/portal/sign-up'
      preLoaderRoute: typeof PortalSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal_/sign-in': {
      id: '/portal_/sign-in'
      path: '/portal/sign-in'
      fullPath: '/portal/sign-in'
      preLoaderRoute: typeof PortalSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal_/reset-password': {
      id: '/portal_/reset-password'
      path: '/portal/reset-password'
      fullPath: '/portal/reset-password'
      preLoaderRoute: typeof PortalResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal_/help': {
      id: '/portal_/help'
      path: '/portal/help'
      fullPath: '/portal/help'
      preLoaderRoute: typeof PortalHelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal_/forgot-password': {
      id: '/portal_/forgot-password'
      path: '/portal/forgot-password'
      fullPath: '/portal/forgot-password'
      preLoaderRoute: typeof PortalForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/workflows': {
      id: '/portal/workflows'
      path: '/workflows'
      fullPath: '/portal/workflows'
      preLoaderRoute: typeof PortalWorkflowsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/platform': {
      id: '/portal/platform'
      path: '/platform'
      fullPath: '/portal/platform'
      preLoaderRoute: typeof PortalPlatformRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/myapp': {
      id: '/portal/myapp'
      path: '/myapp'
      fullPath: '/portal/myapp'
      preLoaderRoute: typeof PortalMyappRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/messaging': {
      id: '/portal/messaging'
      path: '/messaging'
      fullPath: '/portal/messaging'
      preLoaderRoute: typeof PortalMessagingRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/lms': {
      id: '/portal/lms'
      path: '/lms'
      fullPath: '/portal/lms'
      preLoaderRoute: typeof PortalLmsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/learning': {
      id: '/portal/learning'
      path: '/learning'
      fullPath: '/portal/learning'
      preLoaderRoute: typeof PortalLearningRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/knowledgebase-sql': {
      id: '/portal/knowledgebase-sql'
      path: '/knowledgebase-sql'
      fullPath: '/portal/knowledgebase-sql'
      preLoaderRoute: typeof PortalKnowledgebaseSqlRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/knowledgebase-file': {
      id: '/portal/knowledgebase-file'
      path: '/knowledgebase-file'
      fullPath: '/portal/knowledgebase-file'
      preLoaderRoute: typeof PortalKnowledgebaseFileRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/hr': {
      id: '/portal/hr'
      path: '/hr'
      fullPath: '/portal/hr'
      preLoaderRoute: typeof PortalHrRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/ftp': {
      id: '/portal/ftp'
      path: '/ftp'
      fullPath: '/portal/ftp'
      preLoaderRoute: typeof PortalFtpRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/catalogue-intelligence': {
      id: '/portal/catalogue-intelligence'
      path: '/catalogue-intelligence'
      fullPath: '/portal/catalogue-intelligence'
      preLoaderRoute: typeof PortalCatalogueIntelligenceRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/automation': {
      id: '/portal/automation'
      path: '/automation'
      fullPath: '/portal/automation'
      preLoaderRoute: typeof PortalAutomationRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/asset-library': {
      id: '/portal/asset-library'
      path: '/asset-library'
      fullPath: '/portal/asset-library'
      preLoaderRoute: typeof PortalAssetLibraryRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/ai-content': {
      id: '/portal/ai-content'
      path: '/ai-content'
      fullPath: '/portal/ai-content'
      preLoaderRoute: typeof PortalAiContentRouteImport
      parentRoute: typeof PortalRoute
    }
    '/onboard/$token': {
      id: '/onboard/$token'
      path: '/onboard/$token'
      fullPath: '/onboard/$token'
      preLoaderRoute: typeof OnboardTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/terms-of-use': {
      id: '/legal/terms-of-use'
      path: '/legal/terms-of-use'
      fullPath: '/legal/terms-of-use'
      preLoaderRoute: typeof LegalTermsOfUseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/refund-policy': {
      id: '/legal/refund-policy'
      path: '/legal/refund-policy'
      fullPath: '/legal/refund-policy'
      preLoaderRoute: typeof LegalRefundPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/legal/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/paia': {
      id: '/legal/paia'
      path: '/legal/paia'
      fullPath: '/legal/paia'
      preLoaderRoute: typeof LegalPaiaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/data-processing': {
      id: '/legal/data-processing'
      path: '/legal/data-processing'
      fullPath: '/legal/data-processing'
      preLoaderRoute: typeof LegalDataProcessingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connectors/xero-case-study': {
      id: '/connectors/xero-case-study'
      path: '/xero-case-study'
      fullPath: '/connectors/xero-case-study'
      preLoaderRoute: typeof ConnectorsXeroCaseStudyRouteImport
      parentRoute: typeof ConnectorsRoute
    }
    '/connectors/product': {
      id: '/connectors/product'
      path: '/product'
      fullPath: '/connectors/product'
      preLoaderRoute: typeof ConnectorsProductRouteImport
      parentRoute: typeof ConnectorsRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive/pricing': {
      id: '/archive/pricing'
      path: '/archive/pricing'
      fullPath: '/archive/pricing'
      preLoaderRoute: typeof ArchivePricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive/home': {
      id: '/archive/home'
      path: '/archive/home'
      fullPath: '/archive/home'
      preLoaderRoute: typeof ArchiveHomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/workflows/': {
      id: '/portal/workflows/'
      path: '/'
      fullPath: '/portal/workflows/'
      preLoaderRoute: typeof PortalWorkflowsIndexRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/spaces/': {
      id: '/portal/spaces/'
      path: '/spaces'
      fullPath: '/portal/spaces/'
      preLoaderRoute: typeof PortalSpacesIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/myapp/': {
      id: '/portal/myapp/'
      path: '/'
      fullPath: '/portal/myapp/'
      preLoaderRoute: typeof PortalMyappIndexRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/messaging/': {
      id: '/portal/messaging/'
      path: '/'
      fullPath: '/portal/messaging/'
      preLoaderRoute: typeof PortalMessagingIndexRouteImport
      parentRoute: typeof PortalMessagingRoute
    }
    '/portal/lms/': {
      id: '/portal/lms/'
      path: '/'
      fullPath: '/portal/lms/'
      preLoaderRoute: typeof PortalLmsIndexRouteImport
      parentRoute: typeof PortalLmsRoute
    }
    '/portal/learning/': {
      id: '/portal/learning/'
      path: '/'
      fullPath: '/portal/learning/'
      preLoaderRoute: typeof PortalLearningIndexRouteImport
      parentRoute: typeof PortalLearningRoute
    }
    '/portal/knowledgebase-sql/': {
      id: '/portal/knowledgebase-sql/'
      path: '/'
      fullPath: '/portal/knowledgebase-sql/'
      preLoaderRoute: typeof PortalKnowledgebaseSqlIndexRouteImport
      parentRoute: typeof PortalKnowledgebaseSqlRoute
    }
    '/portal/knowledgebase-file/': {
      id: '/portal/knowledgebase-file/'
      path: '/'
      fullPath: '/portal/knowledgebase-file/'
      preLoaderRoute: typeof PortalKnowledgebaseFileIndexRouteImport
      parentRoute: typeof PortalKnowledgebaseFileRoute
    }
    '/portal/hr/': {
      id: '/portal/hr/'
      path: '/'
      fullPath: '/portal/hr/'
      preLoaderRoute: typeof PortalHrIndexRouteImport
      parentRoute: typeof PortalHrRoute
    }
    '/portal/ftp/': {
      id: '/portal/ftp/'
      path: '/'
      fullPath: '/portal/ftp/'
      preLoaderRoute: typeof PortalFtpIndexRouteImport
      parentRoute: typeof PortalFtpRoute
    }
    '/portal/connectors/': {
      id: '/portal/connectors/'
      path: '/connectors'
      fullPath: '/portal/connectors/'
      preLoaderRoute: typeof PortalConnectorsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/automation/': {
      id: '/portal/automation/'
      path: '/'
      fullPath: '/portal/automation/'
      preLoaderRoute: typeof PortalAutomationIndexRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/apps/': {
      id: '/portal/apps/'
      path: '/apps'
      fullPath: '/portal/apps/'
      preLoaderRoute: typeof PortalAppsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/ai-content/': {
      id: '/portal/ai-content/'
      path: '/'
      fullPath: '/portal/ai-content/'
      preLoaderRoute: typeof PortalAiContentIndexRouteImport
      parentRoute: typeof PortalAiContentRoute
    }
    '/products/myapp_/excel-addin-setup': {
      id: '/products/myapp_/excel-addin-setup'
      path: '/products/myapp/excel-addin-setup'
      fullPath: '/products/myapp/excel-addin-setup'
      preLoaderRoute: typeof ProductsMyappExcelAddinSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal_/sign-in_/verify': {
      id: '/portal_/sign-in_/verify'
      path: '/portal/sign-in/verify'
      fullPath: '/portal/sign-in/verify'
      preLoaderRoute: typeof PortalSignInVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal_/invite/accept': {
      id: '/portal_/invite/accept'
      path: '/portal/invite/accept'
      fullPath: '/portal/invite/accept'
      preLoaderRoute: typeof PortalInviteAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal_/auth/verify-email': {
      id: '/portal_/auth/verify-email'
      path: '/portal/auth/verify-email'
      fullPath: '/portal/auth/verify-email'
      preLoaderRoute: typeof PortalAuthVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal_/auth/unlock-account': {
      id: '/portal_/auth/unlock-account'
      path: '/portal/auth/unlock-account'
      fullPath: '/portal/auth/unlock-account'
      preLoaderRoute: typeof PortalAuthUnlockAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/workflows/topology': {
      id: '/portal/workflows/topology'
      path: '/topology'
      fullPath: '/portal/workflows/topology'
      preLoaderRoute: typeof PortalWorkflowsTopologyRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/workflows/templates': {
      id: '/portal/workflows/templates'
      path: '/templates'
      fullPath: '/portal/workflows/templates'
      preLoaderRoute: typeof PortalWorkflowsTemplatesRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/workflows/retry-failures': {
      id: '/portal/workflows/retry-failures'
      path: '/retry-failures'
      fullPath: '/portal/workflows/retry-failures'
      preLoaderRoute: typeof PortalWorkflowsRetryFailuresRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/workflows/projects': {
      id: '/portal/workflows/projects'
      path: '/projects'
      fullPath: '/portal/workflows/projects'
      preLoaderRoute: typeof PortalWorkflowsProjectsRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/workflows/executions': {
      id: '/portal/workflows/executions'
      path: '/executions'
      fullPath: '/portal/workflows/executions'
      preLoaderRoute: typeof PortalWorkflowsExecutionsRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/workflows/execute': {
      id: '/portal/workflows/execute'
      path: '/execute'
      fullPath: '/portal/workflows/execute'
      preLoaderRoute: typeof PortalWorkflowsExecuteRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/workflows/dlq': {
      id: '/portal/workflows/dlq'
      path: '/dlq'
      fullPath: '/portal/workflows/dlq'
      preLoaderRoute: typeof PortalWorkflowsDlqRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/workflows/definitions': {
      id: '/portal/workflows/definitions'
      path: '/definitions'
      fullPath: '/portal/workflows/definitions'
      preLoaderRoute: typeof PortalWorkflowsDefinitionsRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/workflows/canvas-demo': {
      id: '/portal/workflows/canvas-demo'
      path: '/canvas-demo'
      fullPath: '/portal/workflows/canvas-demo'
      preLoaderRoute: typeof PortalWorkflowsCanvasDemoRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/spaces/new': {
      id: '/portal/spaces/new'
      path: '/spaces/new'
      fullPath: '/portal/spaces/new'
      preLoaderRoute: typeof PortalSpacesNewRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/spaces/$spaceId': {
      id: '/portal/spaces/$spaceId'
      path: '/spaces/$spaceId'
      fullPath: '/portal/spaces/$spaceId'
      preLoaderRoute: typeof PortalSpacesSpaceIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/platform/users': {
      id: '/portal/platform/users'
      path: '/users'
      fullPath: '/portal/platform/users'
      preLoaderRoute: typeof PortalPlatformUsersRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/tiers': {
      id: '/portal/platform/tiers'
      path: '/tiers'
      fullPath: '/portal/platform/tiers'
      preLoaderRoute: typeof PortalPlatformTiersRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/theme': {
      id: '/portal/platform/theme'
      path: '/theme'
      fullPath: '/portal/platform/theme'
      preLoaderRoute: typeof PortalPlatformThemeRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/subscriptions': {
      id: '/portal/platform/subscriptions'
      path: '/subscriptions'
      fullPath: '/portal/platform/subscriptions'
      preLoaderRoute: typeof PortalPlatformSubscriptionsRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/settings': {
      id: '/portal/platform/settings'
      path: '/settings'
      fullPath: '/portal/platform/settings'
      preLoaderRoute: typeof PortalPlatformSettingsRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/security': {
      id: '/portal/platform/security'
      path: '/security'
      fullPath: '/portal/platform/security'
      preLoaderRoute: typeof PortalPlatformSecurityRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/secrets': {
      id: '/portal/platform/secrets'
      path: '/secrets'
      fullPath: '/portal/platform/secrets'
      preLoaderRoute: typeof PortalPlatformSecretsRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/sdlc': {
      id: '/portal/platform/sdlc'
      path: '/sdlc'
      fullPath: '/portal/platform/sdlc'
      preLoaderRoute: typeof PortalPlatformSdlcRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/schema-drift': {
      id: '/portal/platform/schema-drift'
      path: '/schema-drift'
      fullPath: '/portal/platform/schema-drift'
      preLoaderRoute: typeof PortalPlatformSchemaDriftRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/rbac': {
      id: '/portal/platform/rbac'
      path: '/rbac'
      fullPath: '/portal/platform/rbac'
      preLoaderRoute: typeof PortalPlatformRbacRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/profile': {
      id: '/portal/platform/profile'
      path: '/profile'
      fullPath: '/portal/platform/profile'
      preLoaderRoute: typeof PortalPlatformProfileRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/products': {
      id: '/portal/platform/products'
      path: '/products'
      fullPath: '/portal/platform/products'
      preLoaderRoute: typeof PortalPlatformProductsRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/pricing': {
      id: '/portal/platform/pricing'
      path: '/pricing'
      fullPath: '/portal/platform/pricing'
      preLoaderRoute: typeof PortalPlatformPricingRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/pipelines': {
      id: '/portal/platform/pipelines'
      path: '/pipelines'
      fullPath: '/portal/platform/pipelines'
      preLoaderRoute: typeof PortalPlatformPipelinesRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/orphaned-schedules': {
      id: '/portal/platform/orphaned-schedules'
      path: '/orphaned-schedules'
      fullPath: '/portal/platform/orphaned-schedules'
      preLoaderRoute: typeof PortalPlatformOrphanedSchedulesRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/organisations': {
      id: '/portal/platform/organisations'
      path: '/organisations'
      fullPath: '/portal/platform/organisations'
      preLoaderRoute: typeof PortalPlatformOrganisationsRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/object-permissions': {
      id: '/portal/platform/object-permissions'
      path: '/object-permissions'
      fullPath: '/portal/platform/object-permissions'
      preLoaderRoute: typeof PortalPlatformObjectPermissionsRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/monitoring': {
      id: '/portal/platform/monitoring'
      path: '/monitoring'
      fullPath: '/portal/platform/monitoring'
      preLoaderRoute: typeof PortalPlatformMonitoringRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/maintenance': {
      id: '/portal/platform/maintenance'
      path: '/maintenance'
      fullPath: '/portal/platform/maintenance'
      preLoaderRoute: typeof PortalPlatformMaintenanceRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/infrastructure': {
      id: '/portal/platform/infrastructure'
      path: '/infrastructure'
      fullPath: '/portal/platform/infrastructure'
      preLoaderRoute: typeof PortalPlatformInfrastructureRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/inbound-dead-letters': {
      id: '/portal/platform/inbound-dead-letters'
      path: '/inbound-dead-letters'
      fullPath: '/portal/platform/inbound-dead-letters'
      preLoaderRoute: typeof PortalPlatformInboundDeadLettersRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/groups': {
      id: '/portal/platform/groups'
      path: '/groups'
      fullPath: '/portal/platform/groups'
      preLoaderRoute: typeof PortalPlatformGroupsRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/discounts': {
      id: '/portal/platform/discounts'
      path: '/discounts'
      fullPath: '/portal/platform/discounts'
      preLoaderRoute: typeof PortalPlatformDiscountsRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/connectors': {
      id: '/portal/platform/connectors'
      path: '/connectors'
      fullPath: '/portal/platform/connectors'
      preLoaderRoute: typeof PortalPlatformConnectorsRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/connector-enrichment': {
      id: '/portal/platform/connector-enrichment'
      path: '/connector-enrichment'
      fullPath: '/portal/platform/connector-enrichment'
      preLoaderRoute: typeof PortalPlatformConnectorEnrichmentRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/client-onboarding': {
      id: '/portal/platform/client-onboarding'
      path: '/client-onboarding'
      fullPath: '/portal/platform/client-onboarding'
      preLoaderRoute: typeof PortalPlatformClientOnboardingRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/chart-settings': {
      id: '/portal/platform/chart-settings'
      path: '/chart-settings'
      fullPath: '/portal/platform/chart-settings'
      preLoaderRoute: typeof PortalPlatformChartSettingsRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/categories': {
      id: '/portal/platform/categories'
      path: '/categories'
      fullPath: '/portal/platform/categories'
      preLoaderRoute: typeof PortalPlatformCategoriesRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/billing-overview': {
      id: '/portal/platform/billing-overview'
      path: '/billing-overview'
      fullPath: '/portal/platform/billing-overview'
      preLoaderRoute: typeof PortalPlatformBillingOverviewRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/billing': {
      id: '/portal/platform/billing'
      path: '/billing'
      fullPath: '/portal/platform/billing'
      preLoaderRoute: typeof PortalPlatformBillingRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/platform/api-keys': {
      id: '/portal/platform/api-keys'
      path: '/api-keys'
      fullPath: '/portal/platform/api-keys'
      preLoaderRoute: typeof PortalPlatformApiKeysRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/organisation/theme': {
      id: '/portal/organisation/theme'
      path: '/organisation/theme'
      fullPath: '/portal/organisation/theme'
      preLoaderRoute: typeof PortalOrganisationThemeRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/organisation/settings': {
      id: '/portal/organisation/settings'
      path: '/organisation/settings'
      fullPath: '/portal/organisation/settings'
      preLoaderRoute: typeof PortalOrganisationSettingsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/organisation/members': {
      id: '/portal/organisation/members'
      path: '/organisation/members'
      fullPath: '/portal/organisation/members'
      preLoaderRoute: typeof PortalOrganisationMembersRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/organisation/categories': {
      id: '/portal/organisation/categories'
      path: '/organisation/categories'
      fullPath: '/portal/organisation/categories'
      preLoaderRoute: typeof PortalOrganisationCategoriesRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/myapp/tables': {
      id: '/portal/myapp/tables'
      path: '/tables'
      fullPath: '/portal/myapp/tables'
      preLoaderRoute: typeof PortalMyappTablesRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/myapp/bridge': {
      id: '/portal/myapp/bridge'
      path: '/bridge'
      fullPath: '/portal/myapp/bridge'
      preLoaderRoute: typeof PortalMyappBridgeRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/myapp/areas': {
      id: '/portal/myapp/areas'
      path: '/areas'
      fullPath: '/portal/myapp/areas'
      preLoaderRoute: typeof PortalMyappAreasRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/myapp/apps': {
      id: '/portal/myapp/apps'
      path: '/apps'
      fullPath: '/portal/myapp/apps'
      preLoaderRoute: typeof PortalMyappAppsRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/messaging/whatsapp-setup': {
      id: '/portal/messaging/whatsapp-setup'
      path: '/whatsapp-setup'
      fullPath: '/portal/messaging/whatsapp-setup'
      preLoaderRoute: typeof PortalMessagingWhatsappSetupRouteImport
      parentRoute: typeof PortalMessagingRoute
    }
    '/portal/messaging/templates': {
      id: '/portal/messaging/templates'
      path: '/templates'
      fullPath: '/portal/messaging/templates'
      preLoaderRoute: typeof PortalMessagingTemplatesRouteImport
      parentRoute: typeof PortalMessagingRoute
    }
    '/portal/messaging/inbox': {
      id: '/portal/messaging/inbox'
      path: '/inbox'
      fullPath: '/portal/messaging/inbox'
      preLoaderRoute: typeof PortalMessagingInboxRouteImport
      parentRoute: typeof PortalMessagingRoute
    }
    '/portal/lms/leaderboard': {
      id: '/portal/lms/leaderboard'
      path: '/leaderboard'
      fullPath: '/portal/lms/leaderboard'
      preLoaderRoute: typeof PortalLmsLeaderboardRouteImport
      parentRoute: typeof PortalLmsRoute
    }
    '/portal/lms/cycles': {
      id: '/portal/lms/cycles'
      path: '/cycles'
      fullPath: '/portal/lms/cycles'
      preLoaderRoute: typeof PortalLmsCyclesRouteImport
      parentRoute: typeof PortalLmsRoute
    }
    '/portal/lms/curation': {
      id: '/portal/lms/curation'
      path: '/curation'
      fullPath: '/portal/lms/curation'
      preLoaderRoute: typeof PortalLmsCurationRouteImport
      parentRoute: typeof PortalLmsRoute
    }
    '/portal/lms/author': {
      id: '/portal/lms/author'
      path: '/author'
      fullPath: '/portal/lms/author'
      preLoaderRoute: typeof PortalLmsAuthorRouteImport
      parentRoute: typeof PortalLmsRoute
    }
    '/portal/lms/assign': {
      id: '/portal/lms/assign'
      path: '/assign'
      fullPath: '/portal/lms/assign'
      preLoaderRoute: typeof PortalLmsAssignRouteImport
      parentRoute: typeof PortalLmsRoute
    }
    '/portal/knowledgebase-sql/quick-question': {
      id: '/portal/knowledgebase-sql/quick-question'
      path: '/quick-question'
      fullPath: '/portal/knowledgebase-sql/quick-question'
      preLoaderRoute: typeof PortalKnowledgebaseSqlQuickQuestionRouteImport
      parentRoute: typeof PortalKnowledgebaseSqlRoute
    }
    '/portal/knowledgebase-sql/query': {
      id: '/portal/knowledgebase-sql/query'
      path: '/query'
      fullPath: '/portal/knowledgebase-sql/query'
      preLoaderRoute: typeof PortalKnowledgebaseSqlQueryRouteImport
      parentRoute: typeof PortalKnowledgebaseSqlRoute
    }
    '/portal/knowledgebase-sql/glossary': {
      id: '/portal/knowledgebase-sql/glossary'
      path: '/glossary'
      fullPath: '/portal/knowledgebase-sql/glossary'
      preLoaderRoute: typeof PortalKnowledgebaseSqlGlossaryRouteImport
      parentRoute: typeof PortalKnowledgebaseSqlRoute
    }
    '/portal/knowledgebase-sql/data-sources': {
      id: '/portal/knowledgebase-sql/data-sources'
      path: '/data-sources'
      fullPath: '/portal/knowledgebase-sql/data-sources'
      preLoaderRoute: typeof PortalKnowledgebaseSqlDataSourcesRouteImport
      parentRoute: typeof PortalKnowledgebaseSqlRoute
    }
    '/portal/knowledgebase-sql/connect': {
      id: '/portal/knowledgebase-sql/connect'
      path: '/connect'
      fullPath: '/portal/knowledgebase-sql/connect'
      preLoaderRoute: typeof PortalKnowledgebaseSqlConnectRouteImport
      parentRoute: typeof PortalKnowledgebaseSqlRoute
    }
    '/portal/knowledgebase-file/upload': {
      id: '/portal/knowledgebase-file/upload'
      path: '/upload'
      fullPath: '/portal/knowledgebase-file/upload'
      preLoaderRoute: typeof PortalKnowledgebaseFileUploadRouteImport
      parentRoute: typeof PortalKnowledgebaseFileRoute
    }
    '/portal/knowledgebase-file/templates': {
      id: '/portal/knowledgebase-file/templates'
      path: '/templates'
      fullPath: '/portal/knowledgebase-file/templates'
      preLoaderRoute: typeof PortalKnowledgebaseFileTemplatesRouteImport
      parentRoute: typeof PortalKnowledgebaseFileRoute
    }
    '/portal/knowledgebase-file/query': {
      id: '/portal/knowledgebase-file/query'
      path: '/query'
      fullPath: '/portal/knowledgebase-file/query'
      preLoaderRoute: typeof PortalKnowledgebaseFileQueryRouteImport
      parentRoute: typeof PortalKnowledgebaseFileRoute
    }
    '/portal/knowledgebase-file/labels': {
      id: '/portal/knowledgebase-file/labels'
      path: '/labels'
      fullPath: '/portal/knowledgebase-file/labels'
      preLoaderRoute: typeof PortalKnowledgebaseFileLabelsRouteImport
      parentRoute: typeof PortalKnowledgebaseFileRoute
    }
    '/portal/knowledgebase-file/documents': {
      id: '/portal/knowledgebase-file/documents'
      path: '/documents'
      fullPath: '/portal/knowledgebase-file/documents'
      preLoaderRoute: typeof PortalKnowledgebaseFileDocumentsRouteImport
      parentRoute: typeof PortalKnowledgebaseFileRoute
    }
    '/portal/knowledgebase-file/category-review': {
      id: '/portal/knowledgebase-file/category-review'
      path: '/category-review'
      fullPath: '/portal/knowledgebase-file/category-review'
      preLoaderRoute: typeof PortalKnowledgebaseFileCategoryReviewRouteImport
      parentRoute: typeof PortalKnowledgebaseFileRoute
    }
    '/portal/knowledgebase-file/categories': {
      id: '/portal/knowledgebase-file/categories'
      path: '/categories'
      fullPath: '/portal/knowledgebase-file/categories'
      preLoaderRoute: typeof PortalKnowledgebaseFileCategoriesRouteImport
      parentRoute: typeof PortalKnowledgebaseFileRoute
    }
    '/portal/knowledgebase-file/batches': {
      id: '/portal/knowledgebase-file/batches'
      path: '/batches'
      fullPath: '/portal/knowledgebase-file/batches'
      preLoaderRoute: typeof PortalKnowledgebaseFileBatchesRouteImport
      parentRoute: typeof PortalKnowledgebaseFileRoute
    }
    '/portal/ftp/users': {
      id: '/portal/ftp/users'
      path: '/users'
      fullPath: '/portal/ftp/users'
      preLoaderRoute: typeof PortalFtpUsersRouteImport
      parentRoute: typeof PortalFtpRoute
    }
    '/portal/ftp/files': {
      id: '/portal/ftp/files'
      path: '/files'
      fullPath: '/portal/ftp/files'
      preLoaderRoute: typeof PortalFtpFilesRouteImport
      parentRoute: typeof PortalFtpRoute
    }
    '/portal/ftp/connections': {
      id: '/portal/ftp/connections'
      path: '/connections'
      fullPath: '/portal/ftp/connections'
      preLoaderRoute: typeof PortalFtpConnectionsRouteImport
      parentRoute: typeof PortalFtpRoute
    }
    '/portal/ftp/audit': {
      id: '/portal/ftp/audit'
      path: '/audit'
      fullPath: '/portal/ftp/audit'
      preLoaderRoute: typeof PortalFtpAuditRouteImport
      parentRoute: typeof PortalFtpRoute
    }
    '/portal/automation/workflows': {
      id: '/portal/automation/workflows'
      path: '/workflows'
      fullPath: '/portal/automation/workflows'
      preLoaderRoute: typeof PortalAutomationWorkflowsRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/webhooks': {
      id: '/portal/automation/webhooks'
      path: '/webhooks'
      fullPath: '/portal/automation/webhooks'
      preLoaderRoute: typeof PortalAutomationWebhooksRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/skills': {
      id: '/portal/automation/skills'
      path: '/skills'
      fullPath: '/portal/automation/skills'
      preLoaderRoute: typeof PortalAutomationSkillsRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/policies': {
      id: '/portal/automation/policies'
      path: '/policies'
      fullPath: '/portal/automation/policies'
      preLoaderRoute: typeof PortalAutomationPoliciesRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/monitoring': {
      id: '/portal/automation/monitoring'
      path: '/monitoring'
      fullPath: '/portal/automation/monitoring'
      preLoaderRoute: typeof PortalAutomationMonitoringRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/mcp': {
      id: '/portal/automation/mcp'
      path: '/mcp'
      fullPath: '/portal/automation/mcp'
      preLoaderRoute: typeof PortalAutomationMcpRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/llm': {
      id: '/portal/automation/llm'
      path: '/llm'
      fullPath: '/portal/automation/llm'
      preLoaderRoute: typeof PortalAutomationLlmRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/dashboard': {
      id: '/portal/automation/dashboard'
      path: '/dashboard'
      fullPath: '/portal/automation/dashboard'
      preLoaderRoute: typeof PortalAutomationDashboardRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/credentials': {
      id: '/portal/automation/credentials'
      path: '/credentials'
      fullPath: '/portal/automation/credentials'
      preLoaderRoute: typeof PortalAutomationCredentialsRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/content-review': {
      id: '/portal/automation/content-review'
      path: '/content-review'
      fullPath: '/portal/automation/content-review'
      preLoaderRoute: typeof PortalAutomationContentReviewRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/audit': {
      id: '/portal/automation/audit'
      path: '/audit'
      fullPath: '/portal/automation/audit'
      preLoaderRoute: typeof PortalAutomationAuditRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/automation/agent-entitlements': {
      id: '/portal/automation/agent-entitlements'
      path: '/agent-entitlements'
      fullPath: '/portal/automation/agent-entitlements'
      preLoaderRoute: typeof PortalAutomationAgentEntitlementsRouteImport
      parentRoute: typeof PortalAutomationRoute
    }
    '/portal/apps/expense': {
      id: '/portal/apps/expense'
      path: '/apps/expense'
      fullPath: '/portal/apps/expense'
      preLoaderRoute: typeof PortalAppsExpenseRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/ai-content/history': {
      id: '/portal/ai-content/history'
      path: '/history'
      fullPath: '/portal/ai-content/history'
      preLoaderRoute: typeof PortalAiContentHistoryRouteImport
      parentRoute: typeof PortalAiContentRoute
    }
    '/forms/$slug/respond': {
      id: '/forms/$slug/respond'
      path: '/forms/$slug/respond'
      fullPath: '/forms/$slug/respond'
      preLoaderRoute: typeof FormsSlugRespondRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/spaces/$spaceId/': {
      id: '/portal/spaces/$spaceId/'
      path: '/'
      fullPath: '/portal/spaces/$spaceId/'
      preLoaderRoute: typeof PortalSpacesSpaceIdIndexRouteImport
      parentRoute: typeof PortalSpacesSpaceIdRoute
    }
    '/portal/myapp/$tableId/': {
      id: '/portal/myapp/$tableId/'
      path: '/$tableId'
      fullPath: '/portal/myapp/$tableId/'
      preLoaderRoute: typeof PortalMyappTableIdIndexRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/learning/review/': {
      id: '/portal/learning/review/'
      path: '/review'
      fullPath: '/portal/learning/review/'
      preLoaderRoute: typeof PortalLearningReviewIndexRouteImport
      parentRoute: typeof PortalLearningRoute
    }
    '/portal/knowledgebase-sql/insight-reports/': {
      id: '/portal/knowledgebase-sql/insight-reports/'
      path: '/insight-reports'
      fullPath: '/portal/knowledgebase-sql/insight-reports/'
      preLoaderRoute: typeof PortalKnowledgebaseSqlInsightReportsIndexRouteImport
      parentRoute: typeof PortalKnowledgebaseSqlRoute
    }
    '/portal/hr/settings/': {
      id: '/portal/hr/settings/'
      path: '/settings'
      fullPath: '/portal/hr/settings/'
      preLoaderRoute: typeof PortalHrSettingsIndexRouteImport
      parentRoute: typeof PortalHrRoute
    }
    '/portal/hr/rules/': {
      id: '/portal/hr/rules/'
      path: '/rules'
      fullPath: '/portal/hr/rules/'
      preLoaderRoute: typeof PortalHrRulesIndexRouteImport
      parentRoute: typeof PortalHrRoute
    }
    '/portal/hr/onboarding/': {
      id: '/portal/hr/onboarding/'
      path: '/onboarding'
      fullPath: '/portal/hr/onboarding/'
      preLoaderRoute: typeof PortalHrOnboardingIndexRouteImport
      parentRoute: typeof PortalHrRoute
    }
    '/portal/hr/forecast/': {
      id: '/portal/hr/forecast/'
      path: '/forecast'
      fullPath: '/portal/hr/forecast/'
      preLoaderRoute: typeof PortalHrForecastIndexRouteImport
      parentRoute: typeof PortalHrRoute
    }
    '/portal/hr/employees/': {
      id: '/portal/hr/employees/'
      path: '/employees'
      fullPath: '/portal/hr/employees/'
      preLoaderRoute: typeof PortalHrEmployeesIndexRouteImport
      parentRoute: typeof PortalHrRoute
    }
    '/portal/hr/allocations/': {
      id: '/portal/hr/allocations/'
      path: '/allocations'
      fullPath: '/portal/hr/allocations/'
      preLoaderRoute: typeof PortalHrAllocationsIndexRouteImport
      parentRoute: typeof PortalHrRoute
    }
    '/portal/connectors/$typeSlug/': {
      id: '/portal/connectors/$typeSlug/'
      path: '/connectors/$typeSlug'
      fullPath: '/portal/connectors/$typeSlug/'
      preLoaderRoute: typeof PortalConnectorsTypeSlugIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/apps/reporting/': {
      id: '/portal/apps/reporting/'
      path: '/apps/reporting'
      fullPath: '/portal/apps/reporting/'
      preLoaderRoute: typeof PortalAppsReportingIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/apps/$appSlug/': {
      id: '/portal/apps/$appSlug/'
      path: '/apps/$appSlug'
      fullPath: '/portal/apps/$appSlug/'
      preLoaderRoute: typeof PortalAppsAppSlugIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/forms/$slug/respond/': {
      id: '/forms/$slug/respond/'
      path: '/'
      fullPath: '/forms/$slug/respond/'
      preLoaderRoute: typeof FormsSlugRespondIndexRouteImport
      parentRoute: typeof FormsSlugRespondRoute
    }
    '/portal/workflows/projects_/$projectId': {
      id: '/portal/workflows/projects_/$projectId'
      path: '/projects/$projectId'
      fullPath: '/portal/workflows/projects/$projectId'
      preLoaderRoute: typeof PortalWorkflowsProjectsProjectIdRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/workflows/definitions_/new': {
      id: '/portal/workflows/definitions_/new'
      path: '/definitions/new'
      fullPath: '/portal/workflows/definitions/new'
      preLoaderRoute: typeof PortalWorkflowsDefinitionsNewRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/spaces/$spaceId/edit': {
      id: '/portal/spaces/$spaceId/edit'
      path: '/edit'
      fullPath: '/portal/spaces/$spaceId/edit'
      preLoaderRoute: typeof PortalSpacesSpaceIdEditRouteImport
      parentRoute: typeof PortalSpacesSpaceIdRoute
    }
    '/portal/platform/groups_/$groupId': {
      id: '/portal/platform/groups_/$groupId'
      path: '/groups/$groupId'
      fullPath: '/portal/platform/groups/$groupId'
      preLoaderRoute: typeof PortalPlatformGroupsGroupIdRouteImport
      parentRoute: typeof PortalPlatformRoute
    }
    '/portal/myapp/$tableId/submit': {
      id: '/portal/myapp/$tableId/submit'
      path: '/$tableId/submit'
      fullPath: '/portal/myapp/$tableId/submit'
      preLoaderRoute: typeof PortalMyappTableIdSubmitRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/myapp/$tableId/report': {
      id: '/portal/myapp/$tableId/report'
      path: '/$tableId/report'
      fullPath: '/portal/myapp/$tableId/report'
      preLoaderRoute: typeof PortalMyappTableIdReportRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/myapp/$tableId/print': {
      id: '/portal/myapp/$tableId/print'
      path: '/$tableId/print'
      fullPath: '/portal/myapp/$tableId/print'
      preLoaderRoute: typeof PortalMyappTableIdPrintRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/myapp/$tableId/permissions': {
      id: '/portal/myapp/$tableId/permissions'
      path: '/$tableId/permissions'
      fullPath: '/portal/myapp/$tableId/permissions'
      preLoaderRoute: typeof PortalMyappTableIdPermissionsRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/myapp/$tableId/kanban': {
      id: '/portal/myapp/$tableId/kanban'
      path: '/$tableId/kanban'
      fullPath: '/portal/myapp/$tableId/kanban'
      preLoaderRoute: typeof PortalMyappTableIdKanbanRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/myapp/$tableId/grid': {
      id: '/portal/myapp/$tableId/grid'
      path: '/$tableId/grid'
      fullPath: '/portal/myapp/$tableId/grid'
      preLoaderRoute: typeof PortalMyappTableIdGridRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/myapp/$tableId/edit': {
      id: '/portal/myapp/$tableId/edit'
      path: '/$tableId/edit'
      fullPath: '/portal/myapp/$tableId/edit'
      preLoaderRoute: typeof PortalMyappTableIdEditRouteImport
      parentRoute: typeof PortalMyappRoute
    }
    '/portal/learning/review/$attemptId': {
      id: '/portal/learning/review/$attemptId'
      path: '/review/$attemptId'
      fullPath: '/portal/learning/review/$attemptId'
      preLoaderRoute: typeof PortalLearningReviewAttemptIdRouteImport
      parentRoute: typeof PortalLearningRoute
    }
    '/portal/learning/attempt/$attemptId': {
      id: '/portal/learning/attempt/$attemptId'
      path: '/attempt/$attemptId'
      fullPath: '/portal/learning/attempt/$attemptId'
      preLoaderRoute: typeof PortalLearningAttemptAttemptIdRouteImport
      parentRoute: typeof PortalLearningRoute
    }
    '/portal/knowledgebase-sql/insight-reports/new': {
      id: '/portal/knowledgebase-sql/insight-reports/new'
      path: '/insight-reports/new'
      fullPath: '/portal/knowledgebase-sql/insight-reports/new'
      preLoaderRoute: typeof PortalKnowledgebaseSqlInsightReportsNewRouteImport
      parentRoute: typeof PortalKnowledgebaseSqlRoute
    }
    '/portal/knowledgebase-sql/insight-reports/$slug': {
      id: '/portal/knowledgebase-sql/insight-reports/$slug'
      path: '/insight-reports/$slug'
      fullPath: '/portal/knowledgebase-sql/insight-reports/$slug'
      preLoaderRoute: typeof PortalKnowledgebaseSqlInsightReportsSlugRouteImport
      parentRoute: typeof PortalKnowledgebaseSqlRoute
    }
    '/portal/knowledgebase-file/documents/$id': {
      id: '/portal/knowledgebase-file/documents/$id'
      path: '/$id'
      fullPath: '/portal/knowledgebase-file/documents/$id'
      preLoaderRoute: typeof PortalKnowledgebaseFileDocumentsIdRouteImport
      parentRoute: typeof PortalKnowledgebaseFileDocumentsRoute
    }
    '/portal/knowledgebase-file/batches/$id': {
      id: '/portal/knowledgebase-file/batches/$id'
      path: '/$id'
      fullPath: '/portal/knowledgebase-file/batches/$id'
      preLoaderRoute: typeof PortalKnowledgebaseFileBatchesIdRouteImport
      parentRoute: typeof PortalKnowledgebaseFileBatchesRoute
    }
    '/portal/hr/onboarding/$id': {
      id: '/portal/hr/onboarding/$id'
      path: '/onboarding/$id'
      fullPath: '/portal/hr/onboarding/$id'
      preLoaderRoute: typeof PortalHrOnboardingIdRouteImport
      parentRoute: typeof PortalHrRoute
    }
    '/portal/connectors/sqlserver/new': {
      id: '/portal/connectors/sqlserver/new'
      path: '/connectors/sqlserver/new'
      fullPath: '/portal/connectors/sqlserver/new'
      preLoaderRoute: typeof PortalConnectorsSqlserverNewRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/connectors/mysql/new': {
      id: '/portal/connectors/mysql/new'
      path: '/connectors/mysql/new'
      fullPath: '/portal/connectors/mysql/new'
      preLoaderRoute: typeof PortalConnectorsMysqlNewRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/connectors/$typeSlug/new': {
      id: '/portal/connectors/$typeSlug/new'
      path: '/connectors/$typeSlug/new'
      fullPath: '/portal/connectors/$typeSlug/new'
      preLoaderRoute: typeof PortalConnectorsTypeSlugNewRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/connectors/$typeSlug/manage': {
      id: '/portal/connectors/$typeSlug/manage'
      path: '/connectors/$typeSlug/manage'
      fullPath: '/portal/connectors/$typeSlug/manage'
      preLoaderRoute: typeof PortalConnectorsTypeSlugManageRouteImport
      parentRoute: typeof PortalRoute
    }
    '/forms/$slug/respond/success': {
      id: '/forms/$slug/respond/success'
      path: '/success'
      fullPath: '/forms/$slug/respond/success'
      preLoaderRoute: typeof FormsSlugRespondSuccessRouteImport
      parentRoute: typeof FormsSlugRespondRoute
    }
    '/portal/apps/reporting/model/': {
      id: '/portal/apps/reporting/model/'
      path: '/apps/reporting/model'
      fullPath: '/portal/apps/reporting/model/'
      preLoaderRoute: typeof PortalAppsReportingModelIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/apps/reporting/datasources/': {
      id: '/portal/apps/reporting/datasources/'
      path: '/apps/reporting/datasources'
      fullPath: '/portal/apps/reporting/datasources/'
      preLoaderRoute: typeof PortalAppsReportingDatasourcesIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/apps/reporting/custom/': {
      id: '/portal/apps/reporting/custom/'
      path: '/apps/reporting/custom'
      fullPath: '/portal/apps/reporting/custom/'
      preLoaderRoute: typeof PortalAppsReportingCustomIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal_/spaces/$spaceId/widget/$widgetId': {
      id: '/portal_/spaces/$spaceId/widget/$widgetId'
      path: '/portal/spaces/$spaceId/widget/$widgetId'
      fullPath: '/portal/spaces/$spaceId/widget/$widgetId'
      preLoaderRoute: typeof PortalSpacesSpaceIdWidgetWidgetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/workflows/definitions_/$key/new-version': {
      id: '/portal/workflows/definitions_/$key/new-version'
      path: '/definitions/$key/new-version'
      fullPath: '/portal/workflows/definitions/$key/new-version'
      preLoaderRoute: typeof PortalWorkflowsDefinitionsKeyNewVersionRouteImport
      parentRoute: typeof PortalWorkflowsRoute
    }
    '/portal/apps/reporting/datasources/new': {
      id: '/portal/apps/reporting/datasources/new'
      path: '/apps/reporting/datasources/new'
      fullPath: '/portal/apps/reporting/datasources/new'
      preLoaderRoute: typeof PortalAppsReportingDatasourcesNewRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/apps/reporting/datasources/$slug': {
      id: '/portal/apps/reporting/datasources/$slug'
      path: '/apps/reporting/datasources/$slug'
      fullPath: '/portal/apps/reporting/datasources/$slug'
      preLoaderRoute: typeof PortalAppsReportingDatasourcesSlugRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/apps/reporting/custom/new': {
      id: '/portal/apps/reporting/custom/new'
      path: '/apps/reporting/custom/new'
      fullPath: '/portal/apps/reporting/custom/new'
      preLoaderRoute: typeof PortalAppsReportingCustomNewRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/apps/reporting/custom/$slug': {
      id: '/portal/apps/reporting/custom/$slug'
      path: '/apps/reporting/custom/$slug'
      fullPath: '/portal/apps/reporting/custom/$slug'
      preLoaderRoute: typeof PortalAppsReportingCustomSlugRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal_/apps/reporting/custom/$slug/window': {
      id: '/portal_/apps/reporting/custom/$slug/window'
      path: '/portal/apps/reporting/custom/$slug/window'
      fullPath: '/portal/apps/reporting/custom/$slug/window'
      preLoaderRoute: typeof PortalAppsReportingCustomSlugWindowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/apps/reporting/datasources/$slug_/edit': {
      id: '/portal/apps/reporting/datasources/$slug_/edit'
      path: '/apps/reporting/datasources/$slug/edit'
      fullPath: '/portal/apps/reporting/datasources/$slug/edit'
      preLoaderRoute: typeof PortalAppsReportingDatasourcesSlugEditRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/apps/reporting/custom/$slug_/edit': {
      id: '/portal/apps/reporting/custom/$slug_/edit'
      path: '/apps/reporting/custom/$slug/edit'
      fullPath: '/portal/apps/reporting/custom/$slug/edit'
      preLoaderRoute: typeof PortalAppsReportingCustomSlugEditRouteImport
      parentRoute: typeof PortalRoute
    }
  }
}

interface ConnectorsRouteChildren {
  ConnectorsProductRoute: typeof ConnectorsProductRoute
  ConnectorsXeroCaseStudyRoute: typeof ConnectorsXeroCaseStudyRoute
  ConnectorsIndexRoute: typeof ConnectorsIndexRoute
}

const ConnectorsRouteChildren: ConnectorsRouteChildren = {
  ConnectorsProductRoute: ConnectorsProductRoute,
  ConnectorsXeroCaseStudyRoute: ConnectorsXeroCaseStudyRoute,
  ConnectorsIndexRoute: ConnectorsIndexRoute,
}

const ConnectorsRouteWithChildren = ConnectorsRoute._addFileChildren(
  ConnectorsRouteChildren,
)

interface PortalAiContentRouteChildren {
  PortalAiContentHistoryRoute: typeof PortalAiContentHistoryRoute
  PortalAiContentIndexRoute: typeof PortalAiContentIndexRoute
}

const PortalAiContentRouteChildren: PortalAiContentRouteChildren = {
  PortalAiContentHistoryRoute: PortalAiContentHistoryRoute,
  PortalAiContentIndexRoute: PortalAiContentIndexRoute,
}

const PortalAiContentRouteWithChildren = PortalAiContentRoute._addFileChildren(
  PortalAiContentRouteChildren,
)

interface PortalAutomationRouteChildren {
  PortalAutomationAgentEntitlementsRoute: typeof PortalAutomationAgentEntitlementsRoute
  PortalAutomationAuditRoute: typeof PortalAutomationAuditRoute
  PortalAutomationContentReviewRoute: typeof PortalAutomationContentReviewRoute
  PortalAutomationCredentialsRoute: typeof PortalAutomationCredentialsRoute
  PortalAutomationDashboardRoute: typeof PortalAutomationDashboardRoute
  PortalAutomationLlmRoute: typeof PortalAutomationLlmRoute
  PortalAutomationMcpRoute: typeof PortalAutomationMcpRoute
  PortalAutomationMonitoringRoute: typeof PortalAutomationMonitoringRoute
  PortalAutomationPoliciesRoute: typeof PortalAutomationPoliciesRoute
  PortalAutomationSkillsRoute: typeof PortalAutomationSkillsRoute
  PortalAutomationWebhooksRoute: typeof PortalAutomationWebhooksRoute
  PortalAutomationWorkflowsRoute: typeof PortalAutomationWorkflowsRoute
  PortalAutomationIndexRoute: typeof PortalAutomationIndexRoute
}

const PortalAutomationRouteChildren: PortalAutomationRouteChildren = {
  PortalAutomationAgentEntitlementsRoute:
    PortalAutomationAgentEntitlementsRoute,
  PortalAutomationAuditRoute: PortalAutomationAuditRoute,
  PortalAutomationContentReviewRoute: PortalAutomationContentReviewRoute,
  PortalAutomationCredentialsRoute: PortalAutomationCredentialsRoute,
  PortalAutomationDashboardRoute: PortalAutomationDashboardRoute,
  PortalAutomationLlmRoute: PortalAutomationLlmRoute,
  PortalAutomationMcpRoute: PortalAutomationMcpRoute,
  PortalAutomationMonitoringRoute: PortalAutomationMonitoringRoute,
  PortalAutomationPoliciesRoute: PortalAutomationPoliciesRoute,
  PortalAutomationSkillsRoute: PortalAutomationSkillsRoute,
  PortalAutomationWebhooksRoute: PortalAutomationWebhooksRoute,
  PortalAutomationWorkflowsRoute: PortalAutomationWorkflowsRoute,
  PortalAutomationIndexRoute: PortalAutomationIndexRoute,
}

const PortalAutomationRouteWithChildren =
  PortalAutomationRoute._addFileChildren(PortalAutomationRouteChildren)

interface PortalFtpRouteChildren {
  PortalFtpAuditRoute: typeof PortalFtpAuditRoute
  PortalFtpConnectionsRoute: typeof PortalFtpConnectionsRoute
  PortalFtpFilesRoute: typeof PortalFtpFilesRoute
  PortalFtpUsersRoute: typeof PortalFtpUsersRoute
  PortalFtpIndexRoute: typeof PortalFtpIndexRoute
}

const PortalFtpRouteChildren: PortalFtpRouteChildren = {
  PortalFtpAuditRoute: PortalFtpAuditRoute,
  PortalFtpConnectionsRoute: PortalFtpConnectionsRoute,
  PortalFtpFilesRoute: PortalFtpFilesRoute,
  PortalFtpUsersRoute: PortalFtpUsersRoute,
  PortalFtpIndexRoute: PortalFtpIndexRoute,
}

const PortalFtpRouteWithChildren = PortalFtpRoute._addFileChildren(
  PortalFtpRouteChildren,
)

interface PortalHrRouteChildren {
  PortalHrIndexRoute: typeof PortalHrIndexRoute
  PortalHrOnboardingIdRoute: typeof PortalHrOnboardingIdRoute
  PortalHrAllocationsIndexRoute: typeof PortalHrAllocationsIndexRoute
  PortalHrEmployeesIndexRoute: typeof PortalHrEmployeesIndexRoute
  PortalHrForecastIndexRoute: typeof PortalHrForecastIndexRoute
  PortalHrOnboardingIndexRoute: typeof PortalHrOnboardingIndexRoute
  PortalHrRulesIndexRoute: typeof PortalHrRulesIndexRoute
  PortalHrSettingsIndexRoute: typeof PortalHrSettingsIndexRoute
}

const PortalHrRouteChildren: PortalHrRouteChildren = {
  PortalHrIndexRoute: PortalHrIndexRoute,
  PortalHrOnboardingIdRoute: PortalHrOnboardingIdRoute,
  PortalHrAllocationsIndexRoute: PortalHrAllocationsIndexRoute,
  PortalHrEmployeesIndexRoute: PortalHrEmployeesIndexRoute,
  PortalHrForecastIndexRoute: PortalHrForecastIndexRoute,
  PortalHrOnboardingIndexRoute: PortalHrOnboardingIndexRoute,
  PortalHrRulesIndexRoute: PortalHrRulesIndexRoute,
  PortalHrSettingsIndexRoute: PortalHrSettingsIndexRoute,
}

const PortalHrRouteWithChildren = PortalHrRoute._addFileChildren(
  PortalHrRouteChildren,
)

interface PortalKnowledgebaseFileBatchesRouteChildren {
  PortalKnowledgebaseFileBatchesIdRoute: typeof PortalKnowledgebaseFileBatchesIdRoute
}

const PortalKnowledgebaseFileBatchesRouteChildren: PortalKnowledgebaseFileBatchesRouteChildren =
  {
    PortalKnowledgebaseFileBatchesIdRoute:
      PortalKnowledgebaseFileBatchesIdRoute,
  }

const PortalKnowledgebaseFileBatchesRouteWithChildren =
  PortalKnowledgebaseFileBatchesRoute._addFileChildren(
    PortalKnowledgebaseFileBatchesRouteChildren,
  )

interface PortalKnowledgebaseFileDocumentsRouteChildren {
  PortalKnowledgebaseFileDocumentsIdRoute: typeof PortalKnowledgebaseFileDocumentsIdRoute
}

const PortalKnowledgebaseFileDocumentsRouteChildren: PortalKnowledgebaseFileDocumentsRouteChildren =
  {
    PortalKnowledgebaseFileDocumentsIdRoute:
      PortalKnowledgebaseFileDocumentsIdRoute,
  }

const PortalKnowledgebaseFileDocumentsRouteWithChildren =
  PortalKnowledgebaseFileDocumentsRoute._addFileChildren(
    PortalKnowledgebaseFileDocumentsRouteChildren,
  )

interface PortalKnowledgebaseFileRouteChildren {
  PortalKnowledgebaseFileBatchesRoute: typeof PortalKnowledgebaseFileBatchesRouteWithChildren
  PortalKnowledgebaseFileCategoriesRoute: typeof PortalKnowledgebaseFileCategoriesRoute
  PortalKnowledgebaseFileCategoryReviewRoute: typeof PortalKnowledgebaseFileCategoryReviewRoute
  PortalKnowledgebaseFileDocumentsRoute: typeof PortalKnowledgebaseFileDocumentsRouteWithChildren
  PortalKnowledgebaseFileLabelsRoute: typeof PortalKnowledgebaseFileLabelsRoute
  PortalKnowledgebaseFileQueryRoute: typeof PortalKnowledgebaseFileQueryRoute
  PortalKnowledgebaseFileTemplatesRoute: typeof PortalKnowledgebaseFileTemplatesRoute
  PortalKnowledgebaseFileUploadRoute: typeof PortalKnowledgebaseFileUploadRoute
  PortalKnowledgebaseFileIndexRoute: typeof PortalKnowledgebaseFileIndexRoute
}

const PortalKnowledgebaseFileRouteChildren: PortalKnowledgebaseFileRouteChildren =
  {
    PortalKnowledgebaseFileBatchesRoute:
      PortalKnowledgebaseFileBatchesRouteWithChildren,
    PortalKnowledgebaseFileCategoriesRoute:
      PortalKnowledgebaseFileCategoriesRoute,
    PortalKnowledgebaseFileCategoryReviewRoute:
      PortalKnowledgebaseFileCategoryReviewRoute,
    PortalKnowledgebaseFileDocumentsRoute:
      PortalKnowledgebaseFileDocumentsRouteWithChildren,
    PortalKnowledgebaseFileLabelsRoute: PortalKnowledgebaseFileLabelsRoute,
    PortalKnowledgebaseFileQueryRoute: PortalKnowledgebaseFileQueryRoute,
    PortalKnowledgebaseFileTemplatesRoute:
      PortalKnowledgebaseFileTemplatesRoute,
    PortalKnowledgebaseFileUploadRoute: PortalKnowledgebaseFileUploadRoute,
    PortalKnowledgebaseFileIndexRoute: PortalKnowledgebaseFileIndexRoute,
  }

const PortalKnowledgebaseFileRouteWithChildren =
  PortalKnowledgebaseFileRoute._addFileChildren(
    PortalKnowledgebaseFileRouteChildren,
  )

interface PortalKnowledgebaseSqlRouteChildren {
  PortalKnowledgebaseSqlConnectRoute: typeof PortalKnowledgebaseSqlConnectRoute
  PortalKnowledgebaseSqlDataSourcesRoute: typeof PortalKnowledgebaseSqlDataSourcesRoute
  PortalKnowledgebaseSqlGlossaryRoute: typeof PortalKnowledgebaseSqlGlossaryRoute
  PortalKnowledgebaseSqlQueryRoute: typeof PortalKnowledgebaseSqlQueryRoute
  PortalKnowledgebaseSqlQuickQuestionRoute: typeof PortalKnowledgebaseSqlQuickQuestionRoute
  PortalKnowledgebaseSqlIndexRoute: typeof PortalKnowledgebaseSqlIndexRoute
  PortalKnowledgebaseSqlInsightReportsSlugRoute: typeof PortalKnowledgebaseSqlInsightReportsSlugRoute
  PortalKnowledgebaseSqlInsightReportsNewRoute: typeof PortalKnowledgebaseSqlInsightReportsNewRoute
  PortalKnowledgebaseSqlInsightReportsIndexRoute: typeof PortalKnowledgebaseSqlInsightReportsIndexRoute
}

const PortalKnowledgebaseSqlRouteChildren: PortalKnowledgebaseSqlRouteChildren =
  {
    PortalKnowledgebaseSqlConnectRoute: PortalKnowledgebaseSqlConnectRoute,
    PortalKnowledgebaseSqlDataSourcesRoute:
      PortalKnowledgebaseSqlDataSourcesRoute,
    PortalKnowledgebaseSqlGlossaryRoute: PortalKnowledgebaseSqlGlossaryRoute,
    PortalKnowledgebaseSqlQueryRoute: PortalKnowledgebaseSqlQueryRoute,
    PortalKnowledgebaseSqlQuickQuestionRoute:
      PortalKnowledgebaseSqlQuickQuestionRoute,
    PortalKnowledgebaseSqlIndexRoute: PortalKnowledgebaseSqlIndexRoute,
    PortalKnowledgebaseSqlInsightReportsSlugRoute:
      PortalKnowledgebaseSqlInsightReportsSlugRoute,
    PortalKnowledgebaseSqlInsightReportsNewRoute:
      PortalKnowledgebaseSqlInsightReportsNewRoute,
    PortalKnowledgebaseSqlInsightReportsIndexRoute:
      PortalKnowledgebaseSqlInsightReportsIndexRoute,
  }

const PortalKnowledgebaseSqlRouteWithChildren =
  PortalKnowledgebaseSqlRoute._addFileChildren(
    PortalKnowledgebaseSqlRouteChildren,
  )

interface PortalLearningRouteChildren {
  PortalLearningIndexRoute: typeof PortalLearningIndexRoute
  PortalLearningAttemptAttemptIdRoute: typeof PortalLearningAttemptAttemptIdRoute
  PortalLearningReviewAttemptIdRoute: typeof PortalLearningReviewAttemptIdRoute
  PortalLearningReviewIndexRoute: typeof PortalLearningReviewIndexRoute
}

const PortalLearningRouteChildren: PortalLearningRouteChildren = {
  PortalLearningIndexRoute: PortalLearningIndexRoute,
  PortalLearningAttemptAttemptIdRoute: PortalLearningAttemptAttemptIdRoute,
  PortalLearningReviewAttemptIdRoute: PortalLearningReviewAttemptIdRoute,
  PortalLearningReviewIndexRoute: PortalLearningReviewIndexRoute,
}

const PortalLearningRouteWithChildren = PortalLearningRoute._addFileChildren(
  PortalLearningRouteChildren,
)

interface PortalLmsRouteChildren {
  PortalLmsAssignRoute: typeof PortalLmsAssignRoute
  PortalLmsAuthorRoute: typeof PortalLmsAuthorRoute
  PortalLmsCurationRoute: typeof PortalLmsCurationRoute
  PortalLmsCyclesRoute: typeof PortalLmsCyclesRoute
  PortalLmsLeaderboardRoute: typeof PortalLmsLeaderboardRoute
  PortalLmsIndexRoute: typeof PortalLmsIndexRoute
}

const PortalLmsRouteChildren: PortalLmsRouteChildren = {
  PortalLmsAssignRoute: PortalLmsAssignRoute,
  PortalLmsAuthorRoute: PortalLmsAuthorRoute,
  PortalLmsCurationRoute: PortalLmsCurationRoute,
  PortalLmsCyclesRoute: PortalLmsCyclesRoute,
  PortalLmsLeaderboardRoute: PortalLmsLeaderboardRoute,
  PortalLmsIndexRoute: PortalLmsIndexRoute,
}

const PortalLmsRouteWithChildren = PortalLmsRoute._addFileChildren(
  PortalLmsRouteChildren,
)

interface PortalMessagingRouteChildren {
  PortalMessagingInboxRoute: typeof PortalMessagingInboxRoute
  PortalMessagingTemplatesRoute: typeof PortalMessagingTemplatesRoute
  PortalMessagingWhatsappSetupRoute: typeof PortalMessagingWhatsappSetupRoute
  PortalMessagingIndexRoute: typeof PortalMessagingIndexRoute
}

const PortalMessagingRouteChildren: PortalMessagingRouteChildren = {
  PortalMessagingInboxRoute: PortalMessagingInboxRoute,
  PortalMessagingTemplatesRoute: PortalMessagingTemplatesRoute,
  PortalMessagingWhatsappSetupRoute: PortalMessagingWhatsappSetupRoute,
  PortalMessagingIndexRoute: PortalMessagingIndexRoute,
}

const PortalMessagingRouteWithChildren = PortalMessagingRoute._addFileChildren(
  PortalMessagingRouteChildren,
)

interface PortalMyappRouteChildren {
  PortalMyappAppsRoute: typeof PortalMyappAppsRoute
  PortalMyappAreasRoute: typeof PortalMyappAreasRoute
  PortalMyappBridgeRoute: typeof PortalMyappBridgeRoute
  PortalMyappTablesRoute: typeof PortalMyappTablesRoute
  PortalMyappIndexRoute: typeof PortalMyappIndexRoute
  PortalMyappTableIdEditRoute: typeof PortalMyappTableIdEditRoute
  PortalMyappTableIdGridRoute: typeof PortalMyappTableIdGridRoute
  PortalMyappTableIdKanbanRoute: typeof PortalMyappTableIdKanbanRoute
  PortalMyappTableIdPermissionsRoute: typeof PortalMyappTableIdPermissionsRoute
  PortalMyappTableIdPrintRoute: typeof PortalMyappTableIdPrintRoute
  PortalMyappTableIdReportRoute: typeof PortalMyappTableIdReportRoute
  PortalMyappTableIdSubmitRoute: typeof PortalMyappTableIdSubmitRoute
  PortalMyappTableIdIndexRoute: typeof PortalMyappTableIdIndexRoute
}

const PortalMyappRouteChildren: PortalMyappRouteChildren = {
  PortalMyappAppsRoute: PortalMyappAppsRoute,
  PortalMyappAreasRoute: PortalMyappAreasRoute,
  PortalMyappBridgeRoute: PortalMyappBridgeRoute,
  PortalMyappTablesRoute: PortalMyappTablesRoute,
  PortalMyappIndexRoute: PortalMyappIndexRoute,
  PortalMyappTableIdEditRoute: PortalMyappTableIdEditRoute,
  PortalMyappTableIdGridRoute: PortalMyappTableIdGridRoute,
  PortalMyappTableIdKanbanRoute: PortalMyappTableIdKanbanRoute,
  PortalMyappTableIdPermissionsRoute: PortalMyappTableIdPermissionsRoute,
  PortalMyappTableIdPrintRoute: PortalMyappTableIdPrintRoute,
  PortalMyappTableIdReportRoute: PortalMyappTableIdReportRoute,
  PortalMyappTableIdSubmitRoute: PortalMyappTableIdSubmitRoute,
  PortalMyappTableIdIndexRoute: PortalMyappTableIdIndexRoute,
}

const PortalMyappRouteWithChildren = PortalMyappRoute._addFileChildren(
  PortalMyappRouteChildren,
)

interface PortalPlatformRouteChildren {
  PortalPlatformApiKeysRoute: typeof PortalPlatformApiKeysRoute
  PortalPlatformBillingRoute: typeof PortalPlatformBillingRoute
  PortalPlatformBillingOverviewRoute: typeof PortalPlatformBillingOverviewRoute
  PortalPlatformCategoriesRoute: typeof PortalPlatformCategoriesRoute
  PortalPlatformChartSettingsRoute: typeof PortalPlatformChartSettingsRoute
  PortalPlatformClientOnboardingRoute: typeof PortalPlatformClientOnboardingRoute
  PortalPlatformConnectorEnrichmentRoute: typeof PortalPlatformConnectorEnrichmentRoute
  PortalPlatformConnectorsRoute: typeof PortalPlatformConnectorsRoute
  PortalPlatformDiscountsRoute: typeof PortalPlatformDiscountsRoute
  PortalPlatformGroupsRoute: typeof PortalPlatformGroupsRoute
  PortalPlatformInboundDeadLettersRoute: typeof PortalPlatformInboundDeadLettersRoute
  PortalPlatformInfrastructureRoute: typeof PortalPlatformInfrastructureRoute
  PortalPlatformMaintenanceRoute: typeof PortalPlatformMaintenanceRoute
  PortalPlatformMonitoringRoute: typeof PortalPlatformMonitoringRoute
  PortalPlatformObjectPermissionsRoute: typeof PortalPlatformObjectPermissionsRoute
  PortalPlatformOrganisationsRoute: typeof PortalPlatformOrganisationsRoute
  PortalPlatformOrphanedSchedulesRoute: typeof PortalPlatformOrphanedSchedulesRoute
  PortalPlatformPipelinesRoute: typeof PortalPlatformPipelinesRoute
  PortalPlatformPricingRoute: typeof PortalPlatformPricingRoute
  PortalPlatformProductsRoute: typeof PortalPlatformProductsRoute
  PortalPlatformProfileRoute: typeof PortalPlatformProfileRoute
  PortalPlatformRbacRoute: typeof PortalPlatformRbacRoute
  PortalPlatformSchemaDriftRoute: typeof PortalPlatformSchemaDriftRoute
  PortalPlatformSdlcRoute: typeof PortalPlatformSdlcRoute
  PortalPlatformSecretsRoute: typeof PortalPlatformSecretsRoute
  PortalPlatformSecurityRoute: typeof PortalPlatformSecurityRoute
  PortalPlatformSettingsRoute: typeof PortalPlatformSettingsRoute
  PortalPlatformSubscriptionsRoute: typeof PortalPlatformSubscriptionsRoute
  PortalPlatformThemeRoute: typeof PortalPlatformThemeRoute
  PortalPlatformTiersRoute: typeof PortalPlatformTiersRoute
  PortalPlatformUsersRoute: typeof PortalPlatformUsersRoute
  PortalPlatformGroupsGroupIdRoute: typeof PortalPlatformGroupsGroupIdRoute
}

const PortalPlatformRouteChildren: PortalPlatformRouteChildren = {
  PortalPlatformApiKeysRoute: PortalPlatformApiKeysRoute,
  PortalPlatformBillingRoute: PortalPlatformBillingRoute,
  PortalPlatformBillingOverviewRoute: PortalPlatformBillingOverviewRoute,
  PortalPlatformCategoriesRoute: PortalPlatformCategoriesRoute,
  PortalPlatformChartSettingsRoute: PortalPlatformChartSettingsRoute,
  PortalPlatformClientOnboardingRoute: PortalPlatformClientOnboardingRoute,
  PortalPlatformConnectorEnrichmentRoute:
    PortalPlatformConnectorEnrichmentRoute,
  PortalPlatformConnectorsRoute: PortalPlatformConnectorsRoute,
  PortalPlatformDiscountsRoute: PortalPlatformDiscountsRoute,
  PortalPlatformGroupsRoute: PortalPlatformGroupsRoute,
  PortalPlatformInboundDeadLettersRoute: PortalPlatformInboundDeadLettersRoute,
  PortalPlatformInfrastructureRoute: PortalPlatformInfrastructureRoute,
  PortalPlatformMaintenanceRoute: PortalPlatformMaintenanceRoute,
  PortalPlatformMonitoringRoute: PortalPlatformMonitoringRoute,
  PortalPlatformObjectPermissionsRoute: PortalPlatformObjectPermissionsRoute,
  PortalPlatformOrganisationsRoute: PortalPlatformOrganisationsRoute,
  PortalPlatformOrphanedSchedulesRoute: PortalPlatformOrphanedSchedulesRoute,
  PortalPlatformPipelinesRoute: PortalPlatformPipelinesRoute,
  PortalPlatformPricingRoute: PortalPlatformPricingRoute,
  PortalPlatformProductsRoute: PortalPlatformProductsRoute,
  PortalPlatformProfileRoute: PortalPlatformProfileRoute,
  PortalPlatformRbacRoute: PortalPlatformRbacRoute,
  PortalPlatformSchemaDriftRoute: PortalPlatformSchemaDriftRoute,
  PortalPlatformSdlcRoute: PortalPlatformSdlcRoute,
  PortalPlatformSecretsRoute: PortalPlatformSecretsRoute,
  PortalPlatformSecurityRoute: PortalPlatformSecurityRoute,
  PortalPlatformSettingsRoute: PortalPlatformSettingsRoute,
  PortalPlatformSubscriptionsRoute: PortalPlatformSubscriptionsRoute,
  PortalPlatformThemeRoute: PortalPlatformThemeRoute,
  PortalPlatformTiersRoute: PortalPlatformTiersRoute,
  PortalPlatformUsersRoute: PortalPlatformUsersRoute,
  PortalPlatformGroupsGroupIdRoute: PortalPlatformGroupsGroupIdRoute,
}

const PortalPlatformRouteWithChildren = PortalPlatformRoute._addFileChildren(
  PortalPlatformRouteChildren,
)

interface PortalWorkflowsRouteChildren {
  PortalWorkflowsCanvasDemoRoute: typeof PortalWorkflowsCanvasDemoRoute
  PortalWorkflowsDefinitionsRoute: typeof PortalWorkflowsDefinitionsRoute
  PortalWorkflowsDlqRoute: typeof PortalWorkflowsDlqRoute
  PortalWorkflowsExecuteRoute: typeof PortalWorkflowsExecuteRoute
  PortalWorkflowsExecutionsRoute: typeof PortalWorkflowsExecutionsRoute
  PortalWorkflowsProjectsRoute: typeof PortalWorkflowsProjectsRoute
  PortalWorkflowsRetryFailuresRoute: typeof PortalWorkflowsRetryFailuresRoute
  PortalWorkflowsTemplatesRoute: typeof PortalWorkflowsTemplatesRoute
  PortalWorkflowsTopologyRoute: typeof PortalWorkflowsTopologyRoute
  PortalWorkflowsIndexRoute: typeof PortalWorkflowsIndexRoute
  PortalWorkflowsDefinitionsNewRoute: typeof PortalWorkflowsDefinitionsNewRoute
  PortalWorkflowsProjectsProjectIdRoute: typeof PortalWorkflowsProjectsProjectIdRoute
  PortalWorkflowsDefinitionsKeyNewVersionRoute: typeof PortalWorkflowsDefinitionsKeyNewVersionRoute
}

const PortalWorkflowsRouteChildren: PortalWorkflowsRouteChildren = {
  PortalWorkflowsCanvasDemoRoute: PortalWorkflowsCanvasDemoRoute,
  PortalWorkflowsDefinitionsRoute: PortalWorkflowsDefinitionsRoute,
  PortalWorkflowsDlqRoute: PortalWorkflowsDlqRoute,
  PortalWorkflowsExecuteRoute: PortalWorkflowsExecuteRoute,
  PortalWorkflowsExecutionsRoute: PortalWorkflowsExecutionsRoute,
  PortalWorkflowsProjectsRoute: PortalWorkflowsProjectsRoute,
  PortalWorkflowsRetryFailuresRoute: PortalWorkflowsRetryFailuresRoute,
  PortalWorkflowsTemplatesRoute: PortalWorkflowsTemplatesRoute,
  PortalWorkflowsTopologyRoute: PortalWorkflowsTopologyRoute,
  PortalWorkflowsIndexRoute: PortalWorkflowsIndexRoute,
  PortalWorkflowsDefinitionsNewRoute: PortalWorkflowsDefinitionsNewRoute,
  PortalWorkflowsProjectsProjectIdRoute: PortalWorkflowsProjectsProjectIdRoute,
  PortalWorkflowsDefinitionsKeyNewVersionRoute:
    PortalWorkflowsDefinitionsKeyNewVersionRoute,
}

const PortalWorkflowsRouteWithChildren = PortalWorkflowsRoute._addFileChildren(
  PortalWorkflowsRouteChildren,
)

interface PortalSpacesSpaceIdRouteChildren {
  PortalSpacesSpaceIdEditRoute: typeof PortalSpacesSpaceIdEditRoute
  PortalSpacesSpaceIdIndexRoute: typeof PortalSpacesSpaceIdIndexRoute
}

const PortalSpacesSpaceIdRouteChildren: PortalSpacesSpaceIdRouteChildren = {
  PortalSpacesSpaceIdEditRoute: PortalSpacesSpaceIdEditRoute,
  PortalSpacesSpaceIdIndexRoute: PortalSpacesSpaceIdIndexRoute,
}

const PortalSpacesSpaceIdRouteWithChildren =
  PortalSpacesSpaceIdRoute._addFileChildren(PortalSpacesSpaceIdRouteChildren)

interface PortalRouteChildren {
  PortalAiContentRoute: typeof PortalAiContentRouteWithChildren
  PortalAssetLibraryRoute: typeof PortalAssetLibraryRoute
  PortalAutomationRoute: typeof PortalAutomationRouteWithChildren
  PortalCatalogueIntelligenceRoute: typeof PortalCatalogueIntelligenceRoute
  PortalFtpRoute: typeof PortalFtpRouteWithChildren
  PortalHrRoute: typeof PortalHrRouteWithChildren
  PortalKnowledgebaseFileRoute: typeof PortalKnowledgebaseFileRouteWithChildren
  PortalKnowledgebaseSqlRoute: typeof PortalKnowledgebaseSqlRouteWithChildren
  PortalLearningRoute: typeof PortalLearningRouteWithChildren
  PortalLmsRoute: typeof PortalLmsRouteWithChildren
  PortalMessagingRoute: typeof PortalMessagingRouteWithChildren
  PortalMyappRoute: typeof PortalMyappRouteWithChildren
  PortalPlatformRoute: typeof PortalPlatformRouteWithChildren
  PortalWorkflowsRoute: typeof PortalWorkflowsRouteWithChildren
  PortalIndexRoute: typeof PortalIndexRoute
  PortalAppsExpenseRoute: typeof PortalAppsExpenseRoute
  PortalOrganisationCategoriesRoute: typeof PortalOrganisationCategoriesRoute
  PortalOrganisationMembersRoute: typeof PortalOrganisationMembersRoute
  PortalOrganisationSettingsRoute: typeof PortalOrganisationSettingsRoute
  PortalOrganisationThemeRoute: typeof PortalOrganisationThemeRoute
  PortalSpacesSpaceIdRoute: typeof PortalSpacesSpaceIdRouteWithChildren
  PortalSpacesNewRoute: typeof PortalSpacesNewRoute
  PortalAppsIndexRoute: typeof PortalAppsIndexRoute
  PortalConnectorsIndexRoute: typeof PortalConnectorsIndexRoute
  PortalSpacesIndexRoute: typeof PortalSpacesIndexRoute
  PortalConnectorsTypeSlugManageRoute: typeof PortalConnectorsTypeSlugManageRoute
  PortalConnectorsTypeSlugNewRoute: typeof PortalConnectorsTypeSlugNewRoute
  PortalConnectorsMysqlNewRoute: typeof PortalConnectorsMysqlNewRoute
  PortalConnectorsSqlserverNewRoute: typeof PortalConnectorsSqlserverNewRoute
  PortalAppsAppSlugIndexRoute: typeof PortalAppsAppSlugIndexRoute
  PortalAppsReportingIndexRoute: typeof PortalAppsReportingIndexRoute
  PortalConnectorsTypeSlugIndexRoute: typeof PortalConnectorsTypeSlugIndexRoute
  PortalAppsReportingCustomSlugRoute: typeof PortalAppsReportingCustomSlugRoute
  PortalAppsReportingCustomNewRoute: typeof PortalAppsReportingCustomNewRoute
  PortalAppsReportingDatasourcesSlugRoute: typeof PortalAppsReportingDatasourcesSlugRoute
  PortalAppsReportingDatasourcesNewRoute: typeof PortalAppsReportingDatasourcesNewRoute
  PortalAppsReportingCustomIndexRoute: typeof PortalAppsReportingCustomIndexRoute
  PortalAppsReportingDatasourcesIndexRoute: typeof PortalAppsReportingDatasourcesIndexRoute
  PortalAppsReportingModelIndexRoute: typeof PortalAppsReportingModelIndexRoute
  PortalAppsReportingCustomSlugEditRoute: typeof PortalAppsReportingCustomSlugEditRoute
  PortalAppsReportingDatasourcesSlugEditRoute: typeof PortalAppsReportingDatasourcesSlugEditRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalAiContentRoute: PortalAiContentRouteWithChildren,
  PortalAssetLibraryRoute: PortalAssetLibraryRoute,
  PortalAutomationRoute: PortalAutomationRouteWithChildren,
  PortalCatalogueIntelligenceRoute: PortalCatalogueIntelligenceRoute,
  PortalFtpRoute: PortalFtpRouteWithChildren,
  PortalHrRoute: PortalHrRouteWithChildren,
  PortalKnowledgebaseFileRoute: PortalKnowledgebaseFileRouteWithChildren,
  PortalKnowledgebaseSqlRoute: PortalKnowledgebaseSqlRouteWithChildren,
  PortalLearningRoute: PortalLearningRouteWithChildren,
  PortalLmsRoute: PortalLmsRouteWithChildren,
  PortalMessagingRoute: PortalMessagingRouteWithChildren,
  PortalMyappRoute: PortalMyappRouteWithChildren,
  PortalPlatformRoute: PortalPlatformRouteWithChildren,
  PortalWorkflowsRoute: PortalWorkflowsRouteWithChildren,
  PortalIndexRoute: PortalIndexRoute,
  PortalAppsExpenseRoute: PortalAppsExpenseRoute,
  PortalOrganisationCategoriesRoute: PortalOrganisationCategoriesRoute,
  PortalOrganisationMembersRoute: PortalOrganisationMembersRoute,
  PortalOrganisationSettingsRoute: PortalOrganisationSettingsRoute,
  PortalOrganisationThemeRoute: PortalOrganisationThemeRoute,
  PortalSpacesSpaceIdRoute: PortalSpacesSpaceIdRouteWithChildren,
  PortalSpacesNewRoute: PortalSpacesNewRoute,
  PortalAppsIndexRoute: PortalAppsIndexRoute,
  PortalConnectorsIndexRoute: PortalConnectorsIndexRoute,
  PortalSpacesIndexRoute: PortalSpacesIndexRoute,
  PortalConnectorsTypeSlugManageRoute: PortalConnectorsTypeSlugManageRoute,
  PortalConnectorsTypeSlugNewRoute: PortalConnectorsTypeSlugNewRoute,
  PortalConnectorsMysqlNewRoute: PortalConnectorsMysqlNewRoute,
  PortalConnectorsSqlserverNewRoute: PortalConnectorsSqlserverNewRoute,
  PortalAppsAppSlugIndexRoute: PortalAppsAppSlugIndexRoute,
  PortalAppsReportingIndexRoute: PortalAppsReportingIndexRoute,
  PortalConnectorsTypeSlugIndexRoute: PortalConnectorsTypeSlugIndexRoute,
  PortalAppsReportingCustomSlugRoute: PortalAppsReportingCustomSlugRoute,
  PortalAppsReportingCustomNewRoute: PortalAppsReportingCustomNewRoute,
  PortalAppsReportingDatasourcesSlugRoute:
    PortalAppsReportingDatasourcesSlugRoute,
  PortalAppsReportingDatasourcesNewRoute:
    PortalAppsReportingDatasourcesNewRoute,
  PortalAppsReportingCustomIndexRoute: PortalAppsReportingCustomIndexRoute,
  PortalAppsReportingDatasourcesIndexRoute:
    PortalAppsReportingDatasourcesIndexRoute,
  PortalAppsReportingModelIndexRoute: PortalAppsReportingModelIndexRoute,
  PortalAppsReportingCustomSlugEditRoute:
    PortalAppsReportingCustomSlugEditRoute,
  PortalAppsReportingDatasourcesSlugEditRoute:
    PortalAppsReportingDatasourcesSlugEditRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

interface FormsSlugRespondRouteChildren {
  FormsSlugRespondSuccessRoute: typeof FormsSlugRespondSuccessRoute
  FormsSlugRespondIndexRoute: typeof FormsSlugRespondIndexRoute
}

const FormsSlugRespondRouteChildren: FormsSlugRespondRouteChildren = {
  FormsSlugRespondSuccessRoute: FormsSlugRespondSuccessRoute,
  FormsSlugRespondIndexRoute: FormsSlugRespondIndexRoute,
}

const FormsSlugRespondRouteWithChildren =
  FormsSlugRespondRoute._addFileChildren(FormsSlugRespondRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  BrandRoute: BrandRoute,
  ConnectorsRoute: ConnectorsRouteWithChildren,
  ContactRoute: ContactRoute,
  IndustriesRoute: IndustriesRoute,
  LoginRoute: LoginRoute,
  PortalRoute: PortalRouteWithChildren,
  PricingRoute: PricingRoute,
  ProofOfConceptRoute: ProofOfConceptRoute,
  ResourcesRoute: ResourcesRoute,
  SolutionsRoute: SolutionsRoute,
  StatusRoute: StatusRoute,
  VideosRoute: VideosRoute,
  ArchiveHomeRoute: ArchiveHomeRoute,
  ArchivePricingRoute: ArchivePricingRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  LegalDataProcessingRoute: LegalDataProcessingRoute,
  LegalPaiaRoute: LegalPaiaRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalRefundPolicyRoute: LegalRefundPolicyRoute,
  LegalTermsOfUseRoute: LegalTermsOfUseRoute,
  OauthConsentRoute: OauthConsentRoute,
  OnboardTokenRoute: OnboardTokenRoute,
  PortalForgotPasswordRoute: PortalForgotPasswordRoute,
  PortalHelpRoute: PortalHelpRoute,
  PortalResetPasswordRoute: PortalResetPasswordRoute,
  PortalSignInRoute: PortalSignInRoute,
  PortalSignUpRoute: PortalSignUpRoute,
  PreviewConnectorFlowsRoute: PreviewConnectorFlowsRoute,
  PreviewGroundUpFlowRoute: PreviewGroundUpFlowRoute,
  PreviewHomeHeroRoute: PreviewHomeHeroRoute,
  PreviewKbHeroesRoute: PreviewKbHeroesRoute,
  PreviewMyappTableTypesRoute: PreviewMyappTableTypesRoute,
  ProductsKnowledgeBaseRoute: ProductsKnowledgeBaseRoute,
  ProductsMyappRoute: ProductsMyappRoute,
  FormsSlugRespondRoute: FormsSlugRespondRouteWithChildren,
  PortalAuthUnlockAccountRoute: PortalAuthUnlockAccountRoute,
  PortalAuthVerifyEmailRoute: PortalAuthVerifyEmailRoute,
  PortalInviteAcceptRoute: PortalInviteAcceptRoute,
  PortalSignInVerifyRoute: PortalSignInVerifyRoute,
  ProductsMyappExcelAddinSetupRoute: ProductsMyappExcelAddinSetupRoute,
  PortalSpacesSpaceIdWidgetWidgetIdRoute:
    PortalSpacesSpaceIdWidgetWidgetIdRoute,
  PortalAppsReportingCustomSlugWindowRoute:
    PortalAppsReportingCustomSlugWindowRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
